export const COUNTRIES = [
  { name: 'United States', abbreviation: 'USA' },
  { name: 'Canada', abbreviation: 'CAN' },
  { name: 'Afghanistan', abbreviation: 'AFG' },
  { name: 'Åland Islands', abbreviation: 'ALA' },
  { name: 'Albania', abbreviation: 'ALB' },
  { name: 'Algeria', abbreviation: 'DZA' },
  { name: 'American Samoa', abbreviation: 'ASM' },
  { name: 'Andorra', abbreviation: 'AND' },
  { name: 'Angola', abbreviation: 'AGO' },
  { name: 'Anguilla', abbreviation: 'AIA' },
  { name: 'Antarctica', abbreviation: 'ATA' },
  { name: 'Antigua and Barbuda', abbreviation: 'ATG' },
  { name: 'Argentina', abbreviation: 'ARG' },
  { name: 'Armenia', abbreviation: 'ARM' },
  { name: 'Aruba', abbreviation: 'ABW' },
  { name: 'Australia', abbreviation: 'AUS' },
  { name: 'Austria', abbreviation: 'AUT' },
  { name: 'Azerbaijan', abbreviation: 'AZE' },
  { name: 'Bahamas', abbreviation: 'BHS' },
  { name: 'Bahrain', abbreviation: 'BHR' },
  { name: 'Bangladesh', abbreviation: 'BGD' },
  { name: 'Barbados', abbreviation: 'BRB' },
  { name: 'Belarus', abbreviation: 'BLR' },
  { name: 'Belgium', abbreviation: 'BEL' },
  { name: 'Belize', abbreviation: 'BLZ' },
  { name: 'Benin', abbreviation: 'BEN' },
  { name: 'Bermuda', abbreviation: 'BMU' },
  { name: 'Bhutan', abbreviation: 'BTN' },
  { name: 'Bolivia, Plurinational State of', abbreviation: 'BOL' },
  { name: 'Bonaire, Sint Eustatius and Saba', abbreviation: 'BES' },
  { name: 'Bosnia and Herzegovina', abbreviation: 'BIH' },
  { name: 'Botswana', abbreviation: 'BWA' },
  { name: 'Bouvet Island', abbreviation: 'BVT' },
  { name: 'Brazil', abbreviation: 'BRA' },
  { name: 'British Indian Ocean Territory', abbreviation: 'IOT' },
  { name: 'Brunei Darussalam', abbreviation: 'BRN' },
  { name: 'Bulgaria', abbreviation: 'BGR' },
  { name: 'Burkina Faso', abbreviation: 'BFA' },
  { name: 'Burundi', abbreviation: 'BDI' },
  { name: 'Cabo Verde', abbreviation: 'CPV' },
  { name: 'Cambodia', abbreviation: 'KHM' },
  { name: 'Cameroon', abbreviation: 'CMR' },
  { name: 'Canada', abbreviation: 'CAN' },
  { name: 'Cayman Islands', abbreviation: 'CYM' },
  { name: 'Central African Republic', abbreviation: 'CAF' },
  { name: 'Chad', abbreviation: 'TCD' },
  { name: 'Chile', abbreviation: 'CHL' },
  { name: 'China', abbreviation: 'CHN' },
  { name: 'Christmas Island', abbreviation: 'CXR' },
  { name: 'Cocos (Keeling) Islands', abbreviation: 'CCK' },
  { name: 'Colombia', abbreviation: 'COL' },
  { name: 'Comoros', abbreviation: 'COM' },
  { name: 'Congo, The Democratic Republic of the', abbreviation: 'COD' },
  { name: 'Congo', abbreviation: 'COG' },
  { name: 'Cook Islands', abbreviation: 'COK' },
  { name: 'Costa Rica', abbreviation: 'CRI' },
  { name: "Côte d'Ivoire", abbreviation: 'CIV' },
  { name: 'Croatia', abbreviation: 'HRV' },
  { name: 'Cuba', abbreviation: 'CUB' },
  { name: 'Curaçao', abbreviation: 'CUW' },
  { name: 'Cyprus', abbreviation: 'CYP' },
  { name: 'Czechia', abbreviation: 'CZE' },
  { name: 'Denmark', abbreviation: 'DNK' },
  { name: 'Djibouti', abbreviation: 'DJI' },
  { name: 'Dominica', abbreviation: 'DMA' },
  { name: 'Dominican Republic', abbreviation: 'DOM' },
  { name: 'Ecuador', abbreviation: 'ECU' },
  { name: 'Egypt', abbreviation: 'EGY' },
  { name: 'El Salvador', abbreviation: 'SLV' },
  { name: 'Equatorial Guinea', abbreviation: 'GNQ' },
  { name: 'Eritrea', abbreviation: 'ERI' },
  { name: 'Estonia', abbreviation: 'EST' },
  { name: 'Eswatini', abbreviation: 'SWZ' },
  { name: 'Ethiopia', abbreviation: 'ETH' },
  { name: 'Falkland Islands (Malvinas)', abbreviation: 'FLK' },
  { name: 'Faroe Islands', abbreviation: 'FRO' },
  { name: 'Fiji', abbreviation: 'FJI' },
  { name: 'Finland', abbreviation: 'FIN' },
  { name: 'France', abbreviation: 'FRA' },
  { name: 'French Guiana', abbreviation: 'GUF' },
  { name: 'French Polynesia', abbreviation: 'PYF' },
  { name: 'French Southern Territories', abbreviation: 'ATF' },
  { name: 'Gabon', abbreviation: 'GAB' },
  { name: 'Gambia', abbreviation: 'GMB' },
  { name: 'Georgia', abbreviation: 'GEO' },
  { name: 'Germany', abbreviation: 'DEU' },
  { name: 'Ghana', abbreviation: 'GHA' },
  { name: 'Gibraltar', abbreviation: 'GIB' },
  { name: 'Greece', abbreviation: 'GRC' },
  { name: 'Greenland', abbreviation: 'GRL' },
  { name: 'Grenada', abbreviation: 'GRD' },
  { name: 'Guadeloupe', abbreviation: 'GLP' },
  { name: 'Guam', abbreviation: 'GUM' },
  { name: 'Guatemala', abbreviation: 'GTM' },
  { name: 'Guernsey', abbreviation: 'GGY' },
  { name: 'Guinea-Bissau', abbreviation: 'GNB' },
  { name: 'Guinea', abbreviation: 'GIN' },
  { name: 'Guyana', abbreviation: 'GUY' },
  { name: 'Haiti', abbreviation: 'HTI' },
  { name: 'Heard Island and McDonald Islands', abbreviation: 'HMD' },
  { name: 'Holy See (Vatican City State)', abbreviation: 'VAT' },
  { name: 'Honduras', abbreviation: 'HND' },
  { name: 'Hong Kong', abbreviation: 'HKG' },
  { name: 'Hungary', abbreviation: 'HUN' },
  { name: 'Iceland', abbreviation: 'ISL' },
  { name: 'India', abbreviation: 'IND' },
  { name: 'Indonesia', abbreviation: 'IDN' },
  { name: 'Iran, Islamic Republic of', abbreviation: 'IRN' },
  { name: 'Iraq', abbreviation: 'IRQ' },
  { name: 'Ireland', abbreviation: 'IRL' },
  { name: 'Isle of Man', abbreviation: 'IMN' },
  { name: 'Israel', abbreviation: 'ISR' },
  { name: 'Italy', abbreviation: 'ITA' },
  { name: 'Jamaica', abbreviation: 'JAM' },
  { name: 'Japan', abbreviation: 'JPN' },
  { name: 'Jersey', abbreviation: 'JEY' },
  { name: 'Jordan', abbreviation: 'JOR' },
  { name: 'Kazakhstan', abbreviation: 'KAZ' },
  { name: 'Kenya', abbreviation: 'KEN' },
  { name: 'Kiribati', abbreviation: 'KIR' },
  { name: "Korea, Democratic People's Republic of", abbreviation: 'PRK' },
  { name: 'Korea, Republic of', abbreviation: 'KOR' },
  { name: 'Kuwait', abbreviation: 'KWT' },
  { name: 'Kyrgyzstan', abbreviation: 'KGZ' },
  { name: "Lao People's Democratic Republic", abbreviation: 'LAO' },
  { name: 'Latvia', abbreviation: 'LVA' },
  { name: 'Lebanon', abbreviation: 'LBN' },
  { name: 'Lesotho', abbreviation: 'LSO' },
  { name: 'Liberia', abbreviation: 'LBR' },
  { name: 'Libya', abbreviation: 'LBY' },
  { name: 'Liechtenstein', abbreviation: 'LIE' },
  { name: 'Lithuania', abbreviation: 'LTU' },
  { name: 'Luxembourg', abbreviation: 'LUX' },
  { name: 'Macao', abbreviation: 'MAC' },
  { name: 'Madagascar', abbreviation: 'MDG' },
  { name: 'Malawi', abbreviation: 'MWI' },
  { name: 'Malaysia', abbreviation: 'MYS' },
  { name: 'Maldives', abbreviation: 'MDV' },
  { name: 'Mali', abbreviation: 'MLI' },
  { name: 'Malta', abbreviation: 'MLT' },
  { name: 'Marshall Islands', abbreviation: 'MHL' },
  { name: 'Martinique', abbreviation: 'MTQ' },
  { name: 'Mauritania', abbreviation: 'MRT' },
  { name: 'Mauritius', abbreviation: 'MUS' },
  { name: 'Mayotte', abbreviation: 'MYT' },
  { name: 'Mexico', abbreviation: 'MEX' },
  { name: 'Micronesia, Federated States of', abbreviation: 'FSM' },
  { name: 'Moldova, Republic of', abbreviation: 'MDA' },
  { name: 'Monaco', abbreviation: 'MCO' },
  { name: 'Mongolia', abbreviation: 'MNG' },
  { name: 'Montenegro', abbreviation: 'MNE' },
  { name: 'Montserrat', abbreviation: 'MSR' },
  { name: 'Morocco', abbreviation: 'MAR' },
  { name: 'Mozambique', abbreviation: 'MOZ' },
  { name: 'Myanmar', abbreviation: 'MMR' },
  { name: 'Namibia', abbreviation: 'NAM' },
  { name: 'Nauru', abbreviation: 'NRU' },
  { name: 'Nepal', abbreviation: 'NPL' },
  { name: 'Netherlands', abbreviation: 'NLD' },
  { name: 'New Caledonia', abbreviation: 'NCL' },
  { name: 'New Zealand', abbreviation: 'NZL' },
  { name: 'Nicaragua', abbreviation: 'NIC' },
  { name: 'Niger', abbreviation: 'NER' },
  { name: 'Nigeria', abbreviation: 'NGA' },
  { name: 'Niue', abbreviation: 'NIU' },
  { name: 'Norfolk Island', abbreviation: 'NFK' },
  { name: 'North Macedonia', abbreviation: 'MKD' },
  { name: 'Northern Mariana Islands', abbreviation: 'MNP' },
  { name: 'Norway', abbreviation: 'NOR' },
  { name: 'Oman', abbreviation: 'OMN' },
  { name: 'Pakistan', abbreviation: 'PAK' },
  { name: 'Palau', abbreviation: 'PLW' },
  { name: 'Palestine, State of', abbreviation: 'PSE' },
  { name: 'Panama', abbreviation: 'PAN' },
  { name: 'Papua New Guinea', abbreviation: 'PNG' },
  { name: 'Paraguay', abbreviation: 'PRY' },
  { name: 'Peru', abbreviation: 'PER' },
  { name: 'Philippines', abbreviation: 'PHL' },
  { name: 'Pitcairn', abbreviation: 'PCN' },
  { name: 'Poland', abbreviation: 'POL' },
  { name: 'Portugal', abbreviation: 'PRT' },
  { name: 'Puerto Rico', abbreviation: 'PRI' },
  { name: 'Qatar', abbreviation: 'QAT' },
  { name: 'Réunion', abbreviation: 'REU' },
  { name: 'Romania', abbreviation: 'ROU' },
  { name: 'Russian Federation', abbreviation: 'RUS' },
  { name: 'Rwanda', abbreviation: 'RWA' },
  { name: 'Saint Barthélemy', abbreviation: 'BLM' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', abbreviation: 'SHN' },
  { name: 'Saint Kitts and Nevis', abbreviation: 'KNA' },
  { name: 'Saint Lucia', abbreviation: 'LCA' },
  { name: 'Saint Martin (French part)', abbreviation: 'MAF' },
  { name: 'Saint Pierre and Miquelon', abbreviation: 'SPM' },
  { name: 'Saint Vincent and the Grenadines', abbreviation: 'VCT' },
  { name: 'Samoa', abbreviation: 'WSM' },
  { name: 'San Marino', abbreviation: 'SMR' },
  { name: 'Sao Tome and Principe', abbreviation: 'STP' },
  { name: 'Saudi Arabia', abbreviation: 'SAU' },
  { name: 'Senegal', abbreviation: 'SEN' },
  { name: 'Serbia', abbreviation: 'SRB' },
  { name: 'Seychelles', abbreviation: 'SYC' },
  { name: 'Sierra Leone', abbreviation: 'SLE' },
  { name: 'Singapore', abbreviation: 'SGP' },
  { name: 'Sint Maarten (Dutch part)', abbreviation: 'SXM' },
  { name: 'Slovakia', abbreviation: 'SVK' },
  { name: 'Slovenia', abbreviation: 'SVN' },
  { name: 'Solomon Islands', abbreviation: 'SLB' },
  { name: 'Somalia', abbreviation: 'SOM' },
  { name: 'South Africa', abbreviation: 'ZAF' },
  { name: 'South Georgia and the South Sandwich Islands', abbreviation: 'SGS' },
  { name: 'South Sudan', abbreviation: 'SSD' },
  { name: 'Spain', abbreviation: 'ESP' },
  { name: 'Sri Lanka', abbreviation: 'LKA' },
  { name: 'Sudan', abbreviation: 'SDN' },
  { name: 'Suriname', abbreviation: 'SUR' },
  { name: 'Svalbard and Jan Mayen', abbreviation: 'SJM' },
  { name: 'Sweden', abbreviation: 'SWE' },
  { name: 'Switzerland', abbreviation: 'CHE' },
  { name: 'Syrian Arab Republic', abbreviation: 'SYR' },
  { name: 'Taiwan, Province of China', abbreviation: 'TWN' },
  { name: 'Tajikistan', abbreviation: 'TJK' },
  { name: 'Tanzania, United Republic of', abbreviation: 'TZA' },
  { name: 'Thailand', abbreviation: 'THA' },
  { name: 'Timor-Leste', abbreviation: 'TLS' },
  { name: 'Togo', abbreviation: 'TGO' },
  { name: 'Tokelau', abbreviation: 'TKL' },
  { name: 'Tonga', abbreviation: 'TON' },
  { name: 'Trinidad and Tobago', abbreviation: 'TTO' },
  { name: 'Tunisia', abbreviation: 'TUN' },
  { name: 'Turkey', abbreviation: 'TUR' },
  { name: 'Turkmenistan', abbreviation: 'TKM' },
  { name: 'Turks and Caicos Islands', abbreviation: 'TCA' },
  { name: 'Tuvalu', abbreviation: 'TUV' },
  { name: 'Uganda', abbreviation: 'UGA' },
  { name: 'Ukraine', abbreviation: 'UKR' },
  { name: 'United Arab Emirates', abbreviation: 'ARE' },
  { name: 'United Kingdom', abbreviation: 'GBR' },
  { name: 'United States Minor Outlying Islands', abbreviation: 'UMI' },
  { name: 'United States', abbreviation: 'USA' },
  { name: 'Uruguay', abbreviation: 'URY' },
  { name: 'Uzbekistan', abbreviation: 'UZB' },
  { name: 'Vanuatu', abbreviation: 'VUT' },
  { name: 'Venezuela, Bolivarian Republic of', abbreviation: 'VEN' },
  { name: 'Viet Nam', abbreviation: 'VNM' },
  { name: 'Virgin Islands, British', abbreviation: 'VGB' },
  { name: 'Virgin Islands, U.S.', abbreviation: 'VIR' },
  { name: 'Wallis and Futuna', abbreviation: 'WLF' },
  { name: 'Western Sahara', abbreviation: 'ESH' },
  { name: 'Yemen', abbreviation: 'YEM' },
  { name: 'Zambia', abbreviation: 'ZMB' },
  { name: 'Zimbabwe', abbreviation: 'ZWE' },
];

export const COUNTRY_REGIONS = {
  AFG: {
    regions: [
      { name: 'Balkh', abbreviation: 'BAL' },
      { name: 'Bāmyān', abbreviation: 'BAM' },
      { name: 'Bādghīs', abbreviation: 'BDG' },
      { name: 'Badakhshān', abbreviation: 'BDS' },
      { name: 'Baghlān', abbreviation: 'BGL' },
      { name: 'Dāykundī', abbreviation: 'DAY' },
      { name: 'Farāh', abbreviation: 'FRA' },
      { name: 'Fāryāb', abbreviation: 'FYB' },
      { name: 'Ghaznī', abbreviation: 'GHA' },
      { name: 'Ghōr', abbreviation: 'GHO' },
      { name: 'Helmand', abbreviation: 'HEL' },
      { name: 'Herāt', abbreviation: 'HER' },
      { name: 'Jowzjān', abbreviation: 'JOW' },
      { name: 'Kābul', abbreviation: 'KAB' },
      { name: 'Kandahār', abbreviation: 'KAN' },
      { name: 'Kāpīsā', abbreviation: 'KAP' },
      { name: 'Kunduz', abbreviation: 'KDZ' },
      { name: 'Khōst', abbreviation: 'KHO' },
      { name: 'Kunaṟ', abbreviation: 'KNR' },
      { name: 'Laghmān', abbreviation: 'LAG' },
      { name: 'Lōgar', abbreviation: 'LOG' },
      { name: 'Nangarhār', abbreviation: 'NAN' },
      { name: 'Nīmrōz', abbreviation: 'NIM' },
      { name: 'Nūristān', abbreviation: 'NUR' },
      { name: 'Panjshayr', abbreviation: 'PAN' },
      { name: 'Parwān', abbreviation: 'PAR' },
      { name: 'Paktiyā', abbreviation: 'PIA' },
      { name: 'Paktīkā', abbreviation: 'PKA' },
      { name: 'Samangān', abbreviation: 'SAM' },
      { name: 'Sar-e Pul', abbreviation: 'SAR' },
      { name: 'Takhār', abbreviation: 'TAK' },
      { name: 'Uruzgān', abbreviation: 'URU' },
      { name: 'Wardak', abbreviation: 'WAR' },
      { name: 'Zābul', abbreviation: 'ZAB' },
    ],
  },
  AGO: {
    regions: [
      { name: 'Bengo', abbreviation: 'BGO' },
      { name: 'Benguela', abbreviation: 'BGU' },
      { name: 'Bié', abbreviation: 'BIE' },
      { name: 'Cabinda', abbreviation: 'CAB' },
      { name: 'Kuando Kubango', abbreviation: 'CCU' },
      { name: 'Cunene', abbreviation: 'CNN' },
      { name: 'Kwanza Norte', abbreviation: 'CNO' },
      { name: 'Kwanza Sul', abbreviation: 'CUS' },
      { name: 'Huambo', abbreviation: 'HUA' },
      { name: 'Huíla', abbreviation: 'HUI' },
      { name: 'Lunda Norte', abbreviation: 'LNO' },
      { name: 'Lunda Sul', abbreviation: 'LSU' },
      { name: 'Luanda', abbreviation: 'LUA' },
      { name: 'Malange', abbreviation: 'MAL' },
      { name: 'Moxico', abbreviation: 'MOX' },
      { name: 'Namibe', abbreviation: 'NAM' },
      { name: 'Uíge', abbreviation: 'UIG' },
      { name: 'Zaire', abbreviation: 'ZAI' },
    ],
  },
  ALB: {
    regions: [
      { name: 'Berat', abbreviation: '01' },
      { name: 'Durrës', abbreviation: '02' },
      { name: 'Elbasan', abbreviation: '03' },
      { name: 'Fier', abbreviation: '04' },
      { name: 'Gjirokastër', abbreviation: '05' },
      { name: 'Korçë', abbreviation: '06' },
      { name: 'Kukës', abbreviation: '07' },
      { name: 'Lezhë', abbreviation: '08' },
      { name: 'Dibër', abbreviation: '09' },
      { name: 'Shkodër', abbreviation: '10' },
      { name: 'Tiranë', abbreviation: '11' },
      { name: 'Vlorë', abbreviation: '12' },
    ],
  },
  AND: {
    regions: [
      { name: 'Canillo', abbreviation: '02' },
      { name: 'Encamp', abbreviation: '03' },
      { name: 'La Massana', abbreviation: '04' },
      { name: 'Ordino', abbreviation: '05' },
      { name: 'Sant Julià de Lòria', abbreviation: '06' },
      { name: 'Andorra la Vella', abbreviation: '07' },
      { name: 'Escaldes-Engordany', abbreviation: '08' },
    ],
  },
  ARE: {
    regions: [
      { name: '‘Ajmān', abbreviation: 'AJ' },
      { name: 'Abū Z̧aby', abbreviation: 'AZ' },
      { name: 'Dubayy', abbreviation: 'DU' },
      { name: 'Al Fujayrah', abbreviation: 'FU' },
      { name: 'Ra’s al Khaymah', abbreviation: 'RK' },
      { name: 'Ash Shāriqah', abbreviation: 'SH' },
      { name: 'Umm al Qaywayn', abbreviation: 'UQ' },
    ],
  },
  ARG: {
    regions: [
      { name: 'Salta', abbreviation: 'A' },
      { name: 'Buenos Aires', abbreviation: 'B' },
      { name: 'San Luis', abbreviation: 'D' },
      { name: 'Entre Ríos', abbreviation: 'E' },
      { name: 'La Rioja', abbreviation: 'F' },
      { name: 'Santiago del Estero', abbreviation: 'G' },
      { name: 'Chaco', abbreviation: 'H' },
      { name: 'San Juan', abbreviation: 'J' },
      { name: 'Catamarca', abbreviation: 'K' },
      { name: 'La Pampa', abbreviation: 'L' },
      { name: 'Mendoza', abbreviation: 'M' },
      { name: 'Misiones', abbreviation: 'N' },
      { name: 'Formosa', abbreviation: 'P' },
      { name: 'Neuquén', abbreviation: 'Q' },
      { name: 'Río Negro', abbreviation: 'R' },
      { name: 'Santa Fe', abbreviation: 'S' },
      { name: 'Tucumán', abbreviation: 'T' },
      { name: 'Chubut', abbreviation: 'U' },
      { name: 'Tierra del Fuego', abbreviation: 'V' },
      { name: 'Corrientes', abbreviation: 'W' },
      { name: 'Córdoba', abbreviation: 'X' },
      { name: 'Jujuy', abbreviation: 'Y' },
      { name: 'Santa Cruz', abbreviation: 'Z' },
      { name: 'Ciudad Autónoma de Buenos Aires', abbreviation: 'C' },
    ],
  },
  ARM: {
    regions: [
      { name: 'Aragac̣otn', abbreviation: 'AG' },
      { name: 'Ararat', abbreviation: 'AR' },
      { name: 'Armavir', abbreviation: 'AV' },
      { name: "Geġark'unik'", abbreviation: 'GR' },
      { name: "Kotayk'", abbreviation: 'KT' },
      { name: 'Loṙi', abbreviation: 'LO' },
      { name: 'Širak', abbreviation: 'SH' },
      { name: "Syunik'", abbreviation: 'SU' },
      { name: 'Tavuš', abbreviation: 'TV' },
      { name: 'Vayoć Jor', abbreviation: 'VD' },
      { name: 'Erevan', abbreviation: 'ER' },
    ],
  },
  ATG: {
    regions: [
      { name: 'Barbuda', abbreviation: '10' },
      { name: 'Redonda', abbreviation: '11' },
      { name: 'Saint George', abbreviation: '03' },
      { name: 'Saint John', abbreviation: '04' },
      { name: 'Saint Mary', abbreviation: '05' },
      { name: 'Saint Paul', abbreviation: '06' },
      { name: 'Saint Peter', abbreviation: '07' },
      { name: 'Saint Philip', abbreviation: '08' },
    ],
  },
  AUS: {
    postalCodeLabel: 'Postcode',
    regionLabel: 'State',
    regions: [
      { name: 'Australian Capital Territory', abbreviation: 'ACT' },
      { name: 'New South Wales', abbreviation: 'NSW' },
      { name: 'Northern Territory', abbreviation: 'NT' },
      { name: 'Queensland', abbreviation: 'QLD' },
      { name: 'South Australia', abbreviation: 'SA' },
      { name: 'Tasmania', abbreviation: 'TAS' },
      { name: 'Victoria', abbreviation: 'VIC' },
      { name: 'Western Australia', abbreviation: 'WA' },
    ],
  },
  AUT: {
    regions: [
      { name: 'Burgenland', abbreviation: '1' },
      { name: 'Kärnten', abbreviation: '2' },
      { name: 'Niederösterreich', abbreviation: '3' },
      { name: 'Oberösterreich', abbreviation: '4' },
      { name: 'Salzburg', abbreviation: '5' },
      { name: 'Steiermark', abbreviation: '6' },
      { name: 'Tirol', abbreviation: '7' },
      { name: 'Vorarlberg', abbreviation: '8' },
      { name: 'Wien', abbreviation: '9' },
    ],
  },
  AZE: {
    regions: [
      { name: 'Bakı', abbreviation: 'BA' },
      { name: 'Gəncə', abbreviation: 'GA' },
      { name: 'Lənkəran', abbreviation: 'LA' },
      { name: 'Mingəçevir', abbreviation: 'MI' },
      { name: 'Naftalan', abbreviation: 'NA' },
      { name: 'Şəki', abbreviation: 'SA' },
      { name: 'Sumqayıt', abbreviation: 'SM' },
      { name: 'Şirvan', abbreviation: 'SR' },
      { name: 'Xankəndi', abbreviation: 'XA' },
      { name: 'Yevlax', abbreviation: 'YE' },
      { name: 'Abşeron', abbreviation: 'ABS' },
      { name: 'Ağstafa', abbreviation: 'AGA' },
      { name: 'Ağcabədi', abbreviation: 'AGC' },
      { name: 'Ağdam', abbreviation: 'AGM' },
      { name: 'Ağdaş', abbreviation: 'AGS' },
      { name: 'Ağsu', abbreviation: 'AGU' },
      { name: 'Astara', abbreviation: 'AST' },
      { name: 'Balakən', abbreviation: 'BAL' },
      { name: 'Bərdə', abbreviation: 'BAR' },
      { name: 'Beyləqan', abbreviation: 'BEY' },
      { name: 'Biləsuvar', abbreviation: 'BIL' },
      { name: 'Cəbrayıl', abbreviation: 'CAB' },
      { name: 'Cəlilabad', abbreviation: 'CAL' },
      { name: 'Daşkəsən', abbreviation: 'DAS' },
      { name: 'Füzuli', abbreviation: 'FUZ' },
      { name: 'Gədəbəy', abbreviation: 'GAD' },
      { name: 'Goranboy', abbreviation: 'GOR' },
      { name: 'Göyçay', abbreviation: 'GOY' },
      { name: 'Göygöl', abbreviation: 'GYG' },
      { name: 'Hacıqabul', abbreviation: 'HAC' },
      { name: 'İmişli', abbreviation: 'IMI' },
      { name: 'İsmayıllı', abbreviation: 'ISM' },
      { name: 'Kəlbəcər', abbreviation: 'KAL' },
      { name: 'Kürdəmir', abbreviation: 'KUR' },
      { name: 'Laçın', abbreviation: 'LAC' },
      { name: 'Lənkəran', abbreviation: 'LAN' },
      { name: 'Lerik', abbreviation: 'LER' },
      { name: 'Masallı', abbreviation: 'MAS' },
      { name: 'Neftçala', abbreviation: 'NEF' },
      { name: 'Oğuz', abbreviation: 'OGU' },
      { name: 'Qəbələ', abbreviation: 'QAB' },
      { name: 'Qax', abbreviation: 'QAX' },
      { name: 'Qazax', abbreviation: 'QAZ' },
      { name: 'Quba', abbreviation: 'QBA' },
      { name: 'Qubadlı', abbreviation: 'QBI' },
      { name: 'Qobustan', abbreviation: 'QOB' },
      { name: 'Qusar', abbreviation: 'QUS' },
      { name: 'Sabirabad', abbreviation: 'SAB' },
      { name: 'Şəki', abbreviation: 'SAK' },
      { name: 'Salyan', abbreviation: 'SAL' },
      { name: 'Saatlı', abbreviation: 'SAT' },
      { name: 'Şabran', abbreviation: 'SBN' },
      { name: 'Siyəzən', abbreviation: 'SIY' },
      { name: 'Şəmkir', abbreviation: 'SKR' },
      { name: 'Şamaxı', abbreviation: 'SMI' },
      { name: 'Samux', abbreviation: 'SMX' },
      { name: 'Şuşa', abbreviation: 'SUS' },
      { name: 'Tərtər', abbreviation: 'TAR' },
      { name: 'Tovuz', abbreviation: 'TOV' },
      { name: 'Ucar', abbreviation: 'UCA' },
      { name: 'Xaçmaz', abbreviation: 'XAC' },
      { name: 'Xocalı', abbreviation: 'XCI' },
      { name: 'Xızı', abbreviation: 'XIZ' },
      { name: 'Xocavənd', abbreviation: 'XVD' },
      { name: 'Yardımlı', abbreviation: 'YAR' },
      { name: 'Yevlax', abbreviation: 'YEV' },
      { name: 'Zəngilan', abbreviation: 'ZAN' },
      { name: 'Zaqatala', abbreviation: 'ZAQ' },
      { name: 'Zərdab', abbreviation: 'ZAR' },
      { name: 'Naxçıvan', abbreviation: 'NX' },
      { name: 'Naxçıvan', abbreviation: 'NV' },
      { name: 'Babək', abbreviation: 'BAB' },
      { name: 'Culfa', abbreviation: 'CUL' },
      { name: 'Kǝngǝrli', abbreviation: 'KAN' },
      { name: 'Ordubad', abbreviation: 'ORD' },
      { name: 'Sədərək', abbreviation: 'SAD' },
      { name: 'Şahbuz', abbreviation: 'SAH' },
      { name: 'Şərur', abbreviation: 'SAR' },
    ],
  },
  BDI: {
    regions: [
      { name: 'Bubanza', abbreviation: 'BB' },
      { name: 'Bujumbura Rural', abbreviation: 'BL' },
      { name: 'Bujumbura Mairie', abbreviation: 'BM' },
      { name: 'Bururi', abbreviation: 'BR' },
      { name: 'Cankuzo', abbreviation: 'CA' },
      { name: 'Cibitoke', abbreviation: 'CI' },
      { name: 'Gitega', abbreviation: 'GI' },
      { name: 'Kirundo', abbreviation: 'KI' },
      { name: 'Karuzi', abbreviation: 'KR' },
      { name: 'Kayanza', abbreviation: 'KY' },
      { name: 'Makamba', abbreviation: 'MA' },
      { name: 'Muramvya', abbreviation: 'MU' },
      { name: 'Mwaro', abbreviation: 'MW' },
      { name: 'Muyinga', abbreviation: 'MY' },
      { name: 'Ngozi', abbreviation: 'NG' },
      { name: 'Rumonge', abbreviation: 'RM' },
      { name: 'Rutana', abbreviation: 'RT' },
      { name: 'Ruyigi', abbreviation: 'RY' },
    ],
  },
  BEL: {
    regions: [
      { name: 'Bruxelles-Capitale, Région de', abbreviation: 'BRU' },
      { name: 'Vlaams Gewest', abbreviation: 'VLG' },
      { name: 'Antwerpen', abbreviation: 'VAN' },
      { name: 'Vlaams-Brabant', abbreviation: 'VBR' },
      { name: 'Limburg', abbreviation: 'VLI' },
      { name: 'Oost-Vlaanderen', abbreviation: 'VOV' },
      { name: 'West-Vlaanderen', abbreviation: 'VWV' },
      { name: 'wallonne, Région', abbreviation: 'WAL' },
      { name: 'Brabant wallon', abbreviation: 'WBR' },
      { name: 'Hainaut', abbreviation: 'WHT' },
      { name: 'Liège', abbreviation: 'WLG' },
      { name: 'Luxembourg', abbreviation: 'WLX' },
      { name: 'Namur', abbreviation: 'WNA' },
    ],
  },
  BEN: {
    regions: [
      { name: 'Atacora', abbreviation: 'AK' },
      { name: 'Alibori', abbreviation: 'AL' },
      { name: 'Atlantique', abbreviation: 'AQ' },
      { name: 'Borgou', abbreviation: 'BO' },
      { name: 'Collines', abbreviation: 'CO' },
      { name: 'Donga', abbreviation: 'DO' },
      { name: 'Couffo', abbreviation: 'KO' },
      { name: 'Littoral', abbreviation: 'LI' },
      { name: 'Mono', abbreviation: 'MO' },
      { name: 'Ouémé', abbreviation: 'OU' },
      { name: 'Plateau', abbreviation: 'PL' },
      { name: 'Zou', abbreviation: 'ZO' },
    ],
  },
  BES: {
    regions: [
      { name: 'Bonaire', abbreviation: 'BO' },
      { name: 'Saba', abbreviation: 'SA' },
      { name: 'Sint Eustatius', abbreviation: 'SE' },
    ],
  },
  BFA: {
    regions: [
      { name: 'Boucle du Mouhoun', abbreviation: '01' },
      { name: 'Balé', abbreviation: 'BAL' },
      { name: 'Banwa', abbreviation: 'BAN' },
      { name: 'Kossi', abbreviation: 'KOS' },
      { name: 'Mouhoun', abbreviation: 'MOU' },
      { name: 'Nayala', abbreviation: 'NAY' },
      { name: 'Sourou', abbreviation: 'SOR' },
      { name: 'Cascades', abbreviation: '02' },
      { name: 'Comoé', abbreviation: 'COM' },
      { name: 'Léraba', abbreviation: 'LER' },
      { name: 'Centre', abbreviation: '03' },
      { name: 'Kadiogo', abbreviation: 'KAD' },
      { name: 'Centre-Est', abbreviation: '04' },
      { name: 'Boulgou', abbreviation: 'BLG' },
      { name: 'Koulpélogo', abbreviation: 'KOP' },
      { name: 'Kouritenga', abbreviation: 'KOT' },
      { name: 'Centre-Nord', abbreviation: '05' },
      { name: 'Bam', abbreviation: 'BAM' },
      { name: 'Namentenga', abbreviation: 'NAM' },
      { name: 'Sanmatenga', abbreviation: 'SMT' },
      { name: 'Centre-Ouest', abbreviation: '06' },
      { name: 'Boulkiemdé', abbreviation: 'BLK' },
      { name: 'Sissili', abbreviation: 'SIS' },
      { name: 'Sanguié', abbreviation: 'SNG' },
      { name: 'Ziro', abbreviation: 'ZIR' },
      { name: 'Centre-Sud', abbreviation: '07' },
      { name: 'Bazèga', abbreviation: 'BAZ' },
      { name: 'Nahouri', abbreviation: 'NAO' },
      { name: 'Zoundwéogo', abbreviation: 'ZOU' },
      { name: 'Est', abbreviation: '08' },
      { name: 'Gnagna', abbreviation: 'GNA' },
      { name: 'Gourma', abbreviation: 'GOU' },
      { name: 'Komondjari', abbreviation: 'KMD' },
      { name: 'Kompienga', abbreviation: 'KMP' },
      { name: 'Tapoa', abbreviation: 'TAP' },
      { name: 'Hauts-Bassins', abbreviation: '09' },
      { name: 'Houet', abbreviation: 'HOU' },
      { name: 'Kénédougou', abbreviation: 'KEN' },
      { name: 'Tuy', abbreviation: 'TUI' },
      { name: 'Nord', abbreviation: '10' },
      { name: 'Loroum', abbreviation: 'LOR' },
      { name: 'Passoré', abbreviation: 'PAS' },
      { name: 'Yatenga', abbreviation: 'YAT' },
      { name: 'Zondoma', abbreviation: 'ZON' },
      { name: 'Plateau-Central', abbreviation: '11' },
      { name: 'Ganzourgou', abbreviation: 'GAN' },
      { name: 'Kourwéogo', abbreviation: 'KOW' },
      { name: 'Oubritenga', abbreviation: 'OUB' },
      { name: 'Sahel', abbreviation: '12' },
      { name: 'Oudalan', abbreviation: 'OUD' },
      { name: 'Séno', abbreviation: 'SEN' },
      { name: 'Soum', abbreviation: 'SOM' },
      { name: 'Yagha', abbreviation: 'YAG' },
      { name: 'Sud-Ouest', abbreviation: '13' },
      { name: 'Bougouriba', abbreviation: 'BGR' },
      { name: 'Ioba', abbreviation: 'IOB' },
      { name: 'Noumbiel', abbreviation: 'NOU' },
      { name: 'Poni', abbreviation: 'PON' },
    ],
  },
  BGD: {
    regions: [
      { name: 'Barisal', abbreviation: 'A' },
      { name: 'Barguna', abbreviation: '02' },
      { name: 'Barisal', abbreviation: '06' },
      { name: 'Bhola', abbreviation: '07' },
      { name: 'Jhalakathi', abbreviation: '25' },
      { name: 'Pirojpur', abbreviation: '50' },
      { name: 'Patuakhali', abbreviation: '51' },
      { name: 'Chittagong', abbreviation: 'B' },
      { name: 'Bandarban', abbreviation: '01' },
      { name: 'Brahmanbaria', abbreviation: '04' },
      { name: 'Comilla', abbreviation: '08' },
      { name: 'Chandpur', abbreviation: '09' },
      { name: 'Chittagong', abbreviation: '10' },
      { name: "Cox's Bazar", abbreviation: '11' },
      { name: 'Feni', abbreviation: '16' },
      { name: 'Khagrachhari', abbreviation: '29' },
      { name: 'Lakshmipur', abbreviation: '31' },
      { name: 'Noakhali', abbreviation: '47' },
      { name: 'Rangamati', abbreviation: '56' },
      { name: 'Dhaka', abbreviation: 'C' },
      { name: 'Dhaka', abbreviation: '13' },
      { name: 'Faridpur', abbreviation: '15' },
      { name: 'Gopalganj', abbreviation: '17' },
      { name: 'Gazipur', abbreviation: '18' },
      { name: 'Kishoreganj', abbreviation: '26' },
      { name: 'Manikganj', abbreviation: '33' },
      { name: 'Munshiganj', abbreviation: '35' },
      { name: 'Madaripur', abbreviation: '36' },
      { name: 'Narayanganj', abbreviation: '40' },
      { name: 'Narsingdi', abbreviation: '42' },
      { name: 'Rajbari', abbreviation: '53' },
      { name: 'Shariatpur', abbreviation: '62' },
      { name: 'Tangail', abbreviation: '63' },
      { name: 'Khulna', abbreviation: 'D' },
      { name: 'Bagerhat', abbreviation: '05' },
      { name: 'Chuadanga', abbreviation: '12' },
      { name: 'Jessore', abbreviation: '22' },
      { name: 'Jhenaidah', abbreviation: '23' },
      { name: 'Khulna', abbreviation: '27' },
      { name: 'Kushtia', abbreviation: '30' },
      { name: 'Magura', abbreviation: '37' },
      { name: 'Meherpur', abbreviation: '39' },
      { name: 'Narail', abbreviation: '43' },
      { name: 'Satkhira', abbreviation: '58' },
      { name: 'Rajshahi', abbreviation: 'E' },
      { name: 'Bogra', abbreviation: '03' },
      { name: 'Joypurhat', abbreviation: '24' },
      { name: 'Natore', abbreviation: '44' },
      { name: 'Chapai Nawabganj', abbreviation: '45' },
      { name: 'Naogaon', abbreviation: '48' },
      { name: 'Pabna', abbreviation: '49' },
      { name: 'Rajshahi', abbreviation: '54' },
      { name: 'Sirajganj', abbreviation: '59' },
      { name: 'Rangpur', abbreviation: 'F' },
      { name: 'Dinajpur', abbreviation: '14' },
      { name: 'Gaibandha', abbreviation: '19' },
      { name: 'Kurigram', abbreviation: '28' },
      { name: 'Lalmonirhat', abbreviation: '32' },
      { name: 'Nilphamari', abbreviation: '46' },
      { name: 'Panchagarh', abbreviation: '52' },
      { name: 'Rangpur', abbreviation: '55' },
      { name: 'Thakurgaon', abbreviation: '64' },
      { name: 'Sylhet', abbreviation: 'G' },
      { name: 'Habiganj', abbreviation: '20' },
      { name: 'Moulvibazar', abbreviation: '38' },
      { name: 'Sylhet', abbreviation: '60' },
      { name: 'Sunamganj', abbreviation: '61' },
      { name: 'Mymensingh', abbreviation: 'H' },
      { name: 'Jamalpur', abbreviation: '21' },
      { name: 'Mymensingh', abbreviation: '34' },
      { name: 'Netrakona', abbreviation: '41' },
      { name: 'Sherpur', abbreviation: '57' },
    ],
  },
  BGR: {
    regions: [
      { name: 'Blagoevgrad', abbreviation: '01' },
      { name: 'Burgas', abbreviation: '02' },
      { name: 'Varna', abbreviation: '03' },
      { name: 'Veliko Tarnovo', abbreviation: '04' },
      { name: 'Vidin', abbreviation: '05' },
      { name: 'Vratsa', abbreviation: '06' },
      { name: 'Gabrovo', abbreviation: '07' },
      { name: 'Dobrich', abbreviation: '08' },
      { name: 'Kardzhali', abbreviation: '09' },
      { name: 'Kyustendil', abbreviation: '10' },
      { name: 'Lovech', abbreviation: '11' },
      { name: 'Montana', abbreviation: '12' },
      { name: 'Pazardzhik', abbreviation: '13' },
      { name: 'Pernik', abbreviation: '14' },
      { name: 'Pleven', abbreviation: '15' },
      { name: 'Plovdiv', abbreviation: '16' },
      { name: 'Razgrad', abbreviation: '17' },
      { name: 'Ruse', abbreviation: '18' },
      { name: 'Silistra', abbreviation: '19' },
      { name: 'Sliven', abbreviation: '20' },
      { name: 'Smolyan', abbreviation: '21' },
      { name: 'Sofia (stolitsa)', abbreviation: '22' },
      { name: 'Sofia', abbreviation: '23' },
      { name: 'Stara Zagora', abbreviation: '24' },
      { name: 'Targovishte', abbreviation: '25' },
      { name: 'Haskovo', abbreviation: '26' },
      { name: 'Shumen', abbreviation: '27' },
      { name: 'Yambol', abbreviation: '28' },
    ],
  },
  BHR: {
    regions: [
      { name: 'Al ‘Āşimah', abbreviation: '13' },
      { name: 'Al Janūbīyah', abbreviation: '14' },
      { name: 'Al Muḩarraq', abbreviation: '15' },
      { name: 'Ash Shamālīyah', abbreviation: '17' },
    ],
  },
  BHS: {
    regions: [
      { name: 'Acklins', abbreviation: 'AK' },
      { name: 'Bimini', abbreviation: 'BI' },
      { name: 'Black Point', abbreviation: 'BP' },
      { name: 'Berry Islands', abbreviation: 'BY' },
      { name: 'Central Eleuthera', abbreviation: 'CE' },
      { name: 'Cat Island', abbreviation: 'CI' },
      { name: 'Crooked Island and Long Cay', abbreviation: 'CK' },
      { name: 'Central Abaco', abbreviation: 'CO' },
      { name: 'Central Andros', abbreviation: 'CS' },
      { name: 'East Grand Bahama', abbreviation: 'EG' },
      { name: 'Exuma', abbreviation: 'EX' },
      { name: 'City of Freeport', abbreviation: 'FP' },
      { name: 'Grand Cay', abbreviation: 'GC' },
      { name: 'Harbour Island', abbreviation: 'HI' },
      { name: 'Hope Town', abbreviation: 'HT' },
      { name: 'Inagua', abbreviation: 'IN' },
      { name: 'Long Island', abbreviation: 'LI' },
      { name: 'Mangrove Cay', abbreviation: 'MC' },
      { name: 'Mayaguana', abbreviation: 'MG' },
      { name: "Moore's Island", abbreviation: 'MI' },
      { name: 'North Eleuthera', abbreviation: 'NE' },
      { name: 'North Abaco', abbreviation: 'NO' },
      { name: 'North Andros', abbreviation: 'NS' },
      { name: 'Rum Cay', abbreviation: 'RC' },
      { name: 'Ragged Island', abbreviation: 'RI' },
      { name: 'South Andros', abbreviation: 'SA' },
      { name: 'South Eleuthera', abbreviation: 'SE' },
      { name: 'South Abaco', abbreviation: 'SO' },
      { name: 'San Salvador', abbreviation: 'SS' },
      { name: 'Spanish Wells', abbreviation: 'SW' },
      { name: 'West Grand Bahama', abbreviation: 'WG' },
      { name: 'New Providence', abbreviation: 'NP' },
    ],
  },
  BIH: {
    regions: [
      { name: 'Federacija Bosne i Hercegovine', abbreviation: 'BIH' },
      { name: 'Republika Srpska', abbreviation: 'SRP' },
      { name: 'Brčko distrikt', abbreviation: 'BRC' },
    ],
  },
  BLR: {
    regions: [
      { name: 'Horad Minsk', abbreviation: 'HM' },
      { name: 'Bresckaja voblasć', abbreviation: 'BR' },
      { name: 'Homieĺskaja voblasć', abbreviation: 'HO' },
      { name: "Hrodzenskaya voblasts'", abbreviation: 'HR' },
      { name: 'Mahilioŭskaja voblasć', abbreviation: 'MA' },
      { name: 'Minskaja voblasć', abbreviation: 'MI' },
      { name: 'Viciebskaja voblasć', abbreviation: 'VI' },
    ],
  },
  BLZ: {
    regions: [
      { name: 'Belize', abbreviation: 'BZ' },
      { name: 'Cayo', abbreviation: 'CY' },
      { name: 'Corozal', abbreviation: 'CZL' },
      { name: 'Orange Walk', abbreviation: 'OW' },
      { name: 'Stann Creek', abbreviation: 'SC' },
      { name: 'Toledo', abbreviation: 'TOL' },
    ],
  },
  BOL: {
    regions: [
      { name: 'El Beni', abbreviation: 'B' },
      { name: 'Cochabamba', abbreviation: 'C' },
      { name: 'Chuquisaca', abbreviation: 'H' },
      { name: 'La Paz', abbreviation: 'L' },
      { name: 'Pando', abbreviation: 'N' },
      { name: 'Oruro', abbreviation: 'O' },
      { name: 'Potosí', abbreviation: 'P' },
      { name: 'Santa Cruz', abbreviation: 'S' },
      { name: 'Tarija', abbreviation: 'T' },
    ],
  },
  BRA: {
    postalCodeLabel: 'Postal Code',
    regionLabel: 'State',
    regions: [
      { name: 'Acre', abbreviation: 'AC' },
      { name: 'Alagoas', abbreviation: 'AL' },
      { name: 'Amapá', abbreviation: 'AP' },
      { name: 'Amazonas', abbreviation: 'AM' },
      { name: 'Bahia', abbreviation: 'BA' },
      { name: 'Ceará', abbreviation: 'CE' },
      { name: 'Distrito Federal', abbreviation: 'DF' },
      { name: 'Espírito Santo', abbreviation: 'ES' },
      { name: 'Fernando de Noronha', abbreviation: 'FN' },
      { name: 'Goiás', abbreviation: 'GO' },
      { name: 'Maranhão', abbreviation: 'MA' },
      { name: 'Mato Grosso do Sul', abbreviation: 'MS' },
      { name: 'Mato Grosso', abbreviation: 'MT' },
      { name: 'Minas Gerais', abbreviation: 'MG' },
      { name: 'Pará', abbreviation: 'PA' },
      { name: 'Paraíba', abbreviation: 'PB' },
      { name: 'Paraná', abbreviation: 'PR' },
      { name: 'Pernambuco', abbreviation: 'PE' },
      { name: 'Piauí', abbreviation: 'PI' },
      { name: 'Rio de Janeiro', abbreviation: 'RJ' },
      { name: 'Rio Grande do Norte', abbreviation: 'RN' },
      { name: 'Rio Grande do Sul', abbreviation: 'RS' },
      { name: 'Rondônia', abbreviation: 'RO' },
      { name: 'Roraima', abbreviation: 'RR' },
      { name: 'Santa Catarina', abbreviation: 'SC' },
      { name: 'São Paulo', abbreviation: 'SP' },
      { name: 'Sergipe', abbreviation: 'SE' },
      { name: 'Tocantins', abbreviation: 'TO' },
    ],
  },
  BRB: {
    regions: [
      { name: 'Christ Church', abbreviation: '01' },
      { name: 'Saint Andrew', abbreviation: '02' },
      { name: 'Saint George', abbreviation: '03' },
      { name: 'Saint James', abbreviation: '04' },
      { name: 'Saint John', abbreviation: '05' },
      { name: 'Saint Joseph', abbreviation: '06' },
      { name: 'Saint Lucy', abbreviation: '07' },
      { name: 'Saint Michael', abbreviation: '08' },
      { name: 'Saint Peter', abbreviation: '09' },
      { name: 'Saint Philip', abbreviation: '10' },
      { name: 'Saint Thomas', abbreviation: '11' },
    ],
  },
  BRN: {
    regions: [
      { name: 'Belait', abbreviation: 'BE' },
      { name: 'Brunei-Muara', abbreviation: 'BM' },
      { name: 'Temburong', abbreviation: 'TE' },
      { name: 'Tutong', abbreviation: 'TU' },
    ],
  },
  BTN: {
    regions: [
      { name: 'Paro', abbreviation: '11' },
      { name: 'Chhukha', abbreviation: '12' },
      { name: 'Haa', abbreviation: '13' },
      { name: 'Samtse', abbreviation: '14' },
      { name: 'Thimphu', abbreviation: '15' },
      { name: 'Tsirang', abbreviation: '21' },
      { name: 'Dagana', abbreviation: '22' },
      { name: 'Punakha', abbreviation: '23' },
      { name: 'Wangdue Phodrang', abbreviation: '24' },
      { name: 'Sarpang', abbreviation: '31' },
      { name: 'Trongsa', abbreviation: '32' },
      { name: 'Bumthang', abbreviation: '33' },
      { name: 'Zhemgang', abbreviation: '34' },
      { name: 'Trashigang', abbreviation: '41' },
      { name: 'Monggar', abbreviation: '42' },
      { name: 'Pemagatshel', abbreviation: '43' },
      { name: 'Lhuentse', abbreviation: '44' },
      { name: 'Samdrup Jongkhar', abbreviation: '45' },
      { name: 'Gasa', abbreviation: 'GA' },
      { name: 'Trashi Yangtse', abbreviation: 'TY' },
    ],
  },
  BWA: {
    regions: [
      { name: 'Central', abbreviation: 'CE' },
      { name: 'Chobe', abbreviation: 'CH' },
      { name: 'Ghanzi', abbreviation: 'GH' },
      { name: 'Kgalagadi', abbreviation: 'KG' },
      { name: 'Kgatleng', abbreviation: 'KL' },
      { name: 'Kweneng', abbreviation: 'KW' },
      { name: 'North East', abbreviation: 'NE' },
      { name: 'North West', abbreviation: 'NW' },
      { name: 'South East', abbreviation: 'SE' },
      { name: 'Southern', abbreviation: 'SO' },
      { name: 'Jwaneng', abbreviation: 'JW' },
      { name: 'Lobatse', abbreviation: 'LO' },
      { name: 'Selibe Phikwe', abbreviation: 'SP' },
      { name: 'Sowa Town', abbreviation: 'ST' },
      { name: 'Francistown', abbreviation: 'FR' },
      { name: 'Gaborone', abbreviation: 'GA' },
    ],
  },
  CAF: {
    regions: [
      { name: 'Gribingui', abbreviation: 'KB' },
      { name: 'Sangha', abbreviation: 'SE' },
      { name: 'Ouham', abbreviation: 'AC' },
      { name: 'Bamingui-Bangoran', abbreviation: 'BB' },
      { name: 'Basse-Kotto', abbreviation: 'BK' },
      { name: 'Haute-Kotto', abbreviation: 'HK' },
      { name: 'Haut-Mbomou', abbreviation: 'HM' },
      { name: 'Haute-Sangha / Mambéré-Kadéï', abbreviation: 'HS' },
      { name: 'Kémo-Gribingui', abbreviation: 'KG' },
      { name: 'Lobaye', abbreviation: 'LB' },
      { name: 'Mbomou', abbreviation: 'MB' },
      { name: 'Ombella-Mpoko', abbreviation: 'MP' },
      { name: 'Nana-Mambéré', abbreviation: 'NM' },
      { name: 'Ouham-Pendé', abbreviation: 'OP' },
      { name: 'Ouaka', abbreviation: 'UK' },
      { name: 'Vakaga', abbreviation: 'VK' },
      { name: 'Bangui', abbreviation: 'BGF' },
    ],
  },
  CAN: {
    postalCodeLabel: 'Postal Code',
    regionLabel: 'Province',
    regions: [
      { name: 'Alberta', abbreviation: 'AB' },
      { name: 'British Columbia', abbreviation: 'BC' },
      { name: 'Manitoba', abbreviation: 'MB' },
      { name: 'New Brunswick', abbreviation: 'NB' },
      { name: 'Newfoundland and Labrador', abbreviation: 'NL' },
      { name: 'Nova Scotia', abbreviation: 'NS' },
      { name: 'Ontario', abbreviation: 'ON' },
      { name: 'Prince Edward Island', abbreviation: 'PE' },
      { name: 'Quebec', abbreviation: 'QC' },
      { name: 'Saskatchewan', abbreviation: 'SK' },
    ],
  },
  CHE: {
    regions: [
      { name: 'Aargau', abbreviation: 'AG' },
      { name: 'Appenzell Innerrhoden', abbreviation: 'AI' },
      { name: 'Appenzell Ausserrhoden', abbreviation: 'AR' },
      { name: 'Bern', abbreviation: 'BE' },
      { name: 'Basel-Landschaft', abbreviation: 'BL' },
      { name: 'Basel-Stadt', abbreviation: 'BS' },
      { name: 'Freiburg', abbreviation: 'FR' },
      { name: 'Genève', abbreviation: 'GE' },
      { name: 'Glarus', abbreviation: 'GL' },
      { name: 'Graubünden', abbreviation: 'GR' },
      { name: 'Jura', abbreviation: 'JU' },
      { name: 'Luzern', abbreviation: 'LU' },
      { name: 'Neuchâtel', abbreviation: 'NE' },
      { name: 'Nidwalden', abbreviation: 'NW' },
      { name: 'Obwalden', abbreviation: 'OW' },
      { name: 'Sankt Gallen', abbreviation: 'SG' },
      { name: 'Schaffhausen', abbreviation: 'SH' },
      { name: 'Solothurn', abbreviation: 'SO' },
      { name: 'Schwyz', abbreviation: 'SZ' },
      { name: 'Thurgau', abbreviation: 'TG' },
      { name: 'Ticino', abbreviation: 'TI' },
      { name: 'Uri', abbreviation: 'UR' },
      { name: 'Vaud', abbreviation: 'VD' },
      { name: 'Wallis', abbreviation: 'VS' },
      { name: 'Zug', abbreviation: 'ZG' },
      { name: 'Zürich', abbreviation: 'ZH' },
    ],
  },
  CHL: {
    regions: [
      { name: 'Aisén del General Carlos Ibañez del Campo', abbreviation: 'AI' },
      { name: 'Antofagasta', abbreviation: 'AN' },
      { name: 'Arica y Parinacota', abbreviation: 'AP' },
      { name: 'La Araucanía', abbreviation: 'AR' },
      { name: 'Atacama', abbreviation: 'AT' },
      { name: 'Biobío', abbreviation: 'BI' },
      { name: 'Coquimbo', abbreviation: 'CO' },
      { name: "Libertador General Bernardo O'Higgins", abbreviation: 'LI' },
      { name: 'Los Lagos', abbreviation: 'LL' },
      { name: 'Los Ríos', abbreviation: 'LR' },
      { name: 'Magallanes', abbreviation: 'MA' },
      { name: 'Maule', abbreviation: 'ML' },
      { name: 'Ñuble', abbreviation: 'NB' },
      { name: 'Región Metropolitana de Santiago', abbreviation: 'RM' },
      { name: 'Tarapacá', abbreviation: 'TA' },
      { name: 'Valparaíso', abbreviation: 'VS' },
    ],
  },
  CHN: {
    postalCodeLabel: 'Postal Code',
    regionLabel: 'Province',
    regions: [
      { name: 'Anhui Sheng', abbreviation: 'AH' },
      { name: 'Beijing Shi', abbreviation: 'BJ' },
      { name: 'Chongqing Shi', abbreviation: 'CQ' },
      { name: 'Fujian Sheng', abbreviation: 'FJ' },
      { name: 'Gansu Sheng', abbreviation: 'GS' },
      { name: 'Guangdong Sheng', abbreviation: 'GD' },
      { name: 'Guangxi Zhuangzu Zizhiqu', abbreviation: 'GX' },
      { name: 'Guizhou Sheng', abbreviation: 'GZ' },
      { name: 'Hainan Sheng', abbreviation: 'HI' },
      { name: 'Hebei Sheng', abbreviation: 'HE' },
      { name: 'Heilongjiang Sheng', abbreviation: 'HL' },
      { name: 'Henan Sheng', abbreviation: 'HA' },
      { name: 'Hong Kong SAR', abbreviation: 'HK' },
      { name: 'Hubei Sheng', abbreviation: 'HB' },
      { name: 'Hunan Sheng', abbreviation: 'HN' },
      { name: 'Jiangsu Sheng', abbreviation: 'JS' },
      { name: 'Jiangxi Sheng', abbreviation: 'JX' },
      { name: 'Jilin Sheng', abbreviation: 'JL' },
      { name: 'Liaoning Sheng', abbreviation: 'LN' },
      { name: 'Macao SAR', abbreviation: 'MO' },
      { name: 'Nei Mongol Zizhiqu', abbreviation: 'NM' },
      { name: 'Ningxia Huizi Zizhiqu', abbreviation: 'NX' },
      { name: 'Qinghai Sheng', abbreviation: 'QH' },
      { name: 'Shaanxi Sheng', abbreviation: 'SN' },
      { name: 'Shandong Sheng', abbreviation: 'SD' },
      { name: 'Shanghai Shi', abbreviation: 'SH' },
      { name: 'Shanxi Sheng', abbreviation: 'SX' },
      { name: 'Sichuan Sheng', abbreviation: 'SC' },
      { name: 'Taiwan Sheng', abbreviation: 'TW' },
      { name: 'Tianjin Shi', abbreviation: 'TJ' },
      { name: 'Xinjiang Uygur Zizhiqu', abbreviation: 'XJ' },
      { name: 'Xizang Zizhiqu', abbreviation: 'XZ' },
      { name: 'Yunnan Sheng', abbreviation: 'YN' },
      { name: 'Zhejiang Sheng', abbreviation: 'ZJ' },
    ],
  },
  CIV: {
    regions: [
      { name: 'Abidjan', abbreviation: 'AB' },
      { name: 'Yamoussoukro', abbreviation: 'YM' },
      { name: 'Bas-Sassandra', abbreviation: 'BS' },
      { name: 'Comoé', abbreviation: 'CM' },
      { name: 'Denguélé', abbreviation: 'DN' },
      { name: 'Gôh-Djiboua', abbreviation: 'GD' },
      { name: 'Lacs', abbreviation: 'LC' },
      { name: 'Lagunes', abbreviation: 'LG' },
      { name: 'Montagnes', abbreviation: 'MG' },
      { name: 'Sassandra-Marahoué', abbreviation: 'SM' },
      { name: 'Savanes', abbreviation: 'SV' },
      { name: 'Vallée du Bandama', abbreviation: 'VB' },
      { name: 'Woroba', abbreviation: 'WR' },
      { name: 'Zanzan', abbreviation: 'ZZ' },
    ],
  },
  CMR: {
    regions: [
      { name: 'Adamaoua', abbreviation: 'AD' },
      { name: 'Centre', abbreviation: 'CE' },
      { name: 'Far North', abbreviation: 'EN' },
      { name: 'East', abbreviation: 'ES' },
      { name: 'Littoral', abbreviation: 'LT' },
      { name: 'North', abbreviation: 'NO' },
      { name: 'North-West', abbreviation: 'NW' },
      { name: 'West', abbreviation: 'OU' },
      { name: 'South', abbreviation: 'SU' },
      { name: 'South-West', abbreviation: 'SW' },
    ],
  },
  COD: {
    regions: [
      { name: 'Kongo Central', abbreviation: 'BC' },
      { name: 'Bas-Uélé', abbreviation: 'BU' },
      { name: 'Équateur', abbreviation: 'EQ' },
      { name: 'Haut-Katanga', abbreviation: 'HK' },
      { name: 'Haut-Lomami', abbreviation: 'HL' },
      { name: 'Haut-Uélé', abbreviation: 'HU' },
      { name: 'Ituri', abbreviation: 'IT' },
      { name: 'Kasaï Central', abbreviation: 'KC' },
      { name: 'Kasaï Oriental', abbreviation: 'KE' },
      { name: 'Kwango', abbreviation: 'KG' },
      { name: 'Kwilu', abbreviation: 'KL' },
      { name: 'Kasaï', abbreviation: 'KS' },
      { name: 'Lomami', abbreviation: 'LO' },
      { name: 'Lualaba', abbreviation: 'LU' },
      { name: 'Maniema', abbreviation: 'MA' },
      { name: 'Mai-Ndombe', abbreviation: 'MN' },
      { name: 'Mongala', abbreviation: 'MO' },
      { name: 'Nord-Kivu', abbreviation: 'NK' },
      { name: 'Nord-Ubangi', abbreviation: 'NU' },
      { name: 'Sankuru', abbreviation: 'SA' },
      { name: 'Sud-Kivu', abbreviation: 'SK' },
      { name: 'Sud-Ubangi', abbreviation: 'SU' },
      { name: 'Tanganyika', abbreviation: 'TA' },
      { name: 'Tshopo', abbreviation: 'TO' },
      { name: 'Tshuapa', abbreviation: 'TU' },
      { name: 'Kinshasa', abbreviation: 'KN' },
    ],
  },
  COG: {
    regions: [
      { name: 'Bouenza', abbreviation: '11' },
      { name: 'Pool', abbreviation: '12' },
      { name: 'Sangha', abbreviation: '13' },
      { name: 'Plateaux', abbreviation: '14' },
      { name: 'Cuvette-Ouest', abbreviation: '15' },
      { name: 'Pointe-Noire', abbreviation: '16' },
      { name: 'Lékoumou', abbreviation: '2' },
      { name: 'Kouilou', abbreviation: '5' },
      { name: 'Likouala', abbreviation: '7' },
      { name: 'Cuvette', abbreviation: '8' },
      { name: 'Niari', abbreviation: '9' },
      { name: 'Brazzaville', abbreviation: 'BZV' },
    ],
  },
  COL: {
    regions: [
      { name: 'Amazonas', abbreviation: 'AMA' },
      { name: 'Antioquia', abbreviation: 'ANT' },
      { name: 'Arauca', abbreviation: 'ARA' },
      { name: 'Atlántico', abbreviation: 'ATL' },
      { name: 'Bolívar', abbreviation: 'BOL' },
      { name: 'Boyacá', abbreviation: 'BOY' },
      { name: 'Caldas', abbreviation: 'CAL' },
      { name: 'Caquetá', abbreviation: 'CAQ' },
      { name: 'Casanare', abbreviation: 'CAS' },
      { name: 'Cauca', abbreviation: 'CAU' },
      { name: 'Cesar', abbreviation: 'CES' },
      { name: 'Chocó', abbreviation: 'CHO' },
      { name: 'Córdoba', abbreviation: 'COR' },
      { name: 'Cundinamarca', abbreviation: 'CUN' },
      { name: 'Guainía', abbreviation: 'GUA' },
      { name: 'Guaviare', abbreviation: 'GUV' },
      { name: 'Huila', abbreviation: 'HUI' },
      { name: 'La Guajira', abbreviation: 'LAG' },
      { name: 'Magdalena', abbreviation: 'MAG' },
      { name: 'Meta', abbreviation: 'MET' },
      { name: 'Nariño', abbreviation: 'NAR' },
      { name: 'Norte de Santander', abbreviation: 'NSA' },
      { name: 'Putumayo', abbreviation: 'PUT' },
      { name: 'Quindío', abbreviation: 'QUI' },
      { name: 'Risaralda', abbreviation: 'RIS' },
      { name: 'Santander', abbreviation: 'SAN' },
      { name: 'San Andrés, Providencia y Santa Catalina', abbreviation: 'SAP' },
      { name: 'Sucre', abbreviation: 'SUC' },
      { name: 'Tolima', abbreviation: 'TOL' },
      { name: 'Valle del Cauca', abbreviation: 'VAC' },
      { name: 'Vaupés', abbreviation: 'VAU' },
      { name: 'Vichada', abbreviation: 'VID' },
      { name: 'Distrito Capital de Bogotá', abbreviation: 'DC' },
    ],
  },
  COM: {
    regions: [
      { name: 'Ndzuwani', abbreviation: 'A' },
      { name: 'Ngazidja', abbreviation: 'G' },
      { name: 'Mwali', abbreviation: 'M' },
    ],
  },
  CPV: {
    regions: [
      { name: 'Ilhas de Barlavento', abbreviation: 'B' },
      { name: 'Boa Vista', abbreviation: 'BV' },
      { name: 'Paul', abbreviation: 'PA' },
      { name: 'Porto Novo', abbreviation: 'PN' },
      { name: 'Ribeira Brava', abbreviation: 'RB' },
      { name: 'Ribeira Grande', abbreviation: 'RG' },
      { name: 'Sal', abbreviation: 'SL' },
      { name: 'São Vicente', abbreviation: 'SV' },
      { name: 'Tarrafal de São Nicolau', abbreviation: 'TS' },
      { name: 'Ilhas de Sotavento', abbreviation: 'S' },
      { name: 'Brava', abbreviation: 'BR' },
      { name: 'Santa Catarina', abbreviation: 'CA' },
      { name: 'Santa Catarina do Fogo', abbreviation: 'CF' },
      { name: 'Santa Cruz', abbreviation: 'CR' },
      { name: 'Maio', abbreviation: 'MA' },
      { name: 'Mosteiros', abbreviation: 'MO' },
      { name: 'Praia', abbreviation: 'PR' },
      { name: 'Ribeira Grande de Santiago', abbreviation: 'RS' },
      { name: 'São Domingos', abbreviation: 'SD' },
      { name: 'São Filipe', abbreviation: 'SF' },
      { name: 'São Miguel', abbreviation: 'SM' },
      { name: 'São Lourenço dos Órgãos', abbreviation: 'SO' },
      { name: 'São Salvador do Mundo', abbreviation: 'SS' },
      { name: 'Tarrafal', abbreviation: 'TA' },
    ],
  },
  CRI: {
    regions: [
      { name: 'Alajuela', abbreviation: 'A' },
      { name: 'Cartago', abbreviation: 'C' },
      { name: 'Guanacaste', abbreviation: 'G' },
      { name: 'Heredia', abbreviation: 'H' },
      { name: 'Limón', abbreviation: 'L' },
      { name: 'Puntarenas', abbreviation: 'P' },
      { name: 'San José', abbreviation: 'SJ' },
    ],
  },
  CUB: {
    regions: [
      { name: 'Pinar del Río', abbreviation: '01' },
      { name: 'La Habana', abbreviation: '03' },
      { name: 'Matanzas', abbreviation: '04' },
      { name: 'Villa Clara', abbreviation: '05' },
      { name: 'Cienfuegos', abbreviation: '06' },
      { name: 'Sancti Spíritus', abbreviation: '07' },
      { name: 'Ciego de Ávila', abbreviation: '08' },
      { name: 'Camagüey', abbreviation: '09' },
      { name: 'Las Tunas', abbreviation: '10' },
      { name: 'Holguín', abbreviation: '11' },
      { name: 'Granma', abbreviation: '12' },
      { name: 'Santiago de Cuba', abbreviation: '13' },
      { name: 'Guantánamo', abbreviation: '14' },
      { name: 'Artemisa', abbreviation: '15' },
      { name: 'Mayabeque', abbreviation: '16' },
      { name: 'Isla de la Juventud', abbreviation: '99' },
    ],
  },
  CYP: {
    regions: [
      { name: 'Lefkosia', abbreviation: '01' },
      { name: 'Lemesos', abbreviation: '02' },
      { name: 'Larnaka', abbreviation: '03' },
      { name: 'Ammochostos', abbreviation: '04' },
      { name: 'Pafos', abbreviation: '05' },
      { name: 'Keryneia', abbreviation: '06' },
    ],
  },
  CZE: {
    regions: [
      { name: 'Středočeský kraj', abbreviation: '20' },
      { name: 'Benešov', abbreviation: '201' },
      { name: 'Beroun', abbreviation: '202' },
      { name: 'Kladno', abbreviation: '203' },
      { name: 'Kolín', abbreviation: '204' },
      { name: 'Kutná Hora', abbreviation: '205' },
      { name: 'Mělník', abbreviation: '206' },
      { name: 'Mladá Boleslav', abbreviation: '207' },
      { name: 'Nymburk', abbreviation: '208' },
      { name: 'Praha-východ', abbreviation: '209' },
      { name: 'Praha-západ', abbreviation: '20A' },
      { name: 'Příbram', abbreviation: '20B' },
      { name: 'Rakovník', abbreviation: '20C' },
      { name: 'Jihočeský kraj', abbreviation: '31' },
      { name: 'České Budějovice', abbreviation: '311' },
      { name: 'Český Krumlov', abbreviation: '312' },
      { name: 'Jindřichův Hradec', abbreviation: '313' },
      { name: 'Písek', abbreviation: '314' },
      { name: 'Prachatice', abbreviation: '315' },
      { name: 'Strakonice', abbreviation: '316' },
      { name: 'Tábor', abbreviation: '317' },
      { name: 'Plzeňský kraj', abbreviation: '32' },
      { name: 'Domažlice', abbreviation: '321' },
      { name: 'Klatovy', abbreviation: '322' },
      { name: 'Plzeň-město', abbreviation: '323' },
      { name: 'Plzeň-jih', abbreviation: '324' },
      { name: 'Plzeň-sever', abbreviation: '325' },
      { name: 'Rokycany', abbreviation: '326' },
      { name: 'Tachov', abbreviation: '327' },
      { name: 'Karlovarský kraj', abbreviation: '41' },
      { name: 'Cheb', abbreviation: '411' },
      { name: 'Karlovy Vary', abbreviation: '412' },
      { name: 'Sokolov', abbreviation: '413' },
      { name: 'Ústecký kraj', abbreviation: '42' },
      { name: 'Děčín', abbreviation: '421' },
      { name: 'Chomutov', abbreviation: '422' },
      { name: 'Litoměřice', abbreviation: '423' },
      { name: 'Louny', abbreviation: '424' },
      { name: 'Most', abbreviation: '425' },
      { name: 'Teplice', abbreviation: '426' },
      { name: 'Ústí nad Labem', abbreviation: '427' },
      { name: 'Liberecký kraj', abbreviation: '51' },
      { name: 'Česká Lípa', abbreviation: '511' },
      { name: 'Jablonec nad Nisou', abbreviation: '512' },
      { name: 'Liberec', abbreviation: '513' },
      { name: 'Semily', abbreviation: '514' },
      { name: 'Královéhradecký kraj', abbreviation: '52' },
      { name: 'Hradec Králové', abbreviation: '521' },
      { name: 'Jičín', abbreviation: '522' },
      { name: 'Náchod', abbreviation: '523' },
      { name: 'Rychnov nad Kněžnou', abbreviation: '524' },
      { name: 'Trutnov', abbreviation: '525' },
      { name: 'Pardubický kraj', abbreviation: '53' },
      { name: 'Chrudim', abbreviation: '531' },
      { name: 'Pardubice', abbreviation: '532' },
      { name: 'Svitavy', abbreviation: '533' },
      { name: 'Ústí nad Orlicí', abbreviation: '534' },
      { name: 'Kraj Vysočina', abbreviation: '63' },
      { name: 'Havlíčkův Brod', abbreviation: '631' },
      { name: 'Jihlava', abbreviation: '632' },
      { name: 'Pelhřimov', abbreviation: '633' },
      { name: 'Třebíč', abbreviation: '634' },
      { name: 'Žďár nad Sázavou', abbreviation: '635' },
      { name: 'Jihomoravský kraj', abbreviation: '64' },
      { name: 'Blansko', abbreviation: '641' },
      { name: 'Brno-město', abbreviation: '642' },
      { name: 'Brno-venkov', abbreviation: '643' },
      { name: 'Břeclav', abbreviation: '644' },
      { name: 'Hodonín', abbreviation: '645' },
      { name: 'Vyškov', abbreviation: '646' },
      { name: 'Znojmo', abbreviation: '647' },
      { name: 'Olomoucký kraj', abbreviation: '71' },
      { name: 'Jeseník', abbreviation: '711' },
      { name: 'Olomouc', abbreviation: '712' },
      { name: 'Prostějov', abbreviation: '713' },
      { name: 'Přerov', abbreviation: '714' },
      { name: 'Šumperk', abbreviation: '715' },
      { name: 'Zlínský kraj', abbreviation: '72' },
      { name: 'Kroměříž', abbreviation: '721' },
      { name: 'Uherské Hradiště', abbreviation: '722' },
      { name: 'Vsetín', abbreviation: '723' },
      { name: 'Zlín', abbreviation: '724' },
      { name: 'Moravskoslezský kraj', abbreviation: '80' },
      { name: 'Bruntál', abbreviation: '801' },
      { name: 'Frýdek-Místek', abbreviation: '802' },
      { name: 'Karviná', abbreviation: '803' },
      { name: 'Nový Jičín', abbreviation: '804' },
      { name: 'Opava', abbreviation: '805' },
      { name: 'Ostrava-město', abbreviation: '806' },
      { name: 'Praha, Hlavní město', abbreviation: '10' },
    ],
  },
  DEU: {
    regions: [
      { name: 'Brandenburg', abbreviation: 'BB' },
      { name: 'Berlin', abbreviation: 'BE' },
      { name: 'Baden-Württemberg', abbreviation: 'BW' },
      { name: 'Bayern', abbreviation: 'BY' },
      { name: 'Bremen', abbreviation: 'HB' },
      { name: 'Hessen', abbreviation: 'HE' },
      { name: 'Hamburg', abbreviation: 'HH' },
      { name: 'Mecklenburg-Vorpommern', abbreviation: 'MV' },
      { name: 'Niedersachsen', abbreviation: 'NI' },
      { name: 'Nordrhein-Westfalen', abbreviation: 'NW' },
      { name: 'Rheinland-Pfalz', abbreviation: 'RP' },
      { name: 'Schleswig-Holstein', abbreviation: 'SH' },
      { name: 'Saarland', abbreviation: 'SL' },
      { name: 'Sachsen', abbreviation: 'SN' },
      { name: 'Sachsen-Anhalt', abbreviation: 'ST' },
      { name: 'Thüringen', abbreviation: 'TH' },
    ],
  },
  DJI: {
    regions: [
      { name: '‘Artā', abbreviation: 'AR' },
      { name: '‘Alī Şabīḩ', abbreviation: 'AS' },
      { name: 'Dikhīl', abbreviation: 'DI' },
      { name: 'Awbūk', abbreviation: 'OB' },
      { name: 'Tājūrah', abbreviation: 'TA' },
      { name: 'Jībūtī', abbreviation: 'DJ' },
    ],
  },
  DMA: {
    regions: [
      { name: 'Saint Andrew', abbreviation: '02' },
      { name: 'Saint David', abbreviation: '03' },
      { name: 'Saint George', abbreviation: '04' },
      { name: 'Saint John', abbreviation: '05' },
      { name: 'Saint Joseph', abbreviation: '06' },
      { name: 'Saint Luke', abbreviation: '07' },
      { name: 'Saint Mark', abbreviation: '08' },
      { name: 'Saint Patrick', abbreviation: '09' },
      { name: 'Saint Paul', abbreviation: '10' },
      { name: 'Saint Peter', abbreviation: '11' },
    ],
  },
  DNK: {
    regions: [
      { name: 'Nordjylland', abbreviation: '81' },
      { name: 'Midtjylland', abbreviation: '82' },
      { name: 'Syddanmark', abbreviation: '83' },
      { name: 'Hovedstaden', abbreviation: '84' },
      { name: 'Sjælland', abbreviation: '85' },
    ],
  },
  DOM: {
    regions: [
      { name: 'Cibao Nordeste', abbreviation: '33' },
      { name: 'Duarte', abbreviation: '06' },
      { name: 'María Trinidad Sánchez', abbreviation: '14' },
      { name: 'Hermanas Mirabal', abbreviation: '19' },
      { name: 'Samaná', abbreviation: '20' },
      { name: 'Cibao Noroeste', abbreviation: '34' },
      { name: 'Dajabón', abbreviation: '05' },
      { name: 'Monte Cristi', abbreviation: '15' },
      { name: 'Santiago Rodríguez', abbreviation: '26' },
      { name: 'Valverde', abbreviation: '27' },
      { name: 'Cibao Norte', abbreviation: '35' },
      { name: 'Espaillat', abbreviation: '09' },
      { name: 'Puerto Plata', abbreviation: '18' },
      { name: 'Santiago', abbreviation: '25' },
      { name: 'Cibao Sur', abbreviation: '36' },
      { name: 'La Vega', abbreviation: '13' },
      { name: 'Sánchez Ramírez', abbreviation: '24' },
      { name: 'Monseñor Nouel', abbreviation: '28' },
      { name: 'El Valle', abbreviation: '37' },
      { name: 'Elías Piña', abbreviation: '07' },
      { name: 'San Juan', abbreviation: '22' },
      { name: 'Enriquillo', abbreviation: '38' },
      { name: 'Baoruco', abbreviation: '03' },
      { name: 'Barahona', abbreviation: '04' },
      { name: 'Independencia', abbreviation: '10' },
      { name: 'Pedernales', abbreviation: '16' },
      { name: 'Higuamo', abbreviation: '39' },
      { name: 'San Pedro de Macorís', abbreviation: '23' },
      { name: 'Monte Plata', abbreviation: '29' },
      { name: 'Hato Mayor', abbreviation: '30' },
      { name: 'Ozama', abbreviation: '40' },
      { name: 'Santo Domingo', abbreviation: '32' },
      { name: 'Distrito Nacional (Santo Domingo)', abbreviation: '01' },
      { name: 'Valdesia', abbreviation: '41' },
      { name: 'Azua', abbreviation: '02' },
      { name: 'Peravia', abbreviation: '17' },
      { name: 'San Cristóbal', abbreviation: '21' },
      { name: 'San José de Ocoa', abbreviation: '31' },
      { name: 'Yuma', abbreviation: '42' },
      { name: 'El Seibo', abbreviation: '08' },
      { name: 'La Altagracia', abbreviation: '11' },
      { name: 'La Romana', abbreviation: '12' },
    ],
  },
  DZA: {
    regions: [
      { name: 'Adrar', abbreviation: '01' },
      { name: 'Chlef', abbreviation: '02' },
      { name: 'Laghouat', abbreviation: '03' },
      { name: 'Oum el Bouaghi', abbreviation: '04' },
      { name: 'Batna', abbreviation: '05' },
      { name: 'Béjaïa', abbreviation: '06' },
      { name: 'Biskra', abbreviation: '07' },
      { name: 'Béchar', abbreviation: '08' },
      { name: 'Blida', abbreviation: '09' },
      { name: 'Bouira', abbreviation: '10' },
      { name: 'Tamanrasset', abbreviation: '11' },
      { name: 'Tébessa', abbreviation: '12' },
      { name: 'Tlemcen', abbreviation: '13' },
      { name: 'Tiaret', abbreviation: '14' },
      { name: 'Tizi Ouzou', abbreviation: '15' },
      { name: 'Alger', abbreviation: '16' },
      { name: 'Djelfa', abbreviation: '17' },
      { name: 'Jijel', abbreviation: '18' },
      { name: 'Sétif', abbreviation: '19' },
      { name: 'Saïda', abbreviation: '20' },
      { name: 'Skikda', abbreviation: '21' },
      { name: 'Sidi Bel Abbès', abbreviation: '22' },
      { name: 'Annaba', abbreviation: '23' },
      { name: 'Guelma', abbreviation: '24' },
      { name: 'Constantine', abbreviation: '25' },
      { name: 'Médéa', abbreviation: '26' },
      { name: 'Mostaganem', abbreviation: '27' },
      { name: "M'sila", abbreviation: '28' },
      { name: 'Mascara', abbreviation: '29' },
      { name: 'Ouargla', abbreviation: '30' },
      { name: 'Oran', abbreviation: '31' },
      { name: 'El Bayadh', abbreviation: '32' },
      { name: 'Illizi', abbreviation: '33' },
      { name: 'Bordj Bou Arréridj', abbreviation: '34' },
      { name: 'Boumerdès', abbreviation: '35' },
      { name: 'El Tarf', abbreviation: '36' },
      { name: 'Tindouf', abbreviation: '37' },
      { name: 'Tissemsilt', abbreviation: '38' },
      { name: 'El Oued', abbreviation: '39' },
      { name: 'Khenchela', abbreviation: '40' },
      { name: 'Souk Ahras', abbreviation: '41' },
      { name: 'Tipaza', abbreviation: '42' },
      { name: 'Mila', abbreviation: '43' },
      { name: 'Aïn Defla', abbreviation: '44' },
      { name: 'Naama', abbreviation: '45' },
      { name: 'Aïn Témouchent', abbreviation: '46' },
      { name: 'Ghardaïa', abbreviation: '47' },
      { name: 'Relizane', abbreviation: '48' },
    ],
  },
  ECU: {
    regions: [
      { name: 'Azuay', abbreviation: 'A' },
      { name: 'Bolívar', abbreviation: 'B' },
      { name: 'Carchi', abbreviation: 'C' },
      { name: 'Orellana', abbreviation: 'D' },
      { name: 'Esmeraldas', abbreviation: 'E' },
      { name: 'Cañar', abbreviation: 'F' },
      { name: 'Guayas', abbreviation: 'G' },
      { name: 'Chimborazo', abbreviation: 'H' },
      { name: 'Imbabura', abbreviation: 'I' },
      { name: 'Loja', abbreviation: 'L' },
      { name: 'Manabí', abbreviation: 'M' },
      { name: 'Napo', abbreviation: 'N' },
      { name: 'El Oro', abbreviation: 'O' },
      { name: 'Pichincha', abbreviation: 'P' },
      { name: 'Los Ríos', abbreviation: 'R' },
      { name: 'Morona Santiago', abbreviation: 'S' },
      { name: 'Santo Domingo de los Tsáchilas', abbreviation: 'SD' },
      { name: 'Santa Elena', abbreviation: 'SE' },
      { name: 'Tungurahua', abbreviation: 'T' },
      { name: 'Sucumbíos', abbreviation: 'U' },
      { name: 'Galápagos', abbreviation: 'W' },
      { name: 'Cotopaxi', abbreviation: 'X' },
      { name: 'Pastaza', abbreviation: 'Y' },
      { name: 'Zamora Chinchipe', abbreviation: 'Z' },
    ],
  },
  EGY: {
    regions: [
      { name: 'Al Iskandarīyah', abbreviation: 'ALX' },
      { name: 'Aswān', abbreviation: 'ASN' },
      { name: 'Asyūţ', abbreviation: 'AST' },
      { name: 'Al Baḩr al Aḩmar', abbreviation: 'BA' },
      { name: 'Al Buḩayrah', abbreviation: 'BH' },
      { name: 'Banī Suwayf', abbreviation: 'BNS' },
      { name: 'Al Qāhirah', abbreviation: 'C' },
      { name: 'Ad Daqahlīyah', abbreviation: 'DK' },
      { name: 'Dumyāţ', abbreviation: 'DT' },
      { name: 'Al Fayyūm', abbreviation: 'FYM' },
      { name: 'Al Gharbīyah', abbreviation: 'GH' },
      { name: 'Al Jīzah', abbreviation: 'GZ' },
      { name: "Al Ismā'īlīyah", abbreviation: 'IS' },
      { name: "Janūb Sīnā'", abbreviation: 'JS' },
      { name: 'Al Qalyūbīyah', abbreviation: 'KB' },
      { name: 'Kafr ash Shaykh', abbreviation: 'KFS' },
      { name: 'Qinā', abbreviation: 'KN' },
      { name: 'Al Uqşur', abbreviation: 'LX' },
      { name: 'Al Minyā', abbreviation: 'MN' },
      { name: 'Al Minūfīyah', abbreviation: 'MNF' },
      { name: 'Maţrūḩ', abbreviation: 'MT' },
      { name: 'Būr Sa‘īd', abbreviation: 'PTS' },
      { name: 'Sūhāj', abbreviation: 'SHG' },
      { name: 'Ash Sharqīyah', abbreviation: 'SHR' },
      { name: "Shamāl Sīnā'", abbreviation: 'SIN' },
      { name: 'As Suways', abbreviation: 'SUZ' },
      { name: 'Al Wādī al Jadīd', abbreviation: 'WAD' },
    ],
  },
  ERI: {
    regions: [
      { name: 'Ansabā', abbreviation: 'AN' },
      { name: 'Janūbī al Baḩrī al Aḩmar', abbreviation: 'DK' },
      { name: 'Al Janūbī', abbreviation: 'DU' },
      { name: 'Qāsh-Barkah', abbreviation: 'GB' },
      { name: 'Al Awsaţ', abbreviation: 'MA' },
      { name: 'Shimālī al Baḩrī al Aḩmar', abbreviation: 'SK' },
    ],
  },
  ESP: {
    regions: [
      { name: 'Andalucía', abbreviation: 'AN' },
      { name: 'Almería', abbreviation: 'AL' },
      { name: 'Cádiz', abbreviation: 'CA' },
      { name: 'Córdoba', abbreviation: 'CO' },
      { name: 'Granada', abbreviation: 'GR' },
      { name: 'Huelva', abbreviation: 'H' },
      { name: 'Jaén', abbreviation: 'J' },
      { name: 'Málaga', abbreviation: 'MA' },
      { name: 'Sevilla', abbreviation: 'SE' },
      { name: 'Aragón', abbreviation: 'AR' },
      { name: 'Huesca', abbreviation: 'HU' },
      { name: 'Teruel', abbreviation: 'TE' },
      { name: 'Zaragoza', abbreviation: 'Z' },
      { name: 'Asturias, Principado de', abbreviation: 'AS' },
      { name: 'Asturias', abbreviation: 'O' },
      { name: 'Cantabria', abbreviation: 'CB' },
      { name: 'Cantabria', abbreviation: 'S' },
      { name: 'Castilla y León', abbreviation: 'CL' },
      { name: 'Ávila', abbreviation: 'AV' },
      { name: 'Burgos', abbreviation: 'BU' },
      { name: 'León', abbreviation: 'LE' },
      { name: 'Palencia', abbreviation: 'P' },
      { name: 'Salamanca', abbreviation: 'SA' },
      { name: 'Segovia', abbreviation: 'SG' },
      { name: 'Soria', abbreviation: 'SO' },
      { name: 'Valladolid', abbreviation: 'VA' },
      { name: 'Zamora', abbreviation: 'ZA' },
      { name: 'Castilla-La Mancha', abbreviation: 'CM' },
      { name: 'Albacete', abbreviation: 'AB' },
      { name: 'Ciudad Real', abbreviation: 'CR' },
      { name: 'Cuenca', abbreviation: 'CU' },
      { name: 'Guadalajara', abbreviation: 'GU' },
      { name: 'Toledo', abbreviation: 'TO' },
      { name: 'Canarias', abbreviation: 'CN' },
      { name: 'Las Palmas', abbreviation: 'GC' },
      { name: 'Santa Cruz de Tenerife', abbreviation: 'TF' },
      { name: 'Catalunya [Cataluña]', abbreviation: 'CT' },
      { name: 'Barcelona [Barcelona]', abbreviation: 'B' },
      { name: 'Girona [Gerona]', abbreviation: 'GI' },
      { name: 'Lleida [Lérida]', abbreviation: 'L' },
      { name: 'Tarragona [Tarragona]', abbreviation: 'T' },
      { name: 'Extremadura', abbreviation: 'EX' },
      { name: 'Badajoz', abbreviation: 'BA' },
      { name: 'Cáceres', abbreviation: 'CC' },
      { name: 'Galicia [Galicia]', abbreviation: 'GA' },
      { name: 'A Coruña [La Coruña]', abbreviation: 'C' },
      { name: 'Lugo [Lugo]', abbreviation: 'LU' },
      { name: 'Ourense [Orense]', abbreviation: 'OR' },
      { name: 'Pontevedra [Pontevedra]', abbreviation: 'PO' },
      { name: 'Illes Balears [Islas Baleares]', abbreviation: 'IB' },
      { name: 'Balears [Baleares]', abbreviation: 'PM' },
      { name: 'Murcia, Región de', abbreviation: 'MC' },
      { name: 'Murcia', abbreviation: 'MU' },
      { name: 'Madrid, Comunidad de', abbreviation: 'MD' },
      { name: 'Madrid', abbreviation: 'M' },
      { name: 'Nafarroako Foru Komunitatea*', abbreviation: 'NC' },
      { name: 'Nafarroa*', abbreviation: 'NA' },
      { name: 'Euskal Herria', abbreviation: 'PV' },
      { name: 'Bizkaia', abbreviation: 'BI' },
      { name: 'Gipuzkoa', abbreviation: 'SS' },
      { name: 'Araba*', abbreviation: 'VI' },
      { name: 'La Rioja', abbreviation: 'RI' },
      { name: 'La Rioja', abbreviation: 'LO' },
      { name: 'Valenciana, Comunitat*', abbreviation: 'VC' },
      { name: 'Alacant*', abbreviation: 'A' },
      { name: 'Castelló*', abbreviation: 'CS' },
      { name: 'València*', abbreviation: 'V' },
      { name: 'Ceuta', abbreviation: 'CE' },
      { name: 'Melilla', abbreviation: 'ML' },
    ],
  },
  EST: {
    regions: [
      { name: 'Harjumaa', abbreviation: '37' },
      { name: 'Hiiumaa', abbreviation: '39' },
      { name: 'Ida-Virumaa', abbreviation: '44' },
      { name: 'Jõgevamaa', abbreviation: '49' },
      { name: 'Järvamaa', abbreviation: '51' },
      { name: 'Läänemaa', abbreviation: '57' },
      { name: 'Lääne-Virumaa', abbreviation: '59' },
      { name: 'Põlvamaa', abbreviation: '65' },
      { name: 'Pärnumaa', abbreviation: '67' },
      { name: 'Raplamaa', abbreviation: '70' },
      { name: 'Saaremaa', abbreviation: '74' },
      { name: 'Tartumaa', abbreviation: '78' },
      { name: 'Valgamaa', abbreviation: '82' },
      { name: 'Viljandimaa', abbreviation: '84' },
      { name: 'Võrumaa', abbreviation: '86' },
    ],
  },
  ETH: {
    regions: [
      { name: 'Āfar', abbreviation: 'AF' },
      { name: 'Amara', abbreviation: 'AM' },
      { name: 'Benshangul-Gumaz', abbreviation: 'BE' },
      { name: 'Gambela Peoples', abbreviation: 'GA' },
      { name: 'Harari People', abbreviation: 'HA' },
      { name: 'Oromia', abbreviation: 'OR' },
      {
        name: 'Southern Nations, Nationalities and Peoples',
        abbreviation: 'SN',
      },
      { name: 'Somali', abbreviation: 'SO' },
      { name: 'Tigrai', abbreviation: 'TI' },
      { name: 'Addis Ababa', abbreviation: 'AA' },
      { name: 'Dire Dawa', abbreviation: 'DD' },
    ],
  },
  FIN: {
    regions: [
      { name: 'Ahvenanmaan maakunta', abbreviation: '01' },
      { name: 'Etelä-Karjala', abbreviation: '02' },
      { name: 'Etelä-Pohjanmaa', abbreviation: '03' },
      { name: 'Etelä-Savo', abbreviation: '04' },
      { name: 'Kainuu', abbreviation: '05' },
      { name: 'Kanta-Häme', abbreviation: '06' },
      { name: 'Keski-Pohjanmaa', abbreviation: '07' },
      { name: 'Keski-Suomi', abbreviation: '08' },
      { name: 'Kymenlaakso', abbreviation: '09' },
      { name: 'Lappi', abbreviation: '10' },
      { name: 'Pirkanmaa', abbreviation: '11' },
      { name: 'Pohjanmaa', abbreviation: '12' },
      { name: 'Pohjois-Karjala', abbreviation: '13' },
      { name: 'Pohjois-Pohjanmaa', abbreviation: '14' },
      { name: 'Pohjois-Savo', abbreviation: '15' },
      { name: 'Päijät-Häme', abbreviation: '16' },
      { name: 'Satakunta', abbreviation: '17' },
      { name: 'Uusimaa', abbreviation: '18' },
      { name: 'Varsinais-Suomi', abbreviation: '19' },
    ],
  },
  FJI: {
    regions: [
      { name: 'Rotuma', abbreviation: 'R' },
      { name: 'Central', abbreviation: 'C' },
      { name: 'Naitasiri', abbreviation: '09' },
      { name: 'Namosi', abbreviation: '10' },
      { name: 'Rewa', abbreviation: '12' },
      { name: 'Serua', abbreviation: '13' },
      { name: 'Tailevu', abbreviation: '14' },
      { name: 'Eastern', abbreviation: 'E' },
      { name: 'Kadavu', abbreviation: '04' },
      { name: 'Lau', abbreviation: '05' },
      { name: 'Lomaiviti', abbreviation: '06' },
      { name: 'Northern', abbreviation: 'N' },
      { name: 'Bua', abbreviation: '02' },
      { name: 'Cakaudrove', abbreviation: '03' },
      { name: 'Macuata', abbreviation: '07' },
      { name: 'Western', abbreviation: 'W' },
      { name: 'Ba', abbreviation: '01' },
      { name: 'Nadroga and Navosa', abbreviation: '08' },
      { name: 'Ra', abbreviation: '11' },
    ],
  },
  FRA: {
    regions: [
      { name: 'Auvergne-Rhône-Alpes', abbreviation: 'ARA' },
      { name: 'Ain', abbreviation: '01' },
      { name: 'Allier', abbreviation: '03' },
      { name: 'Ardèche', abbreviation: '07' },
      { name: 'Cantal', abbreviation: '15' },
      { name: 'Drôme', abbreviation: '26' },
      { name: 'Isère', abbreviation: '38' },
      { name: 'Loire', abbreviation: '42' },
      { name: 'Haute-Loire', abbreviation: '43' },
      { name: 'Puy-de-Dôme', abbreviation: '63' },
      { name: 'Rhône', abbreviation: '69' },
      { name: 'Savoie', abbreviation: '73' },
      { name: 'Haute-Savoie', abbreviation: '74' },
      { name: 'Bourgogne-Franche-Comté', abbreviation: 'BFC' },
      { name: "Côte-d'Or", abbreviation: '21' },
      { name: 'Doubs', abbreviation: '25' },
      { name: 'Jura', abbreviation: '39' },
      { name: 'Nièvre', abbreviation: '58' },
      { name: 'Haute-Saône', abbreviation: '70' },
      { name: 'Saône-et-Loire', abbreviation: '71' },
      { name: 'Yonne', abbreviation: '89' },
      { name: 'Territoire de Belfort', abbreviation: '90' },
      { name: 'Bretagne', abbreviation: 'BRE' },
      { name: "Côtes-d'Armor", abbreviation: '22' },
      { name: 'Finistère', abbreviation: '29' },
      { name: 'Ille-et-Vilaine', abbreviation: '35' },
      { name: 'Morbihan', abbreviation: '56' },
      { name: 'Centre-Val de Loire', abbreviation: 'CVL' },
      { name: 'Cher', abbreviation: '18' },
      { name: 'Eure-et-Loir', abbreviation: '28' },
      { name: 'Indre', abbreviation: '36' },
      { name: 'Indre-et-Loire', abbreviation: '37' },
      { name: 'Loir-et-Cher', abbreviation: '41' },
      { name: 'Loiret', abbreviation: '45' },
      { name: 'Grand-Est', abbreviation: 'GES' },
      { name: 'Ardennes', abbreviation: '08' },
      { name: 'Aube', abbreviation: '10' },
      { name: 'Marne', abbreviation: '51' },
      { name: 'Haute-Marne', abbreviation: '52' },
      { name: 'Meurthe-et-Moselle', abbreviation: '54' },
      { name: 'Meuse', abbreviation: '55' },
      { name: 'Moselle', abbreviation: '57' },
      { name: 'Bas-Rhin', abbreviation: '67' },
      { name: 'Haut-Rhin', abbreviation: '68' },
      { name: 'Vosges', abbreviation: '88' },
      { name: 'Hauts-de-France', abbreviation: 'HDF' },
      { name: 'Aisne', abbreviation: '02' },
      { name: 'Nord', abbreviation: '59' },
      { name: 'Oise', abbreviation: '60' },
      { name: 'Pas-de-Calais', abbreviation: '62' },
      { name: 'Somme', abbreviation: '80' },
      { name: 'Île-de-France', abbreviation: 'IDF' },
      { name: 'Paris', abbreviation: '75' },
      { name: 'Seine-et-Marne', abbreviation: '77' },
      { name: 'Yvelines', abbreviation: '78' },
      { name: 'Essonne', abbreviation: '91' },
      { name: 'Hauts-de-Seine', abbreviation: '92' },
      { name: 'Seine-Saint-Denis', abbreviation: '93' },
      { name: 'Val-de-Marne', abbreviation: '94' },
      { name: "Val-d'Oise", abbreviation: '95' },
      { name: 'Nouvelle-Aquitaine', abbreviation: 'NAQ' },
      { name: 'Charente', abbreviation: '16' },
      { name: 'Charente-Maritime', abbreviation: '17' },
      { name: 'Corrèze', abbreviation: '19' },
      { name: 'Creuse', abbreviation: '23' },
      { name: 'Dordogne', abbreviation: '24' },
      { name: 'Gironde', abbreviation: '33' },
      { name: 'Landes', abbreviation: '40' },
      { name: 'Lot-et-Garonne', abbreviation: '47' },
      { name: 'Pyrénées-Atlantiques', abbreviation: '64' },
      { name: 'Deux-Sèvres', abbreviation: '79' },
      { name: 'Vienne', abbreviation: '86' },
      { name: 'Haute-Vienne', abbreviation: '87' },
      { name: 'Normandie', abbreviation: 'NOR' },
      { name: 'Calvados', abbreviation: '14' },
      { name: 'Eure', abbreviation: '27' },
      { name: 'Manche', abbreviation: '50' },
      { name: 'Orne', abbreviation: '61' },
      { name: 'Seine-Maritime', abbreviation: '76' },
      { name: 'Occitanie', abbreviation: 'OCC' },
      { name: 'Ariège', abbreviation: '09' },
      { name: 'Aude', abbreviation: '11' },
      { name: 'Aveyron', abbreviation: '12' },
      { name: 'Gard', abbreviation: '30' },
      { name: 'Haute-Garonne', abbreviation: '31' },
      { name: 'Gers', abbreviation: '32' },
      { name: 'Hérault', abbreviation: '34' },
      { name: 'Lot', abbreviation: '46' },
      { name: 'Lozère', abbreviation: '48' },
      { name: 'Hautes-Pyrénées', abbreviation: '65' },
      { name: 'Pyrénées-Orientales', abbreviation: '66' },
      { name: 'Tarn', abbreviation: '81' },
      { name: 'Tarn-et-Garonne', abbreviation: '82' },
      { name: 'Provence-Alpes-Côte-d’Azur', abbreviation: 'PAC' },
      { name: 'Alpes-de-Haute-Provence', abbreviation: '04' },
      { name: 'Hautes-Alpes', abbreviation: '05' },
      { name: 'Alpes-Maritimes', abbreviation: '06' },
      { name: 'Bouches-du-Rhône', abbreviation: '13' },
      { name: 'Var', abbreviation: '83' },
      { name: 'Vaucluse', abbreviation: '84' },
      { name: 'Pays-de-la-Loire', abbreviation: 'PDL' },
      { name: 'Loire-Atlantique', abbreviation: '44' },
      { name: 'Maine-et-Loire', abbreviation: '49' },
      { name: 'Mayenne', abbreviation: '53' },
      { name: 'Sarthe', abbreviation: '72' },
      { name: 'Vendée', abbreviation: '85' },
      { name: 'Clipperton', abbreviation: 'CP' },
      { name: 'Saint-Barthélemy', abbreviation: 'BL' },
      { name: 'Guyane (française)', abbreviation: 'GF' },
      { name: 'Saint-Martin', abbreviation: 'MF' },
      { name: 'Martinique', abbreviation: 'MQ' },
      { name: 'Nouvelle-Calédonie', abbreviation: 'NC' },
      { name: 'Polynésie française', abbreviation: 'PF' },
      { name: 'Saint-Pierre-et-Miquelon', abbreviation: 'PM' },
      { name: 'Terres australes françaises', abbreviation: 'TF' },
      { name: 'Wallis-et-Futuna', abbreviation: 'WF' },
      { name: 'Guadeloupe', abbreviation: 'GUA' },
      { name: 'Guadeloupe', abbreviation: 'GP' },
      { name: 'La Réunion', abbreviation: 'LRE' },
      { name: 'La Réunion', abbreviation: 'RE' },
      { name: 'Mayotte', abbreviation: 'MAY' },
      { name: 'Mayotte', abbreviation: 'YT' },
      { name: 'Corse', abbreviation: 'COR' },
      { name: 'Corse-du-Sud', abbreviation: '2A' },
      { name: 'Haute-Corse', abbreviation: '2B' },
    ],
  },
  FSM: {
    regions: [
      { name: 'Kosrae', abbreviation: 'KSA' },
      { name: 'Pohnpei', abbreviation: 'PNI' },
      { name: 'Chuuk', abbreviation: 'TRK' },
      { name: 'Yap', abbreviation: 'YAP' },
    ],
  },
  GAB: {
    regions: [
      { name: 'Estuaire', abbreviation: '1' },
      { name: 'Haut-Ogooué', abbreviation: '2' },
      { name: 'Moyen-Ogooué', abbreviation: '3' },
      { name: 'Ngounié', abbreviation: '4' },
      { name: 'Nyanga', abbreviation: '5' },
      { name: 'Ogooué-Ivindo', abbreviation: '6' },
      { name: 'Ogooué-Lolo', abbreviation: '7' },
      { name: 'Ogooué-Maritime', abbreviation: '8' },
      { name: 'Woleu-Ntem', abbreviation: '9' },
    ],
  },
  GBR: {
    regions: [
      { name: 'Aberdeenshire', abbreviation: 'ABD' },
      { name: 'Aberdeen City', abbreviation: 'ABE' },
      { name: 'Argyll and Bute', abbreviation: 'AGB' },
      { name: 'Angus', abbreviation: 'ANS' },
      { name: 'Clackmannanshire', abbreviation: 'CLK' },
      { name: 'Dumfries and Galloway', abbreviation: 'DGY' },
      { name: 'Dundee City', abbreviation: 'DND' },
      { name: 'East Ayrshire', abbreviation: 'EAY' },
      { name: 'Edinburgh, City of', abbreviation: 'EDH' },
      { name: 'East Dunbartonshire', abbreviation: 'EDU' },
      { name: 'East Lothian', abbreviation: 'ELN' },
      { name: 'Eilean Siar', abbreviation: 'ELS' },
      { name: 'East Renfrewshire', abbreviation: 'ERW' },
      { name: 'Falkirk', abbreviation: 'FAL' },
      { name: 'Fife', abbreviation: 'FIF' },
      { name: 'Glasgow City', abbreviation: 'GLG' },
      { name: 'Highland', abbreviation: 'HLD' },
      { name: 'Inverclyde', abbreviation: 'IVC' },
      { name: 'Midlothian', abbreviation: 'MLN' },
      { name: 'Moray', abbreviation: 'MRY' },
      { name: 'North Ayrshire', abbreviation: 'NAY' },
      { name: 'North Lanarkshire', abbreviation: 'NLK' },
      { name: 'Orkney Islands', abbreviation: 'ORK' },
      { name: 'Perth and Kinross', abbreviation: 'PKN' },
      { name: 'Renfrewshire', abbreviation: 'RFW' },
      { name: 'South Ayrshire', abbreviation: 'SAY' },
      { name: 'Scottish Borders, The', abbreviation: 'SCB' },
      { name: 'South Lanarkshire', abbreviation: 'SLK' },
      { name: 'Stirling', abbreviation: 'STG' },
      { name: 'West Dunbartonshire', abbreviation: 'WDU' },
      { name: 'West Lothian', abbreviation: 'WLN' },
      { name: 'Shetland Islands', abbreviation: 'ZET' },
      { name: 'Buckinghamshire', abbreviation: 'BKM' },
      { name: 'Cambridgeshire', abbreviation: 'CAM' },
      { name: 'Cumbria', abbreviation: 'CMA' },
      { name: 'Derbyshire', abbreviation: 'DBY' },
      { name: 'Devon', abbreviation: 'DEV' },
      { name: 'Dorset', abbreviation: 'DOR' },
      { name: 'Essex', abbreviation: 'ESS' },
      { name: 'East Sussex', abbreviation: 'ESX' },
      { name: 'Gloucestershire', abbreviation: 'GLS' },
      { name: 'Hampshire', abbreviation: 'HAM' },
      { name: 'Hertfordshire', abbreviation: 'HRT' },
      { name: 'Kent', abbreviation: 'KEN' },
      { name: 'Lancashire', abbreviation: 'LAN' },
      { name: 'Leicestershire', abbreviation: 'LEC' },
      { name: 'Lincolnshire', abbreviation: 'LIN' },
      { name: 'Norfolk', abbreviation: 'NFK' },
      { name: 'Northamptonshire', abbreviation: 'NTH' },
      { name: 'Nottinghamshire', abbreviation: 'NTT' },
      { name: 'North Yorkshire', abbreviation: 'NYK' },
      { name: 'Oxfordshire', abbreviation: 'OXF' },
      { name: 'Suffolk', abbreviation: 'SFK' },
      { name: 'Somerset', abbreviation: 'SOM' },
      { name: 'Surrey', abbreviation: 'SRY' },
      { name: 'Staffordshire', abbreviation: 'STS' },
      { name: 'Warwickshire', abbreviation: 'WAR' },
      { name: 'Worcestershire', abbreviation: 'WOR' },
      { name: 'West Sussex', abbreviation: 'WSX' },
      { name: 'Armagh City, Banbridge and Craigavon', abbreviation: 'ABC' },
      { name: 'Ards and North Down', abbreviation: 'AND' },
      { name: 'Antrim and Newtownabbey', abbreviation: 'ANN' },
      { name: 'Belfast', abbreviation: 'BFS' },
      { name: 'Causeway Coast and Glens', abbreviation: 'CCG' },
      { name: 'Derry City and Strabane', abbreviation: 'DRS' },
      { name: 'Fermanagh and Omagh', abbreviation: 'FMO' },
      { name: 'Lisburn and Castlereagh', abbreviation: 'LBC' },
      { name: 'Mid and East Antrim', abbreviation: 'MEA' },
      { name: 'Mid Ulster', abbreviation: 'MUL' },
      { name: 'Newry, Mourne and Down', abbreviation: 'NMD' },
      { name: 'Isle of Anglesey [Sir Ynys Môn GB-YNM]', abbreviation: 'AGY' },
      { name: 'Bath and North East Somerset', abbreviation: 'BAS' },
      { name: 'Blackburn with Darwen', abbreviation: 'BBD' },
      { name: 'Bedford', abbreviation: 'BDF' },
      { name: 'Bridgend [Pen-y-bont ar Ogwr GB-POG]', abbreviation: 'BGE' },
      { name: 'Blaenau Gwent', abbreviation: 'BGW' },
      { name: 'Bournemouth', abbreviation: 'BMH' },
      { name: 'Brighton and Hove', abbreviation: 'BNH' },
      { name: 'Blackpool', abbreviation: 'BPL' },
      { name: 'Bracknell Forest', abbreviation: 'BRC' },
      { name: 'Bristol, City of', abbreviation: 'BST' },
      { name: 'Caerphilly [Caerffili GB-CAF]', abbreviation: 'CAY' },
      { name: 'Central Bedfordshire', abbreviation: 'CBF' },
      { name: 'Ceredigion [Sir Ceredigion]', abbreviation: 'CGN' },
      { name: 'Cheshire East', abbreviation: 'CHE' },
      { name: 'Cheshire West and Chester', abbreviation: 'CHW' },
      { name: 'Carmarthenshire [Sir Gaerfyrddin GB-GFY]', abbreviation: 'CMN' },
      { name: 'Cornwall', abbreviation: 'CON' },
      { name: 'Cardiff [Caerdydd GB-CRD]', abbreviation: 'CRF' },
      { name: 'Conwy', abbreviation: 'CWY' },
      { name: 'Darlington', abbreviation: 'DAL' },
      { name: 'Denbighshire [Sir Ddinbych GB-DDB]', abbreviation: 'DEN' },
      { name: 'Derby', abbreviation: 'DER' },
      { name: 'Durham County', abbreviation: 'DUR' },
      { name: 'East Riding of Yorkshire', abbreviation: 'ERY' },
      { name: 'Flintshire [Sir y Fflint GB-FFL]', abbreviation: 'FLN' },
      { name: 'Gwynedd', abbreviation: 'GWN' },
      { name: 'Halton', abbreviation: 'HAL' },
      { name: 'Herefordshire', abbreviation: 'HEF' },
      { name: 'Hartlepool', abbreviation: 'HPL' },
      { name: 'Isles of Scilly', abbreviation: 'IOS' },
      { name: 'Isle of Wight', abbreviation: 'IOW' },
      { name: 'Kingston upon Hull', abbreviation: 'KHL' },
      { name: 'Leicester', abbreviation: 'LCE' },
      { name: 'Luton', abbreviation: 'LUT' },
      { name: 'Middlesbrough', abbreviation: 'MDB' },
      { name: 'Medway', abbreviation: 'MDW' },
      { name: 'Milton Keynes', abbreviation: 'MIK' },
      { name: 'Monmouthshire [Sir Fynwy GB-FYN]', abbreviation: 'MON' },
      { name: 'Merthyr Tydfil [Merthyr Tudful GB-MTU]', abbreviation: 'MTY' },
      { name: 'Northumberland', abbreviation: 'NBL' },
      { name: 'North East Lincolnshire', abbreviation: 'NEL' },
      { name: 'Nottingham', abbreviation: 'NGM' },
      { name: 'North Lincolnshire', abbreviation: 'NLN' },
      { name: 'North Somerset', abbreviation: 'NSM' },
      {
        name: 'Neath Port Talbot [Castell-nedd Port Talbot GB-CTL]',
        abbreviation: 'NTL',
      },
      { name: 'Newport [Casnewydd GB-CNW]', abbreviation: 'NWP' },
      { name: 'Pembrokeshire [Sir Benfro GB-BNF]', abbreviation: 'PEM' },
      { name: 'Plymouth', abbreviation: 'PLY' },
      { name: 'Poole', abbreviation: 'POL' },
      { name: 'Portsmouth', abbreviation: 'POR' },
      { name: 'Powys', abbreviation: 'POW' },
      { name: 'Peterborough', abbreviation: 'PTE' },
      { name: 'Redcar and Cleveland', abbreviation: 'RCC' },
      {
        name: 'Rhondda, Cynon, Taff [Rhondda, Cynon,Taf]',
        abbreviation: 'RCT',
      },
      { name: 'Reading', abbreviation: 'RDG' },
      { name: 'Rutland', abbreviation: 'RUT' },
      { name: 'South Gloucestershire', abbreviation: 'SGC' },
      { name: 'Shropshire', abbreviation: 'SHR' },
      { name: 'Slough', abbreviation: 'SLG' },
      { name: 'Southend-on-Sea', abbreviation: 'SOS' },
      { name: 'Stoke-on-Trent', abbreviation: 'STE' },
      { name: 'Southampton', abbreviation: 'STH' },
      { name: 'Stockton-on-Tees', abbreviation: 'STT' },
      { name: 'Swansea [Abertawe GB-ATA]', abbreviation: 'SWA' },
      { name: 'Swindon', abbreviation: 'SWD' },
      { name: 'Telford and Wrekin', abbreviation: 'TFW' },
      { name: 'Thurrock', abbreviation: 'THR' },
      { name: 'Torbay', abbreviation: 'TOB' },
      { name: 'Torfaen [Tor-faen]', abbreviation: 'TOF' },
      {
        name: 'Vale of Glamorgan, The [Bro Morgannwg GB-BMG]',
        abbreviation: 'VGL',
      },
      { name: 'West Berkshire', abbreviation: 'WBK' },
      { name: 'Wiltshire', abbreviation: 'WIL' },
      { name: 'Windsor and Maidenhead', abbreviation: 'WNM' },
      { name: 'Wokingham', abbreviation: 'WOK' },
      { name: 'Warrington', abbreviation: 'WRT' },
      { name: 'Wrexham [Wrecsam GB-WRC]', abbreviation: 'WRX' },
      { name: 'York', abbreviation: 'YOR' },
      { name: 'Birmingham', abbreviation: 'BIR' },
      { name: 'Barnsley', abbreviation: 'BNS' },
      { name: 'Bolton', abbreviation: 'BOL' },
      { name: 'Bradford', abbreviation: 'BRD' },
      { name: 'Bury', abbreviation: 'BUR' },
      { name: 'Calderdale', abbreviation: 'CLD' },
      { name: 'Coventry', abbreviation: 'COV' },
      { name: 'Doncaster', abbreviation: 'DNC' },
      { name: 'Dudley', abbreviation: 'DUD' },
      { name: 'Gateshead', abbreviation: 'GAT' },
      { name: 'Kirklees', abbreviation: 'KIR' },
      { name: 'Knowsley', abbreviation: 'KWL' },
      { name: 'Leeds', abbreviation: 'LDS' },
      { name: 'Liverpool', abbreviation: 'LIV' },
      { name: 'Manchester', abbreviation: 'MAN' },
      { name: 'Newcastle upon Tyne', abbreviation: 'NET' },
      { name: 'North Tyneside', abbreviation: 'NTY' },
      { name: 'Oldham', abbreviation: 'OLD' },
      { name: 'Rochdale', abbreviation: 'RCH' },
      { name: 'Rotherham', abbreviation: 'ROT' },
      { name: 'Sandwell', abbreviation: 'SAW' },
      { name: 'Sefton', abbreviation: 'SFT' },
      { name: 'Sheffield', abbreviation: 'SHF' },
      { name: 'St. Helens', abbreviation: 'SHN' },
      { name: 'Stockport', abbreviation: 'SKP' },
      { name: 'Salford', abbreviation: 'SLF' },
      { name: 'Sunderland', abbreviation: 'SND' },
      { name: 'Solihull', abbreviation: 'SOL' },
      { name: 'South Tyneside', abbreviation: 'STY' },
      { name: 'Tameside', abbreviation: 'TAM' },
      { name: 'Trafford', abbreviation: 'TRF' },
      { name: 'Wigan', abbreviation: 'WGN' },
      { name: 'Wakefield', abbreviation: 'WKF' },
      { name: 'Walsall', abbreviation: 'WLL' },
      { name: 'Wolverhampton', abbreviation: 'WLV' },
      { name: 'Wirral', abbreviation: 'WRL' },
      { name: 'Barking and Dagenham', abbreviation: 'BDG' },
      { name: 'Brent', abbreviation: 'BEN' },
      { name: 'Bexley', abbreviation: 'BEX' },
      { name: 'Barnet', abbreviation: 'BNE' },
      { name: 'Bromley', abbreviation: 'BRY' },
      { name: 'Camden', abbreviation: 'CMD' },
      { name: 'Croydon', abbreviation: 'CRY' },
      { name: 'Ealing', abbreviation: 'EAL' },
      { name: 'Enfield', abbreviation: 'ENF' },
      { name: 'Greenwich', abbreviation: 'GRE' },
      { name: 'Havering', abbreviation: 'HAV' },
      { name: 'Hackney', abbreviation: 'HCK' },
      { name: 'Hillingdon', abbreviation: 'HIL' },
      { name: 'Hammersmith and Fulham', abbreviation: 'HMF' },
      { name: 'Hounslow', abbreviation: 'HNS' },
      { name: 'Harrow', abbreviation: 'HRW' },
      { name: 'Haringey', abbreviation: 'HRY' },
      { name: 'Islington', abbreviation: 'ISL' },
      { name: 'Kensington and Chelsea', abbreviation: 'KEC' },
      { name: 'Kingston upon Thames', abbreviation: 'KTT' },
      { name: 'Lambeth', abbreviation: 'LBH' },
      { name: 'Lewisham', abbreviation: 'LEW' },
      { name: 'Merton', abbreviation: 'MRT' },
      { name: 'Newham', abbreviation: 'NWM' },
      { name: 'Redbridge', abbreviation: 'RDB' },
      { name: 'Richmond upon Thames', abbreviation: 'RIC' },
      { name: 'Sutton', abbreviation: 'STN' },
      { name: 'Southwark', abbreviation: 'SWK' },
      { name: 'Tower Hamlets', abbreviation: 'TWH' },
      { name: 'Waltham Forest', abbreviation: 'WFT' },
      { name: 'Wandsworth', abbreviation: 'WND' },
      { name: 'Westminster', abbreviation: 'WSM' },
      { name: 'London, City of', abbreviation: 'LND' },
    ],
  },
  GEO: {
    regions: [
      { name: 'Guria', abbreviation: 'GU' },
      { name: 'Imereti', abbreviation: 'IM' },
      { name: "K'akheti", abbreviation: 'KA' },
      { name: 'Kvemo Kartli', abbreviation: 'KK' },
      { name: 'Mtskheta-Mtianeti', abbreviation: 'MM' },
      { name: "Rach'a-Lechkhumi-Kvemo Svaneti", abbreviation: 'RL' },
      { name: 'Samtskhe-Javakheti', abbreviation: 'SJ' },
      { name: 'Shida Kartli', abbreviation: 'SK' },
      { name: 'Samegrelo-Zemo Svaneti', abbreviation: 'SZ' },
      { name: 'Abkhazia', abbreviation: 'AB' },
      { name: 'Ajaria', abbreviation: 'AJ' },
      { name: 'Tbilisi', abbreviation: 'TB' },
    ],
  },
  GHA: {
    regions: [
      { name: 'Greater Accra', abbreviation: 'AA' },
      { name: 'Ahafo', abbreviation: 'AF' },
      { name: 'Ashanti', abbreviation: 'AH' },
      { name: 'Bono East', abbreviation: 'BE' },
      { name: 'Bono', abbreviation: 'BO' },
      { name: 'Central', abbreviation: 'CP' },
      { name: 'Eastern', abbreviation: 'EP' },
      { name: 'North East', abbreviation: 'NE' },
      { name: 'Northern', abbreviation: 'NP' },
      { name: 'Oti', abbreviation: 'OT' },
      { name: 'Savannah', abbreviation: 'SV' },
      { name: 'Volta', abbreviation: 'TV' },
      { name: 'Upper East', abbreviation: 'UE' },
      { name: 'Upper West', abbreviation: 'UW' },
      { name: 'Western North', abbreviation: 'WN' },
      { name: 'Western', abbreviation: 'WP' },
    ],
  },
  GIN: {
    regions: [
      { name: 'Conakry', abbreviation: 'C' },
      { name: 'Boké', abbreviation: 'B' },
      { name: 'Boffa', abbreviation: 'BF' },
      { name: 'Boké', abbreviation: 'BK' },
      { name: 'Fria', abbreviation: 'FR' },
      { name: 'Gaoual', abbreviation: 'GA' },
      { name: 'Koundara', abbreviation: 'KN' },
      { name: 'Kindia', abbreviation: 'D' },
      { name: 'Coyah', abbreviation: 'CO' },
      { name: 'Dubréka', abbreviation: 'DU' },
      { name: 'Forécariah', abbreviation: 'FO' },
      { name: 'Kindia', abbreviation: 'KD' },
      { name: 'Télimélé', abbreviation: 'TE' },
      { name: 'Faranah', abbreviation: 'F' },
      { name: 'Dabola', abbreviation: 'DB' },
      { name: 'Dinguiraye', abbreviation: 'DI' },
      { name: 'Faranah', abbreviation: 'FA' },
      { name: 'Kissidougou', abbreviation: 'KS' },
      { name: 'Kankan', abbreviation: 'K' },
      { name: 'Kankan', abbreviation: 'KA' },
      { name: 'Kérouané', abbreviation: 'KE' },
      { name: 'Kouroussa', abbreviation: 'KO' },
      { name: 'Mandiana', abbreviation: 'MD' },
      { name: 'Siguiri', abbreviation: 'SI' },
      { name: 'Labé', abbreviation: 'L' },
      { name: 'Koubia', abbreviation: 'KB' },
      { name: 'Labé', abbreviation: 'LA' },
      { name: 'Lélouma', abbreviation: 'LE' },
      { name: 'Mali', abbreviation: 'ML' },
      { name: 'Tougué', abbreviation: 'TO' },
      { name: 'Mamou', abbreviation: 'M' },
      { name: 'Dalaba', abbreviation: 'DL' },
      { name: 'Mamou', abbreviation: 'MM' },
      { name: 'Pita', abbreviation: 'PI' },
      { name: 'Nzérékoré', abbreviation: 'N' },
      { name: 'Beyla', abbreviation: 'BE' },
      { name: 'Guékédou', abbreviation: 'GU' },
      { name: 'Lola', abbreviation: 'LO' },
      { name: 'Macenta', abbreviation: 'MC' },
      { name: 'Nzérékoré', abbreviation: 'NZ' },
      { name: 'Yomou', abbreviation: 'YO' },
    ],
  },
  GMB: {
    regions: [
      { name: 'Lower River', abbreviation: 'L' },
      { name: 'Central River', abbreviation: 'M' },
      { name: 'North Bank', abbreviation: 'N' },
      { name: 'Upper River', abbreviation: 'U' },
      { name: 'Western', abbreviation: 'W' },
      { name: 'Banjul', abbreviation: 'B' },
    ],
  },
  GNB: {
    regions: [
      { name: 'Bissau', abbreviation: 'BS' },
      { name: 'Leste', abbreviation: 'L' },
      { name: 'Bafatá', abbreviation: 'BA' },
      { name: 'Gabú', abbreviation: 'GA' },
      { name: 'Norte', abbreviation: 'N' },
      { name: 'Biombo', abbreviation: 'BM' },
      { name: 'Cacheu', abbreviation: 'CA' },
      { name: 'Oio', abbreviation: 'OI' },
      { name: 'Sul', abbreviation: 'S' },
      { name: 'Bolama', abbreviation: 'BL' },
      { name: 'Quinara', abbreviation: 'QU' },
      { name: 'Tombali', abbreviation: 'TO' },
    ],
  },
  GNQ: {
    regions: [
      { name: 'Région Continentale', abbreviation: 'C' },
      { name: 'Centro Sud', abbreviation: 'CS' },
      { name: 'Kié-Ntem', abbreviation: 'KN' },
      { name: 'Littoral', abbreviation: 'LI' },
      { name: 'Wele-Nzas', abbreviation: 'WN' },
      { name: 'Région Insulaire', abbreviation: 'I' },
      { name: 'Annobon', abbreviation: 'AN' },
      { name: 'Bioko Nord', abbreviation: 'BN' },
      { name: 'Bioko Sud', abbreviation: 'BS' },
    ],
  },
  GRC: {
    regions: [
      { name: 'Ágion Óros', abbreviation: '69' },
      { name: 'Anatolikí Makedonía kai Thráki', abbreviation: 'A' },
      { name: 'Kentrikí Makedonía', abbreviation: 'B' },
      { name: 'Dytikí Makedonía', abbreviation: 'C' },
      { name: 'Ípeiros', abbreviation: 'D' },
      { name: 'Thessalía', abbreviation: 'E' },
      { name: 'Ionía Nísia', abbreviation: 'F' },
      { name: 'Dytikí Elláda', abbreviation: 'G' },
      { name: 'Stereá Elláda', abbreviation: 'H' },
      { name: 'Attikí', abbreviation: 'I' },
      { name: 'Pelopónnisos', abbreviation: 'J' },
      { name: 'Vóreio Aigaío', abbreviation: 'K' },
      { name: 'Nótio Aigaío', abbreviation: 'L' },
      { name: 'Kríti', abbreviation: 'M' },
    ],
  },
  GRD: {
    regions: [
      { name: 'Saint Andrew', abbreviation: '01' },
      { name: 'Saint David', abbreviation: '02' },
      { name: 'Saint George', abbreviation: '03' },
      { name: 'Saint John', abbreviation: '04' },
      { name: 'Saint Mark', abbreviation: '05' },
      { name: 'Saint Patrick', abbreviation: '06' },
      { name: 'Southern Grenadine Islands', abbreviation: '10' },
    ],
  },
  GRL: {
    regions: [
      { name: 'Avannaata Kommunia', abbreviation: 'AV' },
      { name: 'Kommune Kujalleq', abbreviation: 'KU' },
      { name: 'Qeqqata Kommunia', abbreviation: 'QE' },
      { name: 'Kommune Qeqertalik', abbreviation: 'QT' },
      { name: 'Kommuneqarfik Sermersooq', abbreviation: 'SM' },
    ],
  },
  GTM: {
    regions: [
      { name: 'Alta Verapaz', abbreviation: 'AV' },
      { name: 'Baja Verapaz', abbreviation: 'BV' },
      { name: 'Chimaltenango', abbreviation: 'CM' },
      { name: 'Chiquimula', abbreviation: 'CQ' },
      { name: 'Escuintla', abbreviation: 'ES' },
      { name: 'Guatemala', abbreviation: 'GU' },
      { name: 'Huehuetenango', abbreviation: 'HU' },
      { name: 'Izabal', abbreviation: 'IZ' },
      { name: 'Jalapa', abbreviation: 'JA' },
      { name: 'Jutiapa', abbreviation: 'JU' },
      { name: 'Petén', abbreviation: 'PE' },
      { name: 'El Progreso', abbreviation: 'PR' },
      { name: 'Quiché', abbreviation: 'QC' },
      { name: 'Quetzaltenango', abbreviation: 'QZ' },
      { name: 'Retalhuleu', abbreviation: 'RE' },
      { name: 'Sacatepéquez', abbreviation: 'SA' },
      { name: 'San Marcos', abbreviation: 'SM' },
      { name: 'Sololá', abbreviation: 'SO' },
      { name: 'Santa Rosa', abbreviation: 'SR' },
      { name: 'Suchitepéquez', abbreviation: 'SU' },
      { name: 'Totonicapán', abbreviation: 'TO' },
      { name: 'Zacapa', abbreviation: 'ZA' },
    ],
  },
  GUY: {
    regions: [
      { name: 'Barima-Waini', abbreviation: 'BA' },
      { name: 'Cuyuni-Mazaruni', abbreviation: 'CU' },
      { name: 'Demerara-Mahaica', abbreviation: 'DE' },
      { name: 'East Berbice-Corentyne', abbreviation: 'EB' },
      { name: 'Essequibo Islands-West Demerara', abbreviation: 'ES' },
      { name: 'Mahaica-Berbice', abbreviation: 'MA' },
      { name: 'Pomeroon-Supenaam', abbreviation: 'PM' },
      { name: 'Potaro-Siparuni', abbreviation: 'PT' },
      { name: 'Upper Demerara-Berbice', abbreviation: 'UD' },
      { name: 'Upper Takutu-Upper Essequibo', abbreviation: 'UT' },
    ],
  },
  HND: {
    regions: [
      { name: 'Atlántida', abbreviation: 'AT' },
      { name: 'Choluteca', abbreviation: 'CH' },
      { name: 'Colón', abbreviation: 'CL' },
      { name: 'Comayagua', abbreviation: 'CM' },
      { name: 'Copán', abbreviation: 'CP' },
      { name: 'Cortés', abbreviation: 'CR' },
      { name: 'El Paraíso', abbreviation: 'EP' },
      { name: 'Francisco Morazán', abbreviation: 'FM' },
      { name: 'Gracias a Dios', abbreviation: 'GD' },
      { name: 'Islas de la Bahía', abbreviation: 'IB' },
      { name: 'Intibucá', abbreviation: 'IN' },
      { name: 'Lempira', abbreviation: 'LE' },
      { name: 'La Paz', abbreviation: 'LP' },
      { name: 'Ocotepeque', abbreviation: 'OC' },
      { name: 'Olancho', abbreviation: 'OL' },
      { name: 'Santa Bárbara', abbreviation: 'SB' },
      { name: 'Valle', abbreviation: 'VA' },
      { name: 'Yoro', abbreviation: 'YO' },
    ],
  },
  HRV: {
    regions: [
      { name: 'Zagrebačka županija', abbreviation: '01' },
      { name: 'Krapinsko-zagorska županija', abbreviation: '02' },
      { name: 'Sisačko-moslavačka županija', abbreviation: '03' },
      { name: 'Karlovačka županija', abbreviation: '04' },
      { name: 'Varaždinska županija', abbreviation: '05' },
      { name: 'Koprivničko-križevačka županija', abbreviation: '06' },
      { name: 'Bjelovarsko-bilogorska županija', abbreviation: '07' },
      { name: 'Primorsko-goranska županija', abbreviation: '08' },
      { name: 'Ličko-senjska županija', abbreviation: '09' },
      { name: 'Virovitičko-podravska županija', abbreviation: '10' },
      { name: 'Požeško-slavonska županija', abbreviation: '11' },
      { name: 'Brodsko-posavska županija', abbreviation: '12' },
      { name: 'Zadarska županija', abbreviation: '13' },
      { name: 'Osječko-baranjska županija', abbreviation: '14' },
      { name: 'Šibensko-kninska županija', abbreviation: '15' },
      { name: 'Vukovarsko-srijemska županija', abbreviation: '16' },
      { name: 'Splitsko-dalmatinska županija', abbreviation: '17' },
      { name: 'Istarska županija', abbreviation: '18' },
      { name: 'Dubrovačko-neretvanska županija', abbreviation: '19' },
      { name: 'Međimurska županija', abbreviation: '20' },
      { name: 'Grad Zagreb', abbreviation: '21' },
    ],
  },
  HTI: {
    regions: [
      { name: 'Artibonite', abbreviation: 'AR' },
      { name: 'Centre', abbreviation: 'CE' },
      { name: 'Grande’Anse', abbreviation: 'GA' },
      { name: 'Nord', abbreviation: 'ND' },
      { name: 'Nord-Est', abbreviation: 'NE' },
      { name: 'Nippes', abbreviation: 'NI' },
      { name: 'Nord-Ouest', abbreviation: 'NO' },
      { name: 'Ouest', abbreviation: 'OU' },
      { name: 'Sud', abbreviation: 'SD' },
      { name: 'Sud-Est', abbreviation: 'SE' },
    ],
  },
  HUN: {
    regions: [
      { name: 'Baranya', abbreviation: 'BA' },
      { name: 'Békés', abbreviation: 'BE' },
      { name: 'Bács-Kiskun', abbreviation: 'BK' },
      { name: 'Borsod-Abaúj-Zemplén', abbreviation: 'BZ' },
      { name: 'Csongrád', abbreviation: 'CS' },
      { name: 'Fejér', abbreviation: 'FE' },
      { name: 'Győr-Moson-Sopron', abbreviation: 'GS' },
      { name: 'Hajdú-Bihar', abbreviation: 'HB' },
      { name: 'Heves', abbreviation: 'HE' },
      { name: 'Jász-Nagykun-Szolnok', abbreviation: 'JN' },
      { name: 'Komárom-Esztergom', abbreviation: 'KE' },
      { name: 'Nógrád', abbreviation: 'NO' },
      { name: 'Pest', abbreviation: 'PE' },
      { name: 'Somogy', abbreviation: 'SO' },
      { name: 'Szabolcs-Szatmár-Bereg', abbreviation: 'SZ' },
      { name: 'Tolna', abbreviation: 'TO' },
      { name: 'Vas', abbreviation: 'VA' },
      { name: 'Veszprém', abbreviation: 'VE' },
      { name: 'Zala', abbreviation: 'ZA' },
      { name: 'Békéscsaba', abbreviation: 'BC' },
      { name: 'Debrecen', abbreviation: 'DE' },
      { name: 'Dunaújváros', abbreviation: 'DU' },
      { name: 'Eger', abbreviation: 'EG' },
      { name: 'Érd', abbreviation: 'ER' },
      { name: 'Győr', abbreviation: 'GY' },
      { name: 'Hódmezővásárhely', abbreviation: 'HV' },
      { name: 'Kecskemét', abbreviation: 'KM' },
      { name: 'Kaposvár', abbreviation: 'KV' },
      { name: 'Miskolc', abbreviation: 'MI' },
      { name: 'Nagykanizsa', abbreviation: 'NK' },
      { name: 'Nyíregyháza', abbreviation: 'NY' },
      { name: 'Pécs', abbreviation: 'PS' },
      { name: 'Szeged', abbreviation: 'SD' },
      { name: 'Székesfehérvár', abbreviation: 'SF' },
      { name: 'Szombathely', abbreviation: 'SH' },
      { name: 'Szolnok', abbreviation: 'SK' },
      { name: 'Sopron', abbreviation: 'SN' },
      { name: 'Szekszárd', abbreviation: 'SS' },
      { name: 'Salgótarján', abbreviation: 'ST' },
      { name: 'Tatabánya', abbreviation: 'TB' },
      { name: 'Veszprém', abbreviation: 'VM' },
      { name: 'Zalaegerszeg', abbreviation: 'ZE' },
      { name: 'Budapest', abbreviation: 'BU' },
    ],
  },
  IDN: {
    regions: [
      { name: 'Jawa', abbreviation: 'JW' },
      { name: 'Banten', abbreviation: 'BT' },
      { name: 'Jawa Barat', abbreviation: 'JB' },
      { name: 'Jawa Timur', abbreviation: 'JI' },
      { name: 'Jawa Tengah', abbreviation: 'JT' },
      { name: 'Yogyakarta', abbreviation: 'YO' },
      { name: 'Jakarta Raya', abbreviation: 'JK' },
      { name: 'Kalimantan', abbreviation: 'KA' },
      { name: 'Kalimantan Barat', abbreviation: 'KB' },
      { name: 'Kalimantan Timur', abbreviation: 'KI' },
      { name: 'Kalimantan Selatan', abbreviation: 'KS' },
      { name: 'Kalimantan Tengah', abbreviation: 'KT' },
      { name: 'Kalimantan Utara', abbreviation: 'KU' },
      { name: 'Maluku', abbreviation: 'ML' },
      { name: 'Maluku', abbreviation: 'MA' },
      { name: 'Maluku Utara', abbreviation: 'MU' },
      { name: 'Nusa Tenggara', abbreviation: 'NU' },
      { name: 'Bali', abbreviation: 'BA' },
      { name: 'Nusa Tenggara Barat', abbreviation: 'NB' },
      { name: 'Nusa Tenggara Timur', abbreviation: 'NT' },
      { name: 'Papua', abbreviation: 'PP' },
      { name: 'Papua', abbreviation: 'PA' },
      { name: 'Papua Barat', abbreviation: 'PB' },
      { name: 'Sulawesi', abbreviation: 'SL' },
      { name: 'Gorontalo', abbreviation: 'GO' },
      { name: 'Sulawesi Utara', abbreviation: 'SA' },
      { name: 'Sulawesi Tenggara', abbreviation: 'SG' },
      { name: 'Sulawesi Selatan', abbreviation: 'SN' },
      { name: 'Sulawesi Barat', abbreviation: 'SR' },
      { name: 'Sulawesi Tengah', abbreviation: 'ST' },
      { name: 'Sumatera', abbreviation: 'SM' },
      { name: 'Aceh', abbreviation: 'AC' },
      { name: 'Kepulauan Bangka Belitung', abbreviation: 'BB' },
      { name: 'Bengkulu', abbreviation: 'BE' },
      { name: 'Jambi', abbreviation: 'JA' },
      { name: 'Kepulauan Riau', abbreviation: 'KR' },
      { name: 'Lampung', abbreviation: 'LA' },
      { name: 'Riau', abbreviation: 'RI' },
      { name: 'Sumatera Barat', abbreviation: 'SB' },
      { name: 'Sumatera Selatan', abbreviation: 'SS' },
      { name: 'Sumatera Utara', abbreviation: 'SU' },
    ],
  },
  IND: {
    postalCodeLabel: 'PIN',
    regionLabel: 'State',
    regions: [
      { name: 'Andaman and Nicobar Islands', abbreviation: 'AN' },
      { name: 'Andhra Pradesh', abbreviation: 'AP' },
      { name: 'Arunachal Pradesh', abbreviation: 'AR' },
      { name: 'Assam', abbreviation: 'AS' },
      { name: 'Bihar', abbreviation: 'BR' },
      { name: 'Chandigarh', abbreviation: 'CH' },
      { name: 'Chhattisgarh', abbreviation: 'CT' },
      { name: 'Dadra and Nagar Haveli', abbreviation: 'DN' },
      { name: 'Daman and Diu', abbreviation: 'DD' },
      { name: 'Delhi', abbreviation: 'DL' },
      { name: 'Goa', abbreviation: 'GA' },
      { name: 'Gujarat', abbreviation: 'GJ' },
      { name: 'Haryana', abbreviation: 'HR' },
      { name: 'Himachal Pradesh', abbreviation: 'HP' },
      { name: 'Jammu and Kashmir', abbreviation: 'JK' },
      { name: 'Jharkhand', abbreviation: 'JH' },
      { name: 'Karnataka', abbreviation: 'KA' },
      { name: 'Kerala', abbreviation: 'KL' },
      { name: 'Lakshadweep', abbreviation: 'LD' },
      { name: 'Madhya Pradesh', abbreviation: 'MP' },
      { name: 'Maharashtra', abbreviation: 'MH' },
      { name: 'Manipur', abbreviation: 'MN' },
      { name: 'Meghalaya', abbreviation: 'ML' },
      { name: 'Mizoram', abbreviation: 'MZ' },
      { name: 'Nagaland', abbreviation: 'NL' },
      { name: 'Odisha', abbreviation: 'OR' },
      { name: 'Puducherry', abbreviation: 'PY' },
      { name: 'Punjab', abbreviation: 'PB' },
      { name: 'Rajasthan', abbreviation: 'RJ' },
      { name: 'Sikkim', abbreviation: 'SK' },
      { name: 'Tamil Nadu', abbreviation: 'TN' },
      { name: 'Telangana', abbreviation: 'TG' },
      { name: 'Tripura', abbreviation: 'TR' },
      { name: 'Uttar Pradesh', abbreviation: 'UP' },
      { name: 'Uttarakhand', abbreviation: 'UT' },
      { name: 'West Bengal', abbreviation: 'WB' },
    ],
  },
  IRL: {
    postalCodeLabel: 'Eircode',
    regionLabel: 'County',
    regions: [
      { name: 'Carlow', abbreviation: 'CW' },
      { name: 'Cavan', abbreviation: 'CN' },
      { name: 'Clare', abbreviation: 'CE' },
      { name: 'Connacht', abbreviation: 'C' },
      { name: 'Cork', abbreviation: 'CO' },
      { name: 'Donegal', abbreviation: 'DL' },
      { name: 'Dublin', abbreviation: 'D' },
      { name: 'Galway', abbreviation: 'G' },
      { name: 'Kerry', abbreviation: 'KY' },
      { name: 'Kildare', abbreviation: 'KE' },
      { name: 'Kilkenny', abbreviation: 'KK' },
      { name: 'Laois', abbreviation: 'LS' },
      { name: 'Leinster', abbreviation: 'L' },
      { name: 'Leitrim', abbreviation: 'LM' },
      { name: 'Limerick', abbreviation: 'LK' },
      { name: 'Longford', abbreviation: 'LD' },
      { name: 'Louth', abbreviation: 'LH' },
      { name: 'Mayo', abbreviation: 'MO' },
      { name: 'Meath', abbreviation: 'MH' },
      { name: 'Monaghan', abbreviation: 'MN' },
      { name: 'Munster', abbreviation: 'M' },
      { name: 'Offaly', abbreviation: 'OY' },
      { name: 'Roscommon', abbreviation: 'RN' },
      { name: 'Sligo', abbreviation: 'SO' },
      { name: 'Tipperary', abbreviation: 'TA' },
      { name: 'Ulster', abbreviation: 'U' },
      { name: 'Waterford', abbreviation: 'WD' },
      { name: 'Westmeath', abbreviation: 'WH' },
      { name: 'Wexford', abbreviation: 'WX' },
      { name: 'Wicklow', abbreviation: 'WW' },
    ],
  },
  IRN: {
    regions: [
      { name: 'Āz̄ārbāyjān-e Shārqī', abbreviation: '01' },
      { name: 'Āz̄ārbāyjān-e Ghārbī', abbreviation: '02' },
      { name: 'Ardabīl', abbreviation: '03' },
      { name: 'Eşfahān', abbreviation: '04' },
      { name: 'Īlām', abbreviation: '05' },
      { name: 'Būshehr', abbreviation: '06' },
      { name: 'Tehrān', abbreviation: '07' },
      { name: 'Chahār Maḩāl va Bakhtīārī', abbreviation: '08' },
      { name: 'Khūzestān', abbreviation: '10' },
      { name: 'Zanjān', abbreviation: '11' },
      { name: 'Semnān', abbreviation: '12' },
      { name: 'Sīstān va Balūchestān', abbreviation: '13' },
      { name: 'Fārs', abbreviation: '14' },
      { name: 'Kermān', abbreviation: '15' },
      { name: 'Kordestān', abbreviation: '16' },
      { name: 'Kermānshāh', abbreviation: '17' },
      { name: 'Kohgīlūyeh va Bowyer Aḩmad', abbreviation: '18' },
      { name: 'Gīlān', abbreviation: '19' },
      { name: 'Lorestān', abbreviation: '20' },
      { name: 'Māzandarān', abbreviation: '21' },
      { name: 'Markazī', abbreviation: '22' },
      { name: 'Hormozgān', abbreviation: '23' },
      { name: 'Hamadān', abbreviation: '24' },
      { name: 'Yazd', abbreviation: '25' },
      { name: 'Qom', abbreviation: '26' },
      { name: 'Golestān', abbreviation: '27' },
      { name: 'Qazvīn', abbreviation: '28' },
      { name: 'Khorāsān-e Jonūbī', abbreviation: '29' },
      { name: 'Khorāsān-e Raẕavī', abbreviation: '30' },
      { name: 'Khorāsān-e Shomālī', abbreviation: '31' },
      { name: 'Alborz', abbreviation: '32' },
    ],
  },
  IRQ: {
    regions: [
      { name: 'Al Anbār', abbreviation: 'AN' },
      { name: 'Arbīl', abbreviation: 'AR' },
      { name: 'Al Başrah', abbreviation: 'BA' },
      { name: 'Bābil', abbreviation: 'BB' },
      { name: 'Baghdād', abbreviation: 'BG' },
      { name: 'Dahūk', abbreviation: 'DA' },
      { name: 'Diyālá', abbreviation: 'DI' },
      { name: 'Dhī Qār', abbreviation: 'DQ' },
      { name: 'Karbalā’', abbreviation: 'KA' },
      { name: 'Kirkūk', abbreviation: 'KI' },
      { name: 'Maysān', abbreviation: 'MA' },
      { name: 'Al Muthanná', abbreviation: 'MU' },
      { name: 'An Najaf', abbreviation: 'NA' },
      { name: 'Nīnawá', abbreviation: 'NI' },
      { name: 'Al Qādisīyah', abbreviation: 'QA' },
      { name: 'Şalāḩ ad Dīn', abbreviation: 'SD' },
      { name: 'As Sulaymānīyah', abbreviation: 'SU' },
      { name: 'Wāsiţ', abbreviation: 'WA' },
    ],
  },
  ISL: {
    regions: [
      { name: 'Höfuðborgarsvæði', abbreviation: '1' },
      { name: 'Suðurnes', abbreviation: '2' },
      { name: 'Vesturland', abbreviation: '3' },
      { name: 'Vestfirðir', abbreviation: '4' },
      { name: 'Norðurland vestra', abbreviation: '5' },
      { name: 'Norðurland eystra', abbreviation: '6' },
      { name: 'Austurland', abbreviation: '7' },
      { name: 'Suðurland', abbreviation: '8' },
    ],
  },
  ISR: {
    regions: [
      { name: 'Al Janūbī', abbreviation: 'D' },
      { name: 'Ḩayfā', abbreviation: 'HA' },
      { name: 'Al Quds', abbreviation: 'JM' },
      { name: 'Al Awsaţ', abbreviation: 'M' },
      { name: 'Tall Abīb', abbreviation: 'TA' },
      { name: 'Ash Shamālī', abbreviation: 'Z' },
    ],
  },
  ITA: {
    postalCodeLabel: 'Postal Code',
    regionLabel: 'Province',
    regions: [
      { name: 'Abruzzo', abbreviation: '65' },
      { name: 'Agrigento', abbreviation: 'AG' },
      { name: 'Alessandria', abbreviation: 'AL' },
      { name: 'Ancona', abbreviation: 'AN' },
      { name: 'Aosta', abbreviation: 'AO' },
      { name: 'Arezzo', abbreviation: 'AR' },
      { name: 'Ascoli Piceno', abbreviation: 'AP' },
      { name: 'Asti', abbreviation: 'AT' },
      { name: 'Avellino', abbreviation: 'AV' },
      { name: 'Bari', abbreviation: 'BA' },
      { name: 'Barletta-Andria-Trani', abbreviation: 'BT' },
      { name: 'Basilicata', abbreviation: '77' },
      { name: 'Belluno', abbreviation: 'BL' },
      { name: 'Benevento', abbreviation: 'BN' },
      { name: 'Bergamo', abbreviation: 'BG' },
      { name: 'Biella', abbreviation: 'BI' },
      { name: 'Bologna', abbreviation: 'BO' },
      { name: 'Bolzano', abbreviation: 'BZ' },
      { name: 'Brescia', abbreviation: 'BS' },
      { name: 'Brindisi', abbreviation: 'BR' },
      { name: 'Cagliari', abbreviation: 'CA' },
      { name: 'Calabria', abbreviation: '78' },
      { name: 'Caltanissetta', abbreviation: 'CL' },
      { name: 'Campania', abbreviation: '72' },
      { name: 'Campobasso', abbreviation: 'CB' },
      { name: 'Carbonia-Iglesias', abbreviation: 'CI' },
      { name: 'Caserta', abbreviation: 'CE' },
      { name: 'Catania', abbreviation: 'CT' },
      { name: 'Catanzaro', abbreviation: 'CZ' },
      { name: 'Chieti', abbreviation: 'CH' },
      { name: 'Como', abbreviation: 'CO' },
      { name: 'Cosenza', abbreviation: 'CS' },
      { name: 'Cremona', abbreviation: 'CR' },
      { name: 'Crotone', abbreviation: 'KR' },
      { name: 'Cuneo', abbreviation: 'CN' },
      { name: 'Emilia-Romagna', abbreviation: '45' },
      { name: 'Enna', abbreviation: 'EN' },
      { name: 'Fermo', abbreviation: 'FM' },
      { name: 'Ferrara', abbreviation: 'FE' },
      { name: 'Firenze', abbreviation: 'FI' },
      { name: 'Foggia', abbreviation: 'FG' },
      { name: 'Forlì-Cesena', abbreviation: 'FC' },
      { name: 'Friuli-Venezia Giulia', abbreviation: '36' },
      { name: 'Frosinone', abbreviation: 'FR' },
      { name: 'Genova', abbreviation: 'GE' },
      { name: 'Gorizia', abbreviation: 'GO' },
      { name: 'Grosseto', abbreviation: 'GR' },
      { name: 'Imperia', abbreviation: 'IM' },
      { name: 'Isernia', abbreviation: 'IS' },
      { name: "L'Aquila", abbreviation: 'AQ' },
      { name: 'La Spezia', abbreviation: 'SP' },
      { name: 'Latina', abbreviation: 'LT' },
      { name: 'Lazio', abbreviation: '62' },
      { name: 'Lecce', abbreviation: 'LE' },
      { name: 'Lecco', abbreviation: 'LC' },
      { name: 'Liguria', abbreviation: '42' },
      { name: 'Livorno', abbreviation: 'LI' },
      { name: 'Lodi', abbreviation: 'LO' },
      { name: 'Lombardia', abbreviation: '25' },
      { name: 'Lucca', abbreviation: 'LU' },
      { name: 'Macerata', abbreviation: 'MC' },
      { name: 'Mantova', abbreviation: 'MN' },
      { name: 'Marche', abbreviation: '57' },
      { name: 'Massa-Carrara', abbreviation: 'MS' },
      { name: 'Matera', abbreviation: 'MT' },
      { name: 'Medio Campidano', abbreviation: 'VS' },
      { name: 'Messina', abbreviation: 'ME' },
      { name: 'Milano', abbreviation: 'MI' },
      { name: 'Modena', abbreviation: 'MO' },
      { name: 'Molise', abbreviation: '67' },
      { name: 'Monza e Brianza', abbreviation: 'MB' },
      { name: 'Napoli', abbreviation: 'NA' },
      { name: 'Novara', abbreviation: 'NO' },
      { name: 'Nuoro', abbreviation: 'NU' },
      { name: 'Ogliastra', abbreviation: 'OG' },
      { name: 'Olbia-Tempio', abbreviation: 'OT' },
      { name: 'Oristano', abbreviation: 'OR' },
      { name: 'Padova', abbreviation: 'PD' },
      { name: 'Palermo', abbreviation: 'PA' },
      { name: 'Parma', abbreviation: 'PR' },
      { name: 'Pavia', abbreviation: 'PV' },
      { name: 'Perugia', abbreviation: 'PG' },
      { name: 'Pesaro e Urbino', abbreviation: 'PU' },
      { name: 'Pescara', abbreviation: 'PE' },
      { name: 'Piacenza', abbreviation: 'PC' },
      { name: 'Piemonte', abbreviation: '21' },
      { name: 'Pisa', abbreviation: 'PI' },
      { name: 'Pistoia', abbreviation: 'PT' },
      { name: 'Pordenone', abbreviation: 'PN' },
      { name: 'Potenza', abbreviation: 'PZ' },
      { name: 'Prato', abbreviation: 'PO' },
      { name: 'Puglia', abbreviation: '75' },
      { name: 'Ragusa', abbreviation: 'RG' },
      { name: 'Ravenna', abbreviation: 'RA' },
      { name: 'Reggio Calabria', abbreviation: 'RC' },
      { name: 'Reggio Emilia', abbreviation: 'RE' },
      { name: 'Rieti', abbreviation: 'RI' },
      { name: 'Rimini', abbreviation: 'RN' },
      { name: 'Roma', abbreviation: 'RM' },
      { name: 'Rovigo', abbreviation: 'RO' },
      { name: 'Salerno', abbreviation: 'SA' },
      { name: 'Sardegna', abbreviation: '88' },
      { name: 'Sassari', abbreviation: 'SS' },
      { name: 'Savona', abbreviation: 'SV' },
      { name: 'Sicilia', abbreviation: '82' },
      { name: 'Siena', abbreviation: 'SI' },
      { name: 'Siracusa', abbreviation: 'SR' },
      { name: 'Sondrio', abbreviation: 'SO' },
      { name: 'Taranto', abbreviation: 'TA' },
      { name: 'Teramo', abbreviation: 'TE' },
      { name: 'Terni', abbreviation: 'TR' },
      { name: 'Torino', abbreviation: 'TO' },
      { name: 'Toscana', abbreviation: '52' },
      { name: 'Trapani', abbreviation: 'TP' },
      { name: 'Trentino-Alto Adige', abbreviation: '32' },
      { name: 'Trento', abbreviation: 'TN' },
      { name: 'Treviso', abbreviation: 'TV' },
      { name: 'Trieste', abbreviation: 'TS' },
      { name: 'Udine', abbreviation: 'UD' },
      { name: 'Umbria', abbreviation: '55' },
      { name: "Valle d'Aosta", abbreviation: '23' },
      { name: 'Varese', abbreviation: 'VA' },
      { name: 'Veneto', abbreviation: '34' },
      { name: 'Venezia', abbreviation: 'VE' },
      { name: 'Verbano-Cusio-Ossola', abbreviation: 'VB' },
      { name: 'Vercelli', abbreviation: 'VC' },
      { name: 'Verona', abbreviation: 'VR' },
      { name: 'Vibo Valentia', abbreviation: 'VV' },
      { name: 'Vicenza', abbreviation: 'VI' },
      { name: 'Viterbo', abbreviation: 'VT' },
    ],
  },
  JAM: {
    regions: [
      { name: 'Kingston', abbreviation: '01' },
      { name: 'Saint Andrew', abbreviation: '02' },
      { name: 'Saint Thomas', abbreviation: '03' },
      { name: 'Portland', abbreviation: '04' },
      { name: 'Saint Mary', abbreviation: '05' },
      { name: 'Saint Ann', abbreviation: '06' },
      { name: 'Trelawny', abbreviation: '07' },
      { name: 'Saint James', abbreviation: '08' },
      { name: 'Hanover', abbreviation: '09' },
      { name: 'Westmoreland', abbreviation: '10' },
      { name: 'Saint Elizabeth', abbreviation: '11' },
      { name: 'Manchester', abbreviation: '12' },
      { name: 'Clarendon', abbreviation: '13' },
      { name: 'Saint Catherine', abbreviation: '14' },
    ],
  },
  JOR: {
    regions: [
      { name: '‘Ajlūn', abbreviation: 'AJ' },
      { name: 'Al ‘A̅şimah', abbreviation: 'AM' },
      { name: 'Al ‘Aqabah', abbreviation: 'AQ' },
      { name: 'Aţ Ţafīlah', abbreviation: 'AT' },
      { name: 'Az Zarqā’', abbreviation: 'AZ' },
      { name: 'Al Balqā’', abbreviation: 'BA' },
      { name: 'Irbid', abbreviation: 'IR' },
      { name: 'Jarash', abbreviation: 'JA' },
      { name: 'Al Karak', abbreviation: 'KA' },
      { name: 'Al Mafraq', abbreviation: 'MA' },
      { name: 'Mādabā', abbreviation: 'MD' },
      { name: 'Ma‘ān', abbreviation: 'MN' },
    ],
  },
  JPN: {
    regions: [
      { name: 'Hokkaido', abbreviation: '01' },
      { name: 'Aomori', abbreviation: '02' },
      { name: 'Iwate', abbreviation: '03' },
      { name: 'Miyagi', abbreviation: '04' },
      { name: 'Akita', abbreviation: '05' },
      { name: 'Yamagata', abbreviation: '06' },
      { name: 'Fukushima', abbreviation: '07' },
      { name: 'Ibaraki', abbreviation: '08' },
      { name: 'Tochigi', abbreviation: '09' },
      { name: 'Gunma', abbreviation: '10' },
      { name: 'Saitama', abbreviation: '11' },
      { name: 'Chiba', abbreviation: '12' },
      { name: 'Tokyo', abbreviation: '13' },
      { name: 'Kanagawa', abbreviation: '14' },
      { name: 'Niigata', abbreviation: '15' },
      { name: 'Toyama', abbreviation: '16' },
      { name: 'Ishikawa', abbreviation: '17' },
      { name: 'Fukui', abbreviation: '18' },
      { name: 'Yamanashi', abbreviation: '19' },
      { name: 'Nagano', abbreviation: '20' },
      { name: 'Gifu', abbreviation: '21' },
      { name: 'Shizuoka', abbreviation: '22' },
      { name: 'Aichi', abbreviation: '23' },
      { name: 'Mie', abbreviation: '24' },
      { name: 'Shiga', abbreviation: '25' },
      { name: 'Kyoto', abbreviation: '26' },
      { name: 'Osaka', abbreviation: '27' },
      { name: 'Hyogo', abbreviation: '28' },
      { name: 'Nara', abbreviation: '29' },
      { name: 'Wakayama', abbreviation: '30' },
      { name: 'Tottori', abbreviation: '31' },
      { name: 'Shimane', abbreviation: '32' },
      { name: 'Okayama', abbreviation: '33' },
      { name: 'Hiroshima', abbreviation: '34' },
      { name: 'Yamaguchi', abbreviation: '35' },
      { name: 'Tokushima', abbreviation: '36' },
      { name: 'Kagawa', abbreviation: '37' },
      { name: 'Ehime', abbreviation: '38' },
      { name: 'Kochi', abbreviation: '39' },
      { name: 'Fukuoka', abbreviation: '40' },
      { name: 'Saga', abbreviation: '41' },
      { name: 'Nagasaki', abbreviation: '42' },
      { name: 'Kumamoto', abbreviation: '43' },
      { name: 'Oita', abbreviation: '44' },
      { name: 'Miyazaki', abbreviation: '45' },
      { name: 'Kagoshima', abbreviation: '46' },
      { name: 'Okinawa', abbreviation: '47' },
    ],
  },
  KAZ: {
    regions: [
      { name: 'Aqmola oblysy', abbreviation: 'AKM' },
      { name: 'Aqtöbe oblysy', abbreviation: 'AKT' },
      { name: 'Almaty oblysy', abbreviation: 'ALM' },
      { name: 'Atyraū oblysy', abbreviation: 'ATY' },
      { name: 'Qaraghandy oblysy', abbreviation: 'KAR' },
      { name: 'Qostanay oblysy', abbreviation: 'KUS' },
      { name: 'Qyzylorda oblysy', abbreviation: 'KZY' },
      { name: 'Mangghystaū oblysy', abbreviation: 'MAN' },
      { name: 'Pavlodar oblysy', abbreviation: 'PAV' },
      { name: 'Soltüstik Qazaqstan oblysy', abbreviation: 'SEV' },
      { name: 'Shyghys Qazaqstan oblysy', abbreviation: 'VOS' },
      { name: 'Türkistan oblysy', abbreviation: 'YUZ' },
      { name: 'Batys Qazaqstan oblysy', abbreviation: 'ZAP' },
      { name: 'Zhambyl oblysy', abbreviation: 'ZHA' },
      { name: 'Almaty', abbreviation: 'ALA' },
      { name: 'Astana', abbreviation: 'AST' },
      { name: 'Bayqongyr', abbreviation: 'BAY' },
      { name: 'Shymkent', abbreviation: 'SHY' },
    ],
  },
  KEN: {
    regions: [
      { name: 'Baringo', abbreviation: '01' },
      { name: 'Bomet', abbreviation: '02' },
      { name: 'Bungoma', abbreviation: '03' },
      { name: 'Busia', abbreviation: '04' },
      { name: 'Elgeyo/Marakwet', abbreviation: '05' },
      { name: 'Embu', abbreviation: '06' },
      { name: 'Garissa', abbreviation: '07' },
      { name: 'Homa Bay', abbreviation: '08' },
      { name: 'Isiolo', abbreviation: '09' },
      { name: 'Kajiado', abbreviation: '10' },
      { name: 'Kakamega', abbreviation: '11' },
      { name: 'Kericho', abbreviation: '12' },
      { name: 'Kiambu', abbreviation: '13' },
      { name: 'Kilifi', abbreviation: '14' },
      { name: 'Kirinyaga', abbreviation: '15' },
      { name: 'Kisii', abbreviation: '16' },
      { name: 'Kisumu', abbreviation: '17' },
      { name: 'Kitui', abbreviation: '18' },
      { name: 'Kwale', abbreviation: '19' },
      { name: 'Laikipia', abbreviation: '20' },
      { name: 'Lamu', abbreviation: '21' },
      { name: 'Machakos', abbreviation: '22' },
      { name: 'Makueni', abbreviation: '23' },
      { name: 'Mandera', abbreviation: '24' },
      { name: 'Marsabit', abbreviation: '25' },
      { name: 'Meru', abbreviation: '26' },
      { name: 'Migori', abbreviation: '27' },
      { name: 'Mombasa', abbreviation: '28' },
      { name: "Murang'a", abbreviation: '29' },
      { name: 'Nairobi City', abbreviation: '30' },
      { name: 'Nakuru', abbreviation: '31' },
      { name: 'Nandi', abbreviation: '32' },
      { name: 'Narok', abbreviation: '33' },
      { name: 'Nyamira', abbreviation: '34' },
      { name: 'Nyandarua', abbreviation: '35' },
      { name: 'Nyeri', abbreviation: '36' },
      { name: 'Samburu', abbreviation: '37' },
      { name: 'Siaya', abbreviation: '38' },
      { name: 'Taita/Taveta', abbreviation: '39' },
      { name: 'Tana River', abbreviation: '40' },
      { name: 'Tharaka-Nithi', abbreviation: '41' },
      { name: 'Trans Nzoia', abbreviation: '42' },
      { name: 'Turkana', abbreviation: '43' },
      { name: 'Uasin Gishu', abbreviation: '44' },
      { name: 'Vihiga', abbreviation: '45' },
      { name: 'Wajir', abbreviation: '46' },
      { name: 'West Pokot', abbreviation: '47' },
    ],
  },
  KGZ: {
    regions: [
      { name: 'Bishkek', abbreviation: 'GB' },
      { name: 'Osh', abbreviation: 'GO' },
      { name: 'Batken', abbreviation: 'B' },
      { name: 'Chüy', abbreviation: 'C' },
      { name: 'Jalal-Abad', abbreviation: 'J' },
      { name: 'Naryn', abbreviation: 'N' },
      { name: 'Osh', abbreviation: 'O' },
      { name: 'Talas', abbreviation: 'T' },
      { name: 'Ysyk-Köl', abbreviation: 'Y' },
    ],
  },
  KHM: {
    regions: [
      { name: 'Phnum Pénh', abbreviation: '12' },
      { name: 'Banteay Mean Chey', abbreviation: '1' },
      { name: 'Krâchéh', abbreviation: '10' },
      { name: 'Môndól Kiri', abbreviation: '11' },
      { name: 'Preăh Vihéar', abbreviation: '13' },
      { name: 'Prey Vêng', abbreviation: '14' },
      { name: 'Poŭthĭsăt', abbreviation: '15' },
      { name: 'Rotanak Kiri', abbreviation: '16' },
      { name: 'Siem Reab', abbreviation: '17' },
      { name: 'Preăh Sihanouk', abbreviation: '18' },
      { name: 'Stoĕng Trêng', abbreviation: '19' },
      { name: 'Baat Dambang', abbreviation: '2' },
      { name: 'Svay Riĕng', abbreviation: '20' },
      { name: 'Taakaev', abbreviation: '21' },
      { name: 'Ŏtdâr Méanchey', abbreviation: '22' },
      { name: 'Kaeb', abbreviation: '23' },
      { name: 'Pailĭn', abbreviation: '24' },
      { name: 'Tbong Khmum', abbreviation: '25' },
      { name: 'Kampong Chaam', abbreviation: '3' },
      { name: 'Kampong Chhnang', abbreviation: '4' },
      { name: 'Kampong Spueu', abbreviation: '5' },
      { name: 'Kâmpóng Thum', abbreviation: '6' },
      { name: 'Kampot', abbreviation: '7' },
      { name: 'Kandaal', abbreviation: '8' },
      { name: 'Kaoh Kong', abbreviation: '9' },
    ],
  },
  KIR: {
    regions: [
      { name: 'Gilbert Islands', abbreviation: 'G' },
      { name: 'Line Islands', abbreviation: 'L' },
      { name: 'Phoenix Islands', abbreviation: 'P' },
    ],
  },
  KNA: {
    regions: [
      { name: 'Saint Kitts', abbreviation: 'K' },
      { name: 'Christ Church Nichola Town', abbreviation: '01' },
      { name: 'Saint Anne Sandy Point', abbreviation: '02' },
      { name: 'Saint George Basseterre', abbreviation: '03' },
      { name: 'Saint John Capisterre', abbreviation: '06' },
      { name: 'Saint Mary Cayon', abbreviation: '08' },
      { name: 'Saint Paul Capisterre', abbreviation: '09' },
      { name: 'Saint Peter Basseterre', abbreviation: '11' },
      { name: 'Saint Thomas Middle Island', abbreviation: '13' },
      { name: 'Trinity Palmetto Point', abbreviation: '15' },
      { name: 'Nevis', abbreviation: 'N' },
      { name: 'Saint George Gingerland', abbreviation: '04' },
      { name: 'Saint James Windward', abbreviation: '05' },
      { name: 'Saint John Figtree', abbreviation: '07' },
      { name: 'Saint Paul Charlestown', abbreviation: '10' },
      { name: 'Saint Thomas Lowland', abbreviation: '12' },
    ],
  },
  KOR: {
    regions: [
      { name: 'Seoul-teukbyeolsi', abbreviation: '11' },
      { name: 'Busan-gwangyeoksi', abbreviation: '26' },
      { name: 'Daegu-gwangyeoksi', abbreviation: '27' },
      { name: 'Incheon-gwangyeoksi', abbreviation: '28' },
      { name: 'Gwangju-gwangyeoksi', abbreviation: '29' },
      { name: 'Daejeon-gwangyeoksi', abbreviation: '30' },
      { name: 'Ulsan-gwangyeoksi', abbreviation: '31' },
      { name: 'Gyeonggi-do', abbreviation: '41' },
      { name: 'Gangwon-do', abbreviation: '42' },
      { name: 'Chungcheongbuk-do', abbreviation: '43' },
      { name: 'Chungcheongnam-do', abbreviation: '44' },
      { name: 'Jeollabuk-do', abbreviation: '45' },
      { name: 'Jeollanam-do', abbreviation: '46' },
      { name: 'Gyeongsangbuk-do', abbreviation: '47' },
      { name: 'Gyeongsangnam-do', abbreviation: '48' },
      { name: 'Jeju-teukbyeoljachido', abbreviation: '49' },
      { name: 'Sejong', abbreviation: '50' },
    ],
  },
  KWT: {
    regions: [
      { name: 'Al Aḩmadī', abbreviation: 'AH' },
      { name: 'Al Farwānīyah', abbreviation: 'FA' },
      { name: 'Ḩawallī', abbreviation: 'HA' },
      { name: 'Al Jahrā’', abbreviation: 'JA' },
      { name: 'Al ‘Āşimah', abbreviation: 'KU' },
      { name: 'Mubārak al Kabīr', abbreviation: 'MU' },
    ],
  },
  LAO: {
    regions: [
      { name: 'Viangchan', abbreviation: 'VT' },
      { name: 'Attapu', abbreviation: 'AT' },
      { name: 'Bokèo', abbreviation: 'BK' },
      { name: 'Bolikhamxai', abbreviation: 'BL' },
      { name: 'Champasak', abbreviation: 'CH' },
      { name: 'Houaphan', abbreviation: 'HO' },
      { name: 'Khammouan', abbreviation: 'KH' },
      { name: 'Louang Namtha', abbreviation: 'LM' },
      { name: 'Louangphabang', abbreviation: 'LP' },
      { name: 'Oudômxai', abbreviation: 'OU' },
      { name: 'Phôngsali', abbreviation: 'PH' },
      { name: 'Salavan', abbreviation: 'SL' },
      { name: 'Savannakhét', abbreviation: 'SV' },
      { name: 'Viangchan', abbreviation: 'VI' },
      { name: 'Xaignabouli', abbreviation: 'XA' },
      { name: 'Xékong', abbreviation: 'XE' },
      { name: 'Xiangkhouang', abbreviation: 'XI' },
      { name: 'Xaisômboun', abbreviation: 'XS' },
    ],
  },
  LBN: {
    regions: [
      { name: '‘Akkār', abbreviation: 'AK' },
      { name: 'Ash Shimāl', abbreviation: 'AS' },
      { name: 'Bayrūt', abbreviation: 'BA' },
      { name: 'B‘alabak-Al Hirmil', abbreviation: 'BH' },
      { name: 'Béqaa', abbreviation: 'BI' },
      { name: 'Al Janūb', abbreviation: 'JA' },
      { name: 'Mont-Liban', abbreviation: 'JL' },
      { name: 'Nabatîyé', abbreviation: 'NA' },
    ],
  },
  LBR: {
    regions: [
      { name: 'Bong', abbreviation: 'BG' },
      { name: 'Bomi', abbreviation: 'BM' },
      { name: 'Grand Cape Mount', abbreviation: 'CM' },
      { name: 'Grand Bassa', abbreviation: 'GB' },
      { name: 'Grand Gedeh', abbreviation: 'GG' },
      { name: 'Grand Kru', abbreviation: 'GK' },
      { name: 'Gbarpolu', abbreviation: 'GP' },
      { name: 'Lofa', abbreviation: 'LO' },
      { name: 'Margibi', abbreviation: 'MG' },
      { name: 'Montserrado', abbreviation: 'MO' },
      { name: 'Maryland', abbreviation: 'MY' },
      { name: 'Nimba', abbreviation: 'NI' },
      { name: 'River Gee', abbreviation: 'RG' },
      { name: 'River Cess', abbreviation: 'RI' },
      { name: 'Sinoe', abbreviation: 'SI' },
    ],
  },
  LBY: {
    regions: [
      { name: 'Banghāzī', abbreviation: 'BA' },
      { name: 'Al Buţnān', abbreviation: 'BU' },
      { name: 'Darnah', abbreviation: 'DR' },
      { name: 'Ghāt', abbreviation: 'GT' },
      { name: 'Al Jabal al Akhḑar', abbreviation: 'JA' },
      { name: 'Al Jabal al Gharbī', abbreviation: 'JG' },
      { name: 'Al Jafārah', abbreviation: 'JI' },
      { name: 'Al Jufrah', abbreviation: 'JU' },
      { name: 'Al Kufrah', abbreviation: 'KF' },
      { name: 'Al Marqab', abbreviation: 'MB' },
      { name: 'Mişrātah', abbreviation: 'MI' },
      { name: 'Al Marj', abbreviation: 'MJ' },
      { name: 'Murzuq', abbreviation: 'MQ' },
      { name: 'Nālūt', abbreviation: 'NL' },
      { name: 'An Nuqāţ al Khams', abbreviation: 'NQ' },
      { name: 'Sabhā', abbreviation: 'SB' },
      { name: 'Surt', abbreviation: 'SR' },
      { name: 'Ţarābulus', abbreviation: 'TB' },
      { name: 'Al Wāḩāt', abbreviation: 'WA' },
      { name: 'Wādī al Ḩayāt', abbreviation: 'WD' },
      { name: 'Wādī ash Shāţi’', abbreviation: 'WS' },
      { name: 'Az Zāwiyah', abbreviation: 'ZA' },
    ],
  },
  LCA: {
    regions: [
      { name: 'Anse la Raye', abbreviation: '01' },
      { name: 'Castries', abbreviation: '02' },
      { name: 'Choiseul', abbreviation: '03' },
      { name: 'Dennery', abbreviation: '05' },
      { name: 'Gros Islet', abbreviation: '06' },
      { name: 'Laborie', abbreviation: '07' },
      { name: 'Micoud', abbreviation: '08' },
      { name: 'Soufrière', abbreviation: '10' },
      { name: 'Vieux Fort', abbreviation: '11' },
      { name: 'Canaries', abbreviation: '12' },
    ],
  },
  LIE: {
    regions: [
      { name: 'Balzers', abbreviation: '01' },
      { name: 'Eschen', abbreviation: '02' },
      { name: 'Gamprin', abbreviation: '03' },
      { name: 'Mauren', abbreviation: '04' },
      { name: 'Planken', abbreviation: '05' },
      { name: 'Ruggell', abbreviation: '06' },
      { name: 'Schaan', abbreviation: '07' },
      { name: 'Schellenberg', abbreviation: '08' },
      { name: 'Triesen', abbreviation: '09' },
      { name: 'Triesenberg', abbreviation: '10' },
      { name: 'Vaduz', abbreviation: '11' },
    ],
  },
  LKA: {
    regions: [
      { name: 'Western Province', abbreviation: '1' },
      { name: 'Colombo', abbreviation: '11' },
      { name: 'Gampaha', abbreviation: '12' },
      { name: 'Kalutara', abbreviation: '13' },
      { name: 'Central Province', abbreviation: '2' },
      { name: 'Kandy', abbreviation: '21' },
      { name: 'Matale', abbreviation: '22' },
      { name: 'Nuwara Eliya', abbreviation: '23' },
      { name: 'Southern Province', abbreviation: '3' },
      { name: 'Galle', abbreviation: '31' },
      { name: 'Matara', abbreviation: '32' },
      { name: 'Hambantota', abbreviation: '33' },
      { name: 'Northern Province', abbreviation: '4' },
      { name: 'Jaffna', abbreviation: '41' },
      { name: 'Kilinochchi', abbreviation: '42' },
      { name: 'Mannar', abbreviation: '43' },
      { name: 'Vavuniya', abbreviation: '44' },
      { name: 'Mullaittivu', abbreviation: '45' },
      { name: 'Eastern Province', abbreviation: '5' },
      { name: 'Batticaloa', abbreviation: '51' },
      { name: 'Ampara', abbreviation: '52' },
      { name: 'Trincomalee', abbreviation: '53' },
      { name: 'North Western Province', abbreviation: '6' },
      { name: 'Kurunegala', abbreviation: '61' },
      { name: 'Puttalam', abbreviation: '62' },
      { name: 'North Central Province', abbreviation: '7' },
      { name: 'Anuradhapura', abbreviation: '71' },
      { name: 'Polonnaruwa', abbreviation: '72' },
      { name: 'Uva Province', abbreviation: '8' },
      { name: 'Badulla', abbreviation: '81' },
      { name: 'Monaragala', abbreviation: '82' },
      { name: 'Sabaragamuwa Province', abbreviation: '9' },
      { name: 'Ratnapura', abbreviation: '91' },
      { name: 'Kegalla', abbreviation: '92' },
    ],
  },
  LSO: {
    regions: [
      { name: 'Maseru', abbreviation: 'A' },
      { name: 'Butha-Buthe', abbreviation: 'B' },
      { name: 'Leribe', abbreviation: 'C' },
      { name: 'Berea', abbreviation: 'D' },
      { name: 'Mafeteng', abbreviation: 'E' },
      { name: "Mohale's Hoek", abbreviation: 'F' },
      { name: 'Quthing', abbreviation: 'G' },
      { name: "Qacha's Nek", abbreviation: 'H' },
      { name: 'Mokhotlong', abbreviation: 'J' },
      { name: 'Thaba-Tseka', abbreviation: 'K' },
    ],
  },
  LTU: {
    regions: [
      { name: 'Alytaus apskritis', abbreviation: 'AL' },
      { name: 'Klaipėdos apskritis', abbreviation: 'KL' },
      { name: 'Kauno apskritis', abbreviation: 'KU' },
      { name: 'Marijampolės apskritis', abbreviation: 'MR' },
      { name: 'Panevėžio apskritis', abbreviation: 'PN' },
      { name: 'Šiaulių apskritis', abbreviation: 'SA' },
      { name: 'Tauragės apskritis', abbreviation: 'TA' },
      { name: 'Telšių apskritis', abbreviation: 'TE' },
      { name: 'Utenos apskritis', abbreviation: 'UT' },
      { name: 'Vilniaus apskritis', abbreviation: 'VL' },
      { name: 'Alytaus miestas', abbreviation: '02' },
      { name: 'Kauno miestas', abbreviation: '15' },
      { name: 'Klaipėdos miestas', abbreviation: '20' },
      { name: 'Palangos miestas', abbreviation: '31' },
      { name: 'Panevėžio miestas', abbreviation: '32' },
      { name: 'Šiaulių miestas', abbreviation: '43' },
      { name: 'Vilniaus miestas', abbreviation: '57' },
      { name: 'Akmenė', abbreviation: '01' },
      { name: 'Alytus', abbreviation: '03' },
      { name: 'Anykščiai', abbreviation: '04' },
      { name: 'Biržai', abbreviation: '06' },
      { name: 'Ignalina', abbreviation: '09' },
      { name: 'Jonava', abbreviation: '10' },
      { name: 'Joniškis', abbreviation: '11' },
      { name: 'Jurbarkas', abbreviation: '12' },
      { name: 'Kaišiadorys', abbreviation: '13' },
      { name: 'Kaunas', abbreviation: '16' },
      { name: 'Kėdainiai', abbreviation: '18' },
      { name: 'Kelmė', abbreviation: '19' },
      { name: 'Klaipėda', abbreviation: '21' },
      { name: 'Kretinga', abbreviation: '22' },
      { name: 'Kupiškis', abbreviation: '23' },
      { name: 'Lazdijai', abbreviation: '24' },
      { name: 'Marijampolė', abbreviation: '25' },
      { name: 'Mažeikiai', abbreviation: '26' },
      { name: 'Molėtai', abbreviation: '27' },
      { name: 'Pakruojis', abbreviation: '30' },
      { name: 'Panevėžys', abbreviation: '33' },
      { name: 'Pasvalys', abbreviation: '34' },
      { name: 'Plungė', abbreviation: '35' },
      { name: 'Prienai', abbreviation: '36' },
      { name: 'Radviliškis', abbreviation: '37' },
      { name: 'Raseiniai', abbreviation: '38' },
      { name: 'Rokiškis', abbreviation: '40' },
      { name: 'Šakiai', abbreviation: '41' },
      { name: 'Šalčininkai', abbreviation: '42' },
      { name: 'Šiauliai', abbreviation: '44' },
      { name: 'Šilalė', abbreviation: '45' },
      { name: 'Šilutė', abbreviation: '46' },
      { name: 'Širvintos', abbreviation: '47' },
      { name: 'Skuodas', abbreviation: '48' },
      { name: 'Švenčionys', abbreviation: '49' },
      { name: 'Tauragė', abbreviation: '50' },
      { name: 'Telšiai', abbreviation: '51' },
      { name: 'Trakai', abbreviation: '52' },
      { name: 'Ukmergė', abbreviation: '53' },
      { name: 'Utena', abbreviation: '54' },
      { name: 'Varėna', abbreviation: '55' },
      { name: 'Vilkaviškis', abbreviation: '56' },
      { name: 'Vilnius', abbreviation: '58' },
      { name: 'Zarasai', abbreviation: '60' },
      { name: 'Birštono', abbreviation: '05' },
      { name: 'Druskininkai', abbreviation: '07' },
      { name: 'Elektrėnai', abbreviation: '08' },
      { name: 'Kalvarijos', abbreviation: '14' },
      { name: 'Kazlų Rūdos', abbreviation: '17' },
      { name: 'Neringa', abbreviation: '28' },
      { name: 'Pagėgiai', abbreviation: '29' },
      { name: 'Rietavo', abbreviation: '39' },
      { name: 'Visaginas', abbreviation: '59' },
    ],
  },
  LUX: {
    regions: [
      { name: 'Capellen', abbreviation: 'CA' },
      { name: 'Clerf', abbreviation: 'CL' },
      { name: 'Diekirch', abbreviation: 'DI' },
      { name: 'Echternach', abbreviation: 'EC' },
      { name: 'Esch an der Alzette', abbreviation: 'ES' },
      { name: 'Grevenmacher', abbreviation: 'GR' },
      { name: 'Luxemburg', abbreviation: 'LU' },
      { name: 'Mersch', abbreviation: 'ME' },
      { name: 'Redingen', abbreviation: 'RD' },
      { name: 'Remich', abbreviation: 'RM' },
      { name: 'Vianden', abbreviation: 'VD' },
      { name: 'Wiltz', abbreviation: 'WI' },
    ],
  },
  LVA: {
    regions: [
      { name: 'Aglonas novads', abbreviation: '001' },
      { name: 'Aizkraukles novads', abbreviation: '002' },
      { name: 'Aizputes novads', abbreviation: '003' },
      { name: 'Aknīstes novads', abbreviation: '004' },
      { name: 'Alojas novads', abbreviation: '005' },
      { name: 'Alsungas novads', abbreviation: '006' },
      { name: 'Alūksnes novads', abbreviation: '007' },
      { name: 'Amatas novads', abbreviation: '008' },
      { name: 'Apes novads', abbreviation: '009' },
      { name: 'Auces novads', abbreviation: '010' },
      { name: 'Ādažu novads', abbreviation: '011' },
      { name: 'Babītes novads', abbreviation: '012' },
      { name: 'Baldones novads', abbreviation: '013' },
      { name: 'Baltinavas novads', abbreviation: '014' },
      { name: 'Balvu novads', abbreviation: '015' },
      { name: 'Bauskas novads', abbreviation: '016' },
      { name: 'Beverīnas novads', abbreviation: '017' },
      { name: 'Brocēnu novads', abbreviation: '018' },
      { name: 'Burtnieku novads', abbreviation: '019' },
      { name: 'Carnikavas novads', abbreviation: '020' },
      { name: 'Cesvaines novads', abbreviation: '021' },
      { name: 'Cēsu novads', abbreviation: '022' },
      { name: 'Ciblas novads', abbreviation: '023' },
      { name: 'Dagdas novads', abbreviation: '024' },
      { name: 'Daugavpils novads', abbreviation: '025' },
      { name: 'Dobeles novads', abbreviation: '026' },
      { name: 'Dundagas novads', abbreviation: '027' },
      { name: 'Durbes novads', abbreviation: '028' },
      { name: 'Engures novads', abbreviation: '029' },
      { name: 'Ērgļu novads', abbreviation: '030' },
      { name: 'Garkalnes novads', abbreviation: '031' },
      { name: 'Grobiņas novads', abbreviation: '032' },
      { name: 'Gulbenes novads', abbreviation: '033' },
      { name: 'Iecavas novads', abbreviation: '034' },
      { name: 'Ikšķiles novads', abbreviation: '035' },
      { name: 'Ilūkstes novads', abbreviation: '036' },
      { name: 'Inčukalna novads', abbreviation: '037' },
      { name: 'Jaunjelgavas novads', abbreviation: '038' },
      { name: 'Jaunpiebalgas novads', abbreviation: '039' },
      { name: 'Jaunpils novads', abbreviation: '040' },
      { name: 'Jelgavas novads', abbreviation: '041' },
      { name: 'Jēkabpils novads', abbreviation: '042' },
      { name: 'Kandavas novads', abbreviation: '043' },
      { name: 'Kārsavas novads', abbreviation: '044' },
      { name: 'Kocēnu novads', abbreviation: '045' },
      { name: 'Kokneses novads', abbreviation: '046' },
      { name: 'Krāslavas novads', abbreviation: '047' },
      { name: 'Krimuldas novads', abbreviation: '048' },
      { name: 'Krustpils novads', abbreviation: '049' },
      { name: 'Kuldīgas novads', abbreviation: '050' },
      { name: 'Ķeguma novads', abbreviation: '051' },
      { name: 'Ķekavas novads', abbreviation: '052' },
      { name: 'Lielvārdes novads', abbreviation: '053' },
      { name: 'Limbažu novads', abbreviation: '054' },
      { name: 'Līgatnes novads', abbreviation: '055' },
      { name: 'Līvānu novads', abbreviation: '056' },
      { name: 'Lubānas novads', abbreviation: '057' },
      { name: 'Ludzas novads', abbreviation: '058' },
      { name: 'Madonas novads', abbreviation: '059' },
      { name: 'Mazsalacas novads', abbreviation: '060' },
      { name: 'Mālpils novads', abbreviation: '061' },
      { name: 'Mārupes novads', abbreviation: '062' },
      { name: 'Mērsraga novads', abbreviation: '063' },
      { name: 'Naukšēnu novads', abbreviation: '064' },
      { name: 'Neretas novads', abbreviation: '065' },
      { name: 'Nīcas novads', abbreviation: '066' },
      { name: 'Ogres novads', abbreviation: '067' },
      { name: 'Olaines novads', abbreviation: '068' },
      { name: 'Ozolnieku novads', abbreviation: '069' },
      { name: 'Pārgaujas novads', abbreviation: '070' },
      { name: 'Pāvilostas novads', abbreviation: '071' },
      { name: 'Pļaviņu novads', abbreviation: '072' },
      { name: 'Preiļu novads', abbreviation: '073' },
      { name: 'Priekules novads', abbreviation: '074' },
      { name: 'Priekuļu novads', abbreviation: '075' },
      { name: 'Raunas novads', abbreviation: '076' },
      { name: 'Rēzeknes novads', abbreviation: '077' },
      { name: 'Riebiņu novads', abbreviation: '078' },
      { name: 'Rojas novads', abbreviation: '079' },
      { name: 'Ropažu novads', abbreviation: '080' },
      { name: 'Rucavas novads', abbreviation: '081' },
      { name: 'Rugāju novads', abbreviation: '082' },
      { name: 'Rundāles novads', abbreviation: '083' },
      { name: 'Rūjienas novads', abbreviation: '084' },
      { name: 'Salas novads', abbreviation: '085' },
      { name: 'Salacgrīvas novads', abbreviation: '086' },
      { name: 'Salaspils novads', abbreviation: '087' },
      { name: 'Saldus novads', abbreviation: '088' },
      { name: 'Saulkrastu novads', abbreviation: '089' },
      { name: 'Sējas novads', abbreviation: '090' },
      { name: 'Siguldas novads', abbreviation: '091' },
      { name: 'Skrīveru novads', abbreviation: '092' },
      { name: 'Skrundas novads', abbreviation: '093' },
      { name: 'Smiltenes novads', abbreviation: '094' },
      { name: 'Stopiņu novads', abbreviation: '095' },
      { name: 'Strenču novads', abbreviation: '096' },
      { name: 'Talsu novads', abbreviation: '097' },
      { name: 'Tērvetes novads', abbreviation: '098' },
      { name: 'Tukuma novads', abbreviation: '099' },
      { name: 'Vaiņodes novads', abbreviation: '100' },
      { name: 'Valkas novads', abbreviation: '101' },
      { name: 'Varakļānu novads', abbreviation: '102' },
      { name: 'Vārkavas novads', abbreviation: '103' },
      { name: 'Vecpiebalgas novads', abbreviation: '104' },
      { name: 'Vecumnieku novads', abbreviation: '105' },
      { name: 'Ventspils novads', abbreviation: '106' },
      { name: 'Viesītes novads', abbreviation: '107' },
      { name: 'Viļakas novads', abbreviation: '108' },
      { name: 'Viļānu novads', abbreviation: '109' },
      { name: 'Zilupes novads', abbreviation: '110' },
      { name: 'Daugavpils', abbreviation: 'DGV' },
      { name: 'Jelgava', abbreviation: 'JEL' },
      { name: 'Jēkabpils', abbreviation: 'JKB' },
      { name: 'Jūrmala', abbreviation: 'JUR' },
      { name: 'Liepāja', abbreviation: 'LPX' },
      { name: 'Rēzekne', abbreviation: 'REZ' },
      { name: 'Rīga', abbreviation: 'RIX' },
      { name: 'Ventspils', abbreviation: 'VEN' },
      { name: 'Valmiera', abbreviation: 'VMR' },
    ],
  },
  MAR: {
    regions: [
      { name: 'Tanger-Tétouan-Al Hoceïma', abbreviation: '01' },
      { name: 'M’diq-Fnideq', abbreviation: 'MDF' },
      { name: 'Tanger-Assilah', abbreviation: 'TNG' },
      { name: 'Chefchaouen', abbreviation: 'CHE' },
      { name: 'Fahs-Anjra', abbreviation: 'FAH' },
      { name: 'Al Hoceïma', abbreviation: 'HOC' },
      { name: 'Larache', abbreviation: 'LAR' },
      { name: 'Ouezzane', abbreviation: 'OUZ' },
      { name: 'Tétouan', abbreviation: 'TET' },
      { name: "L'Oriental", abbreviation: '02' },
      { name: 'Oujda-Angad', abbreviation: 'OUJ' },
      { name: 'Berkane', abbreviation: 'BER' },
      { name: 'Driouch', abbreviation: 'DRI' },
      { name: 'Figuig', abbreviation: 'FIG' },
      { name: 'Guercif', abbreviation: 'GUF' },
      { name: 'Jerada', abbreviation: 'JRA' },
      { name: 'Nador', abbreviation: 'NAD' },
      { name: 'Taourirt', abbreviation: 'TAI' },
      { name: 'Fès-Meknès', abbreviation: '03' },
      { name: 'Fès', abbreviation: 'FES' },
      { name: 'Meknès', abbreviation: 'MEK' },
      { name: 'Boulemane', abbreviation: 'BOM' },
      { name: 'El Hajeb', abbreviation: 'HAJ' },
      { name: 'Ifrane', abbreviation: 'IFR' },
      { name: 'Moulay Yacoub', abbreviation: 'MOU' },
      { name: 'Sefrou', abbreviation: 'SEF' },
      { name: 'Taounate', abbreviation: 'TAO' },
      { name: 'Taza', abbreviation: 'TAZ' },
      { name: 'Rabat-Salé-Kénitra', abbreviation: '04' },
      { name: 'Rabat', abbreviation: 'RAB' },
      { name: 'Salé', abbreviation: 'SAL' },
      { name: 'Skhirate-Témara', abbreviation: 'SKH' },
      { name: 'Kénitra', abbreviation: 'KEN' },
      { name: 'Khemisset', abbreviation: 'KHE' },
      { name: 'Nouaceur', abbreviation: 'NOU' },
      { name: 'Sidi Kacem', abbreviation: 'SIK' },
      { name: 'Sidi Slimane', abbreviation: 'SIL' },
      { name: 'Béni Mellal-Khénifra', abbreviation: '05' },
      { name: 'Azilal', abbreviation: 'AZI' },
      { name: 'Béni Mellal', abbreviation: 'BEM' },
      { name: 'Fquih Ben Salah', abbreviation: 'FQH' },
      { name: 'Khenifra', abbreviation: 'KHN' },
      { name: 'Khouribga', abbreviation: 'KHO' },
      { name: 'Casablanca-Settat', abbreviation: '06' },
      { name: 'Casablanca', abbreviation: 'CAS' },
      { name: 'Mohammadia', abbreviation: 'MOH' },
      { name: 'Benslimane', abbreviation: 'BES' },
      { name: 'Berrechid', abbreviation: 'BRR' },
      { name: 'Chtouka-Ait Baha', abbreviation: 'CHT' },
      { name: 'El Jadida', abbreviation: 'JDI' },
      { name: 'Médiouna', abbreviation: 'MED' },
      { name: 'Settat', abbreviation: 'SET' },
      { name: 'Sidi Bennour', abbreviation: 'SIB' },
      { name: 'Marrakech-Safi', abbreviation: '07' },
      { name: 'Marrakech', abbreviation: 'MAR' },
      { name: 'Chichaoua', abbreviation: 'CHI' },
      { name: 'Essaouira', abbreviation: 'ESI' },
      { name: 'Al Haouz', abbreviation: 'HAO' },
      { name: 'El Kelâa des Sraghna', abbreviation: 'KES' },
      { name: 'Rehamna', abbreviation: 'REH' },
      { name: 'Safi', abbreviation: 'SAF' },
      { name: 'Youssoufia', abbreviation: 'YUS' },
      { name: 'Drâa-Tafilalet', abbreviation: '08' },
      { name: 'Errachidia', abbreviation: 'ERR' },
      { name: 'Midelt', abbreviation: 'MID' },
      { name: 'Ouarzazate', abbreviation: 'OUA' },
      { name: 'Tinghir', abbreviation: 'TIN' },
      { name: 'Zagora', abbreviation: 'ZAG' },
      { name: 'Souss-Massa', abbreviation: '09' },
      { name: 'Agadir-Ida-Ou-Tanane', abbreviation: 'AGD' },
      { name: 'Inezgane-Ait Melloul', abbreviation: 'INE' },
      { name: 'Taroudant', abbreviation: 'TAR' },
      { name: 'Tata', abbreviation: 'TAT' },
      { name: 'Tiznit', abbreviation: 'TIZ' },
      { name: 'Guelmim-Oued Noun (EH-partial)', abbreviation: '10' },
      { name: 'Assa-Zag (EH-partial)', abbreviation: 'ASZ' },
      { name: 'Guelmim', abbreviation: 'GUE' },
      { name: 'Sidi Ifni', abbreviation: 'SIF' },
      { name: 'Tan-Tan (EH-partial)', abbreviation: 'TNT' },
      { name: 'Laâyoune-Sakia El Hamra (EH-partial)', abbreviation: '11' },
      { name: 'Boujdour (EH)', abbreviation: 'BOD' },
      { name: 'Es-Semara (EH-partial)', abbreviation: 'ESM' },
      { name: 'Laâyoune (EH)', abbreviation: 'LAA' },
      { name: 'Tarfaya (EH-partial)', abbreviation: 'TAF' },
      { name: 'Dakhla-Oued Ed-Dahab (EH)', abbreviation: '12' },
      { name: 'Aousserd (EH)', abbreviation: 'AOU' },
      { name: 'Oued Ed-Dahab (EH)', abbreviation: 'OUD' },
    ],
  },
  MCO: {
    regions: [
      { name: 'La Colle', abbreviation: 'CL' },
      { name: 'La Condamine', abbreviation: 'CO' },
      { name: 'Fontvieille', abbreviation: 'FO' },
      { name: 'La Gare', abbreviation: 'GA' },
      { name: 'Jardin Exotique', abbreviation: 'JE' },
      { name: 'Larvotto', abbreviation: 'LA' },
      { name: 'Malbousquet', abbreviation: 'MA' },
      { name: 'Monte-Carlo', abbreviation: 'MC' },
      { name: 'Moneghetti', abbreviation: 'MG' },
      { name: 'Monaco-Ville', abbreviation: 'MO' },
      { name: 'Moulins', abbreviation: 'MU' },
      { name: 'Port-Hercule', abbreviation: 'PH' },
      { name: 'Sainte-Dévote', abbreviation: 'SD' },
      { name: 'La Source', abbreviation: 'SO' },
      { name: 'Spélugues', abbreviation: 'SP' },
      { name: 'Saint-Roman', abbreviation: 'SR' },
      { name: 'Vallon de la Rousse', abbreviation: 'VR' },
    ],
  },
  MDA: {
    regions: [
      { name: 'Anenii Noi', abbreviation: 'AN' },
      { name: 'Briceni', abbreviation: 'BR' },
      { name: 'Basarabeasca', abbreviation: 'BS' },
      { name: 'Cahul', abbreviation: 'CA' },
      { name: 'Călărași', abbreviation: 'CL' },
      { name: 'Cimișlia', abbreviation: 'CM' },
      { name: 'Criuleni', abbreviation: 'CR' },
      { name: 'Căușeni', abbreviation: 'CS' },
      { name: 'Cantemir', abbreviation: 'CT' },
      { name: 'Dondușeni', abbreviation: 'DO' },
      { name: 'Drochia', abbreviation: 'DR' },
      { name: 'Dubăsari', abbreviation: 'DU' },
      { name: 'Edineț', abbreviation: 'ED' },
      { name: 'Fălești', abbreviation: 'FA' },
      { name: 'Florești', abbreviation: 'FL' },
      { name: 'Glodeni', abbreviation: 'GL' },
      { name: 'Hîncești', abbreviation: 'HI' },
      { name: 'Ialoveni', abbreviation: 'IA' },
      { name: 'Leova', abbreviation: 'LE' },
      { name: 'Nisporeni', abbreviation: 'NI' },
      { name: 'Ocnița', abbreviation: 'OC' },
      { name: 'Orhei', abbreviation: 'OR' },
      { name: 'Rezina', abbreviation: 'RE' },
      { name: 'Rîșcani', abbreviation: 'RI' },
      { name: 'Șoldănești', abbreviation: 'SD' },
      { name: 'Sîngerei', abbreviation: 'SI' },
      { name: 'Soroca', abbreviation: 'SO' },
      { name: 'Strășeni', abbreviation: 'ST' },
      { name: 'Ștefan Vodă', abbreviation: 'SV' },
      { name: 'Taraclia', abbreviation: 'TA' },
      { name: 'Telenești', abbreviation: 'TE' },
      { name: 'Ungheni', abbreviation: 'UN' },
      {
        name: 'Găgăuzia, Unitatea teritorială autonomă (UTAG)',
        abbreviation: 'GA',
      },
      {
        name: 'Stînga Nistrului, unitatea teritorială din',
        abbreviation: 'SN',
      },
      { name: 'Bălți', abbreviation: 'BA' },
      { name: 'Bender [Tighina]', abbreviation: 'BD' },
      { name: 'Chișinău', abbreviation: 'CU' },
    ],
  },
  MDG: {
    regions: [
      { name: 'Toamasina', abbreviation: 'A' },
      { name: 'Antsiranana', abbreviation: 'D' },
      { name: 'Fianarantsoa', abbreviation: 'F' },
      { name: 'Mahajanga', abbreviation: 'M' },
      { name: 'Antananarivo', abbreviation: 'T' },
      { name: 'Toliara', abbreviation: 'U' },
    ],
  },
  MDV: {
    regions: [
      { name: 'Ariatholhu Dhekunuburi', abbreviation: '00' },
      { name: 'North Ari Atoll', abbreviation: '02' },
      { name: 'Faadhippolhu', abbreviation: '03' },
      { name: 'Felidhu Atoll', abbreviation: '04' },
      { name: 'Hahdhunmathi', abbreviation: '05' },
      { name: 'North Thiladhunmathi', abbreviation: '07' },
      { name: 'Kolhumadulu', abbreviation: '08' },
      { name: 'Mulaku Atoll', abbreviation: '12' },
      { name: 'North Maalhosmadulu', abbreviation: '13' },
      { name: 'North Nilandhe Atoll', abbreviation: '14' },
      { name: 'South Nilandhe Atoll', abbreviation: '17' },
      { name: 'South Maalhosmadulu', abbreviation: '20' },
      { name: 'South Thiladhunmathi', abbreviation: '23' },
      { name: 'North Miladhunmadulu', abbreviation: '24' },
      { name: 'South Miladhunmadulu', abbreviation: '25' },
      { name: 'Male Atoll', abbreviation: '26' },
      { name: 'North Huvadhu Atoll', abbreviation: '27' },
      { name: 'South Huvadhu Atoll', abbreviation: '28' },
      { name: 'Fuvammulah', abbreviation: '29' },
      { name: 'Addu City', abbreviation: '01' },
      { name: 'Male', abbreviation: 'MLE' },
    ],
  },
  MEX: {
    postalCodeLabel: 'Postal Code',
    regionLabel: 'State',
    regions: [
      { name: 'Aguascalientes', abbreviation: 'AGU' },
      { name: 'Baja California Sur', abbreviation: 'BCS' },
      { name: 'Baja California', abbreviation: 'BCN' },
      { name: 'Campeche', abbreviation: 'CAM' },
      { name: 'Chiapas', abbreviation: 'CHP' },
      { name: 'Chihuahua', abbreviation: 'CHH' },
      { name: 'Ciudad de México', abbreviation: 'CMX' },
      { name: 'Coahuila de Zaragoza', abbreviation: 'COA' },
      { name: 'Colima', abbreviation: 'COL' },
      { name: 'Durango', abbreviation: 'DUR' },
      { name: 'Guanajuato', abbreviation: 'GUA' },
      { name: 'Guerrero', abbreviation: 'GRO' },
      { name: 'Hidalgo', abbreviation: 'HID' },
      { name: 'Jalisco', abbreviation: 'JAL' },
      { name: 'México', abbreviation: 'MEX' },
      { name: 'Michoacán de Ocampo', abbreviation: 'MIC' },
      { name: 'Morelos', abbreviation: 'MOR' },
      { name: 'Nayarit', abbreviation: 'NAY' },
      { name: 'Nuevo León', abbreviation: 'NLE' },
      { name: 'Oaxaca', abbreviation: 'OAX' },
      { name: 'Puebla', abbreviation: 'PUE' },
      { name: 'Querétaro', abbreviation: 'QUE' },
      { name: 'Quintana Roo', abbreviation: 'ROO' },
      { name: 'San Luis Potosí', abbreviation: 'SLP' },
      { name: 'Sinaloa', abbreviation: 'SIN' },
      { name: 'Sonora', abbreviation: 'SON' },
      { name: 'Tabasco', abbreviation: 'TAB' },
      { name: 'Tamaulipas', abbreviation: 'TAM' },
      { name: 'Tlaxcala', abbreviation: 'TLA' },
      { name: 'Veracruz de Ignacio de la Llave', abbreviation: 'VER' },
      { name: 'Yucatán', abbreviation: 'YUC' },
      { name: 'Zacatecas', abbreviation: 'ZAC' },
    ],
  },
  MHL: {
    regions: [
      { name: 'Ralik chain', abbreviation: 'L' },
      { name: 'Ailinglaplap', abbreviation: 'ALL' },
      { name: 'Ebon', abbreviation: 'EBO' },
      { name: 'Enewetak & Ujelang', abbreviation: 'ENI' },
      { name: 'Jabat', abbreviation: 'JAB' },
      { name: 'Jaluit', abbreviation: 'JAL' },
      { name: 'Bikini & Kili', abbreviation: 'KIL' },
      { name: 'Kwajalein', abbreviation: 'KWA' },
      { name: 'Lae', abbreviation: 'LAE' },
      { name: 'Lib', abbreviation: 'LIB' },
      { name: 'Namdrik', abbreviation: 'NMK' },
      { name: 'Namu', abbreviation: 'NMU' },
      { name: 'Rongelap', abbreviation: 'RON' },
      { name: 'Ujae', abbreviation: 'UJA' },
      { name: 'Wotho', abbreviation: 'WTH' },
      { name: 'Ratak chain', abbreviation: 'T' },
      { name: 'Ailuk', abbreviation: 'ALK' },
      { name: 'Arno', abbreviation: 'ARN' },
      { name: 'Aur', abbreviation: 'AUR' },
      { name: 'Likiep', abbreviation: 'LIK' },
      { name: 'Majuro', abbreviation: 'MAJ' },
      { name: 'Maloelap', abbreviation: 'MAL' },
      { name: 'Mejit', abbreviation: 'MEJ' },
      { name: 'Mili', abbreviation: 'MIL' },
      { name: 'Utrik', abbreviation: 'UTI' },
      { name: 'Wotje', abbreviation: 'WTJ' },
    ],
  },
  MKD: {
    regions: [
      { name: 'Veles', abbreviation: '101' },
      { name: 'Gradsko', abbreviation: '102' },
      { name: 'Demir Kapija', abbreviation: '103' },
      { name: 'Kavadarci', abbreviation: '104' },
      { name: 'Lozovo', abbreviation: '105' },
      { name: 'Negotino', abbreviation: '106' },
      { name: 'Rosoman', abbreviation: '107' },
      { name: 'Sveti Nikole', abbreviation: '108' },
      { name: 'Čaška', abbreviation: '109' },
      { name: 'Berovo', abbreviation: '201' },
      { name: 'Vinica', abbreviation: '202' },
      { name: 'Delčevo', abbreviation: '203' },
      { name: 'Zrnovci', abbreviation: '204' },
      { name: 'Karbinci', abbreviation: '205' },
      { name: 'Kočani', abbreviation: '206' },
      { name: 'Makedonska Kamenica', abbreviation: '207' },
      { name: 'Pehčevo', abbreviation: '208' },
      { name: 'Probištip', abbreviation: '209' },
      { name: 'Češinovo-Obleševo', abbreviation: '210' },
      { name: 'Štip', abbreviation: '211' },
      { name: 'Vevčani', abbreviation: '301' },
      { name: 'Debar', abbreviation: '303' },
      { name: 'Debrca', abbreviation: '304' },
      { name: 'Kičevo', abbreviation: '307' },
      { name: 'Makedonski Brod', abbreviation: '308' },
      { name: 'Ohrid', abbreviation: '310' },
      { name: 'Plasnica', abbreviation: '311' },
      { name: 'Struga', abbreviation: '312' },
      { name: 'Centar Župa', abbreviation: '313' },
      { name: 'Bogdanci', abbreviation: '401' },
      { name: 'Bosilovo', abbreviation: '402' },
      { name: 'Valandovo', abbreviation: '403' },
      { name: 'Vasilevo', abbreviation: '404' },
      { name: 'Gevgelija', abbreviation: '405' },
      { name: 'Dojran', abbreviation: '406' },
      { name: 'Konče', abbreviation: '407' },
      { name: 'Novo Selo', abbreviation: '408' },
      { name: 'Radoviš', abbreviation: '409' },
      { name: 'Strumica', abbreviation: '410' },
      { name: 'Bitola', abbreviation: '501' },
      { name: 'Demir Hisar', abbreviation: '502' },
      { name: 'Dolneni', abbreviation: '503' },
      { name: 'Krivogaštani', abbreviation: '504' },
      { name: 'Kruševo', abbreviation: '505' },
      { name: 'Mogila', abbreviation: '506' },
      { name: 'Novaci', abbreviation: '507' },
      { name: 'Prilep', abbreviation: '508' },
      { name: 'Resen', abbreviation: '509' },
      { name: 'Bogovinje', abbreviation: '601' },
      { name: 'Brvenica', abbreviation: '602' },
      { name: 'Vrapčište', abbreviation: '603' },
      { name: 'Gostivar', abbreviation: '604' },
      { name: 'Želino', abbreviation: '605' },
      { name: 'Jegunovce', abbreviation: '606' },
      { name: 'Mavrovo i Rostuše', abbreviation: '607' },
      { name: 'Tearce', abbreviation: '608' },
      { name: 'Tetovo', abbreviation: '609' },
      { name: 'Kratovo', abbreviation: '701' },
      { name: 'Kriva Palanka', abbreviation: '702' },
      { name: 'Kumanovo', abbreviation: '703' },
      { name: 'Lipkovo', abbreviation: '704' },
      { name: 'Rankovce', abbreviation: '705' },
      { name: 'Staro Nagoričane', abbreviation: '706' },
      { name: 'Aerodrom †', abbreviation: '801' },
      { name: 'Aračinovo', abbreviation: '802' },
      { name: 'Butel †', abbreviation: '803' },
      { name: 'Gazi Baba †', abbreviation: '804' },
      { name: 'Gjorče Petrov †', abbreviation: '805' },
      { name: 'Zelenikovo', abbreviation: '806' },
      { name: 'Ilinden', abbreviation: '807' },
      { name: 'Karpoš †', abbreviation: '808' },
      { name: 'Kisela Voda †', abbreviation: '809' },
      { name: 'Petrovec', abbreviation: '810' },
      { name: 'Saraj †', abbreviation: '811' },
      { name: 'Sopište', abbreviation: '812' },
      { name: 'Studeničani', abbreviation: '813' },
      { name: 'Centar †', abbreviation: '814' },
      { name: 'Čair †', abbreviation: '815' },
      { name: 'Čučer-Sandevo', abbreviation: '816' },
      { name: 'Šuto Orizari †', abbreviation: '817' },
    ],
  },
  MLI: {
    regions: [
      { name: 'Kayes', abbreviation: '1' },
      { name: 'Taoudénit', abbreviation: '10' },
      { name: 'Koulikoro', abbreviation: '2' },
      { name: 'Sikasso', abbreviation: '3' },
      { name: 'Ségou', abbreviation: '4' },
      { name: 'Mopti', abbreviation: '5' },
      { name: 'Tombouctou', abbreviation: '6' },
      { name: 'Gao', abbreviation: '7' },
      { name: 'Kidal', abbreviation: '8' },
      { name: 'Ménaka', abbreviation: '9' },
      { name: 'Bamako', abbreviation: 'BKO' },
    ],
  },
  MLT: {
    regions: [
      { name: 'Attard', abbreviation: '01' },
      { name: 'Balzan', abbreviation: '02' },
      { name: 'Birgu', abbreviation: '03' },
      { name: 'Birkirkara', abbreviation: '04' },
      { name: 'Birżebbuġa', abbreviation: '05' },
      { name: 'Bormla', abbreviation: '06' },
      { name: 'Dingli', abbreviation: '07' },
      { name: 'Fgura', abbreviation: '08' },
      { name: 'Floriana', abbreviation: '09' },
      { name: 'Fontana', abbreviation: '10' },
      { name: 'Gudja', abbreviation: '11' },
      { name: 'Gżira', abbreviation: '12' },
      { name: 'Għajnsielem', abbreviation: '13' },
      { name: 'Għarb', abbreviation: '14' },
      { name: 'Għargħur', abbreviation: '15' },
      { name: 'Għasri', abbreviation: '16' },
      { name: 'Għaxaq', abbreviation: '17' },
      { name: 'Ħamrun', abbreviation: '18' },
      { name: 'Iklin', abbreviation: '19' },
      { name: 'Isla', abbreviation: '20' },
      { name: 'Kalkara', abbreviation: '21' },
      { name: 'Kerċem', abbreviation: '22' },
      { name: 'Kirkop', abbreviation: '23' },
      { name: 'Lija', abbreviation: '24' },
      { name: 'Luqa', abbreviation: '25' },
      { name: 'Marsa', abbreviation: '26' },
      { name: 'Marsaskala', abbreviation: '27' },
      { name: 'Marsaxlokk', abbreviation: '28' },
      { name: 'Mdina', abbreviation: '29' },
      { name: 'Mellieħa', abbreviation: '30' },
      { name: 'Mġarr', abbreviation: '31' },
      { name: 'Mosta', abbreviation: '32' },
      { name: 'Mqabba', abbreviation: '33' },
      { name: 'Msida', abbreviation: '34' },
      { name: 'Mtarfa', abbreviation: '35' },
      { name: 'Munxar', abbreviation: '36' },
      { name: 'Nadur', abbreviation: '37' },
      { name: 'Naxxar', abbreviation: '38' },
      { name: 'Paola', abbreviation: '39' },
      { name: 'Pembroke', abbreviation: '40' },
      { name: 'Pietà', abbreviation: '41' },
      { name: 'Qala', abbreviation: '42' },
      { name: 'Qormi', abbreviation: '43' },
      { name: 'Qrendi', abbreviation: '44' },
      { name: 'Rabat Gozo', abbreviation: '45' },
      { name: 'Rabat Malta', abbreviation: '46' },
      { name: 'Safi', abbreviation: '47' },
      { name: "Saint Julian's", abbreviation: '48' },
      { name: 'Saint John', abbreviation: '49' },
      { name: 'Saint Lawrence', abbreviation: '50' },
      { name: "Saint Paul's Bay", abbreviation: '51' },
      { name: 'Sannat', abbreviation: '52' },
      { name: "Saint Lucia's", abbreviation: '53' },
      { name: 'Santa Venera', abbreviation: '54' },
      { name: 'Siġġiewi', abbreviation: '55' },
      { name: 'Sliema', abbreviation: '56' },
      { name: 'Swieqi', abbreviation: '57' },
      { name: "Ta' Xbiex", abbreviation: '58' },
      { name: 'Tarxien', abbreviation: '59' },
      { name: 'Valletta', abbreviation: '60' },
      { name: 'Xagħra', abbreviation: '61' },
      { name: 'Xewkija', abbreviation: '62' },
      { name: 'Xgħajra', abbreviation: '63' },
      { name: 'Żabbar', abbreviation: '64' },
      { name: 'Żebbuġ Gozo', abbreviation: '65' },
      { name: 'Żebbuġ Malta', abbreviation: '66' },
      { name: 'Żejtun', abbreviation: '67' },
      { name: 'Żurrieq', abbreviation: '68' },
    ],
  },
  MMR: {
    regions: [
      { name: 'Sagaing', abbreviation: '01' },
      { name: 'Bago', abbreviation: '02' },
      { name: 'Magway', abbreviation: '03' },
      { name: 'Mandalay', abbreviation: '04' },
      { name: 'Tanintharyi', abbreviation: '05' },
      { name: 'Yangon', abbreviation: '06' },
      { name: 'Ayeyarwady', abbreviation: '07' },
      { name: 'Kachin', abbreviation: '11' },
      { name: 'Kayah', abbreviation: '12' },
      { name: 'Kayin', abbreviation: '13' },
      { name: 'Chin', abbreviation: '14' },
      { name: 'Mon', abbreviation: '15' },
      { name: 'Rakhine', abbreviation: '16' },
      { name: 'Shan', abbreviation: '17' },
      { name: 'Nay Pyi Taw', abbreviation: '18' },
    ],
  },
  MNE: {
    regions: [
      { name: 'Andrijevica', abbreviation: '01' },
      { name: 'Bar', abbreviation: '02' },
      { name: 'Berane', abbreviation: '03' },
      { name: 'Bijelo Polje', abbreviation: '04' },
      { name: 'Budva', abbreviation: '05' },
      { name: 'Cetinje', abbreviation: '06' },
      { name: 'Danilovgrad', abbreviation: '07' },
      { name: 'Herceg-Novi', abbreviation: '08' },
      { name: 'Kolašin', abbreviation: '09' },
      { name: 'Kotor', abbreviation: '10' },
      { name: 'Mojkovac', abbreviation: '11' },
      { name: 'Nikšić', abbreviation: '12' },
      { name: 'Plav', abbreviation: '13' },
      { name: 'Pljevlja', abbreviation: '14' },
      { name: 'Plužine', abbreviation: '15' },
      { name: 'Podgorica', abbreviation: '16' },
      { name: 'Rožaje', abbreviation: '17' },
      { name: 'Šavnik', abbreviation: '18' },
      { name: 'Tivat', abbreviation: '19' },
      { name: 'Ulcinj', abbreviation: '20' },
      { name: 'Žabljak', abbreviation: '21' },
      { name: 'Gusinje', abbreviation: '22' },
      { name: 'Petnjica', abbreviation: '23' },
      { name: 'Tuzi', abbreviation: '24' },
    ],
  },
  MNG: {
    regions: [
      { name: 'Orhon', abbreviation: '035' },
      { name: 'Darhan uul', abbreviation: '037' },
      { name: 'Hentiy', abbreviation: '039' },
      { name: 'Hövsgöl', abbreviation: '041' },
      { name: 'Hovd', abbreviation: '043' },
      { name: 'Uvs', abbreviation: '046' },
      { name: 'Töv', abbreviation: '047' },
      { name: 'Selenge', abbreviation: '049' },
      { name: 'Sühbaatar', abbreviation: '051' },
      { name: 'Ömnögovĭ', abbreviation: '053' },
      { name: 'Övörhangay', abbreviation: '055' },
      { name: 'Dzavhan', abbreviation: '057' },
      { name: 'Dundgovĭ', abbreviation: '059' },
      { name: 'Dornod', abbreviation: '061' },
      { name: 'Dornogovĭ', abbreviation: '063' },
      { name: 'Govĭ-Sümber', abbreviation: '064' },
      { name: 'Govĭ-Altay', abbreviation: '065' },
      { name: 'Bulgan', abbreviation: '067' },
      { name: 'Bayanhongor', abbreviation: '069' },
      { name: 'Bayan-Ölgiy', abbreviation: '071' },
      { name: 'Arhangay', abbreviation: '073' },
      { name: 'Ulaanbaatar', abbreviation: '1' },
    ],
  },
  MOZ: {
    regions: [
      { name: 'Maputo', abbreviation: 'MPM' },
      { name: 'Niassa', abbreviation: 'A' },
      { name: 'Manica', abbreviation: 'B' },
      { name: 'Gaza', abbreviation: 'G' },
      { name: 'Inhambane', abbreviation: 'I' },
      { name: 'Maputo', abbreviation: 'L' },
      { name: 'Nampula', abbreviation: 'N' },
      { name: 'Cabo Delgado', abbreviation: 'P' },
      { name: 'Zambézia', abbreviation: 'Q' },
      { name: 'Sofala', abbreviation: 'S' },
      { name: 'Tete', abbreviation: 'T' },
    ],
  },
  MRT: {
    regions: [
      { name: 'Hodh ech Chargui', abbreviation: '01' },
      { name: 'Hodh el Gharbi', abbreviation: '02' },
      { name: 'Assaba', abbreviation: '03' },
      { name: 'Gorgol', abbreviation: '04' },
      { name: 'Brakna', abbreviation: '05' },
      { name: 'Trarza', abbreviation: '06' },
      { name: 'Adrar', abbreviation: '07' },
      { name: 'Dakhlet Nouâdhibou', abbreviation: '08' },
      { name: 'Tagant', abbreviation: '09' },
      { name: 'Guidimaka', abbreviation: '10' },
      { name: 'Tiris Zemmour', abbreviation: '11' },
      { name: 'Inchiri', abbreviation: '12' },
      { name: 'Nuwākshūţ al Gharbīyah', abbreviation: '13' },
      { name: 'Nuwākshūţ ash Shamālīyah', abbreviation: '14' },
      { name: 'Nuwākshūţ al Janūbīyah', abbreviation: '15' },
    ],
  },
  MUS: {
    regions: [
      { name: 'Beau Bassin-Rose Hill', abbreviation: 'BR' },
      { name: 'Curepipe', abbreviation: 'CU' },
      { name: 'Port Louis', abbreviation: 'PU' },
      { name: 'Quatre Bornes', abbreviation: 'QB' },
      { name: 'Vacoas-Phoenix', abbreviation: 'VP' },
      { name: 'Black River', abbreviation: 'BL' },
      { name: 'Flacq', abbreviation: 'FL' },
      { name: 'Grand Port', abbreviation: 'GP' },
      { name: 'Moka', abbreviation: 'MO' },
      { name: 'Pamplemousses', abbreviation: 'PA' },
      { name: 'Port Louis', abbreviation: 'PL' },
      { name: 'Plaines Wilhems', abbreviation: 'PW' },
      { name: 'Rivière du Rempart', abbreviation: 'RR' },
      { name: 'Savanne', abbreviation: 'SA' },
      { name: 'Agalega Islands', abbreviation: 'AG' },
      { name: 'Cargados Carajos Shoals', abbreviation: 'CC' },
      { name: 'Rodrigues Island', abbreviation: 'RO' },
    ],
  },
  MWI: {
    regions: [
      { name: 'Central Region', abbreviation: 'C' },
      { name: 'Dedza', abbreviation: 'DE' },
      { name: 'Dowa', abbreviation: 'DO' },
      { name: 'Kasungu', abbreviation: 'KS' },
      { name: 'Lilongwe', abbreviation: 'LI' },
      { name: 'Mchinji', abbreviation: 'MC' },
      { name: 'Ntchisi', abbreviation: 'NI' },
      { name: 'Nkhotakota', abbreviation: 'NK' },
      { name: 'Ntcheu', abbreviation: 'NU' },
      { name: 'Salima', abbreviation: 'SA' },
      { name: 'Northern Region', abbreviation: 'N' },
      { name: 'Chitipa', abbreviation: 'CT' },
      { name: 'Karonga', abbreviation: 'KR' },
      { name: 'Likoma', abbreviation: 'LK' },
      { name: 'Mzimba', abbreviation: 'MZ' },
      { name: 'Nkhata Bay', abbreviation: 'NB' },
      { name: 'Rumphi', abbreviation: 'RU' },
      { name: 'Southern Region', abbreviation: 'S' },
      { name: 'Balaka', abbreviation: 'BA' },
      { name: 'Blantyre', abbreviation: 'BL' },
      { name: 'Chikwawa', abbreviation: 'CK' },
      { name: 'Chiradzulu', abbreviation: 'CR' },
      { name: 'Mangochi', abbreviation: 'MG' },
      { name: 'Machinga', abbreviation: 'MH' },
      { name: 'Mulanje', abbreviation: 'MU' },
      { name: 'Mwanza', abbreviation: 'MW' },
      { name: 'Neno', abbreviation: 'NE' },
      { name: 'Nsanje', abbreviation: 'NS' },
      { name: 'Phalombe', abbreviation: 'PH' },
      { name: 'Thyolo', abbreviation: 'TH' },
      { name: 'Zomba', abbreviation: 'ZO' },
    ],
  },
  MYS: {
    postalCodeLabel: 'Postcode',
    regionLabel: 'State',
    regions: [
      { name: 'Johor', abbreviation: 'JHR' },
      { name: 'Kedah', abbreviation: 'KDH' },
      { name: 'Kelantan', abbreviation: 'KTN' },
      { name: 'Kuala Lumpur', abbreviation: 'KUL' },
      { name: 'Labuan', abbreviation: 'LBN' },
      { name: 'Malacca', abbreviation: 'MLK' },
      { name: 'Negeri Sembilan', abbreviation: 'NSN' },
      { name: 'Pahang', abbreviation: 'PHG' },
      { name: 'Penang', abbreviation: 'PNG' },
      { name: 'Perak', abbreviation: 'PRK' },
      { name: 'Perlis', abbreviation: 'PLS' },
      { name: 'Putrajaya', abbreviation: 'PJY' },
      { name: 'Sabah', abbreviation: 'SBH' },
      { name: 'Sarawak', abbreviation: 'SWK' },
      { name: 'Selangor', abbreviation: 'SGR' },
      { name: 'Terengganu', abbreviation: 'TRG' },
    ],
  },
  NAM: {
    regions: [
      { name: 'Zambezi', abbreviation: 'CA' },
      { name: 'Erongo', abbreviation: 'ER' },
      { name: 'Hardap', abbreviation: 'HA' },
      { name: 'Karas', abbreviation: 'KA' },
      { name: 'Kavango East', abbreviation: 'KE' },
      { name: 'Khomas', abbreviation: 'KH' },
      { name: 'Kunene', abbreviation: 'KU' },
      { name: 'Kavango West', abbreviation: 'KW' },
      { name: 'Otjozondjupa', abbreviation: 'OD' },
      { name: 'Omaheke', abbreviation: 'OH' },
      { name: 'Oshana', abbreviation: 'ON' },
      { name: 'Omusati', abbreviation: 'OS' },
      { name: 'Oshikoto', abbreviation: 'OT' },
      { name: 'Ohangwena', abbreviation: 'OW' },
    ],
  },
  NER: {
    regions: [
      { name: 'Niamey', abbreviation: '8' },
      { name: 'Agadez', abbreviation: '1' },
      { name: 'Diffa', abbreviation: '2' },
      { name: 'Dosso', abbreviation: '3' },
      { name: 'Maradi', abbreviation: '4' },
      { name: 'Tahoua', abbreviation: '5' },
      { name: 'Tillabéri', abbreviation: '6' },
      { name: 'Zinder', abbreviation: '7' },
    ],
  },
  NGA: {
    regions: [
      { name: 'Abia', abbreviation: 'AB' },
      { name: 'Adamawa', abbreviation: 'AD' },
      { name: 'Akwa Ibom', abbreviation: 'AK' },
      { name: 'Anambra', abbreviation: 'AN' },
      { name: 'Bauchi', abbreviation: 'BA' },
      { name: 'Benue', abbreviation: 'BE' },
      { name: 'Borno', abbreviation: 'BO' },
      { name: 'Bayelsa', abbreviation: 'BY' },
      { name: 'Cross River', abbreviation: 'CR' },
      { name: 'Delta', abbreviation: 'DE' },
      { name: 'Ebonyi', abbreviation: 'EB' },
      { name: 'Edo', abbreviation: 'ED' },
      { name: 'Ekiti', abbreviation: 'EK' },
      { name: 'Enugu', abbreviation: 'EN' },
      { name: 'Gombe', abbreviation: 'GO' },
      { name: 'Imo', abbreviation: 'IM' },
      { name: 'Jigawa', abbreviation: 'JI' },
      { name: 'Kaduna', abbreviation: 'KD' },
      { name: 'Kebbi', abbreviation: 'KE' },
      { name: 'Kano', abbreviation: 'KN' },
      { name: 'Kogi', abbreviation: 'KO' },
      { name: 'Katsina', abbreviation: 'KT' },
      { name: 'Kwara', abbreviation: 'KW' },
      { name: 'Lagos', abbreviation: 'LA' },
      { name: 'Nasarawa', abbreviation: 'NA' },
      { name: 'Niger', abbreviation: 'NI' },
      { name: 'Ogun', abbreviation: 'OG' },
      { name: 'Ondo', abbreviation: 'ON' },
      { name: 'Osun', abbreviation: 'OS' },
      { name: 'Oyo', abbreviation: 'OY' },
      { name: 'Plateau', abbreviation: 'PL' },
      { name: 'Rivers', abbreviation: 'RI' },
      { name: 'Sokoto', abbreviation: 'SO' },
      { name: 'Taraba', abbreviation: 'TA' },
      { name: 'Yobe', abbreviation: 'YO' },
      { name: 'Zamfara', abbreviation: 'ZA' },
      { name: 'Abuja Federal Capital Territory', abbreviation: 'FC' },
    ],
  },
  NIC: {
    regions: [
      { name: 'Boaco', abbreviation: 'BO' },
      { name: 'Carazo', abbreviation: 'CA' },
      { name: 'Chinandega', abbreviation: 'CI' },
      { name: 'Chontales', abbreviation: 'CO' },
      { name: 'Estelí', abbreviation: 'ES' },
      { name: 'Granada', abbreviation: 'GR' },
      { name: 'Jinotega', abbreviation: 'JI' },
      { name: 'León', abbreviation: 'LE' },
      { name: 'Madriz', abbreviation: 'MD' },
      { name: 'Managua', abbreviation: 'MN' },
      { name: 'Masaya', abbreviation: 'MS' },
      { name: 'Matagalpa', abbreviation: 'MT' },
      { name: 'Nueva Segovia', abbreviation: 'NS' },
      { name: 'Rivas', abbreviation: 'RI' },
      { name: 'Río San Juan', abbreviation: 'SJ' },
      { name: 'Costa Caribe Norte', abbreviation: 'AN' },
      { name: 'Costa Caribe Sur', abbreviation: 'AS' },
    ],
  },
  NLD: {
    regions: [
      { name: 'Drenthe', abbreviation: 'DR' },
      { name: 'Flevoland', abbreviation: 'FL' },
      { name: 'Fryslân', abbreviation: 'FR' },
      { name: 'Gelderland', abbreviation: 'GE' },
      { name: 'Groningen', abbreviation: 'GR' },
      { name: 'Limburg', abbreviation: 'LI' },
      { name: 'Noord-Brabant', abbreviation: 'NB' },
      { name: 'Noord-Holland', abbreviation: 'NH' },
      { name: 'Overijssel', abbreviation: 'OV' },
      { name: 'Utrecht', abbreviation: 'UT' },
      { name: 'Zeeland', abbreviation: 'ZE' },
      { name: 'Zuid-Holland', abbreviation: 'ZH' },
      { name: 'Aruba', abbreviation: 'AW' },
      { name: 'Curaçao', abbreviation: 'CW' },
      { name: 'Sint Maarten', abbreviation: 'SX' },
      { name: 'Bonaire', abbreviation: 'BQ1' },
      { name: 'Saba', abbreviation: 'BQ2' },
      { name: 'Sint Eustatius', abbreviation: 'BQ3' },
    ],
  },
  NOR: {
    regions: [
      { name: 'Østfold', abbreviation: '01' },
      { name: 'Akershus', abbreviation: '02' },
      { name: 'Oslo', abbreviation: '03' },
      { name: 'Hedmark', abbreviation: '04' },
      { name: 'Oppland', abbreviation: '05' },
      { name: 'Buskerud', abbreviation: '06' },
      { name: 'Vestfold', abbreviation: '07' },
      { name: 'Telemark', abbreviation: '08' },
      { name: 'Aust-Agder', abbreviation: '09' },
      { name: 'Vest-Agder', abbreviation: '10' },
      { name: 'Rogaland', abbreviation: '11' },
      { name: 'Hordaland', abbreviation: '12' },
      { name: 'Sogn og Fjordane', abbreviation: '14' },
      { name: 'Møre og Romsdal', abbreviation: '15' },
      { name: 'Nordland', abbreviation: '18' },
      { name: 'Troms', abbreviation: '19' },
      { name: 'Finnmark', abbreviation: '20' },
      { name: 'Trøndelag', abbreviation: '50' },
      { name: 'Svalbard (Arctic Region)', abbreviation: '21' },
      { name: 'Jan Mayen (Arctic Region)', abbreviation: '22' },
    ],
  },
  NPL: {
    regions: [
      { name: 'Central', abbreviation: '1' },
      { name: 'Bagmati', abbreviation: 'BA' },
      { name: 'Janakpur', abbreviation: 'JA' },
      { name: 'Narayani', abbreviation: 'NA' },
      { name: 'Mid Western', abbreviation: '2' },
      { name: 'Bheri', abbreviation: 'BH' },
      { name: 'Karnali', abbreviation: 'KA' },
      { name: 'Rapti', abbreviation: 'RA' },
      { name: 'Western', abbreviation: '3' },
      { name: 'Dhawalagiri', abbreviation: 'DH' },
      { name: 'Gandaki', abbreviation: 'GA' },
      { name: 'Lumbini', abbreviation: 'LU' },
      { name: 'Eastern', abbreviation: '4' },
      { name: 'Kosi', abbreviation: 'KO' },
      { name: 'Mechi', abbreviation: 'ME' },
      { name: 'Sagarmatha', abbreviation: 'SA' },
      { name: 'Far Western', abbreviation: '5' },
      { name: 'Mahakali', abbreviation: 'MA' },
      { name: 'Seti', abbreviation: 'SE' },
      { name: 'Province 1', abbreviation: 'P1' },
      { name: 'Province 2', abbreviation: 'P2' },
      { name: 'Province 3', abbreviation: 'P3' },
      { name: 'Gandaki', abbreviation: 'P4' },
      { name: 'Province 5', abbreviation: 'P5' },
      { name: 'Karnali', abbreviation: 'P6' },
      { name: 'Province 7', abbreviation: 'P7' },
    ],
  },
  NRU: {
    regions: [
      { name: 'Aiwo', abbreviation: '01' },
      { name: 'Anabar', abbreviation: '02' },
      { name: 'Anetan', abbreviation: '03' },
      { name: 'Anibare', abbreviation: '04' },
      { name: 'Baitsi', abbreviation: '05' },
      { name: 'Boe', abbreviation: '06' },
      { name: 'Buada', abbreviation: '07' },
      { name: 'Denigomodu', abbreviation: '08' },
      { name: 'Ewa', abbreviation: '09' },
      { name: 'Ijuw', abbreviation: '10' },
      { name: 'Meneng', abbreviation: '11' },
      { name: 'Nibok', abbreviation: '12' },
      { name: 'Uaboe', abbreviation: '13' },
      { name: 'Yaren', abbreviation: '14' },
    ],
  },
  NZL: {
    regions: [
      { name: 'Auckland', abbreviation: 'AUK' },
      { name: 'Bay of Plenty', abbreviation: 'BOP' },
      { name: 'Canterbury', abbreviation: 'CAN' },
      { name: 'Gisborne', abbreviation: 'GIS' },
      { name: "Hawke's Bay", abbreviation: 'HKB' },
      { name: 'Marlborough', abbreviation: 'MBH' },
      { name: 'Manawatu-Wanganui', abbreviation: 'MWT' },
      { name: 'Nelson', abbreviation: 'NSN' },
      { name: 'Northland', abbreviation: 'NTL' },
      { name: 'Otago', abbreviation: 'OTA' },
      { name: 'Southland', abbreviation: 'STL' },
      { name: 'Tasman', abbreviation: 'TAS' },
      { name: 'Taranaki', abbreviation: 'TKI' },
      { name: 'Wellington', abbreviation: 'WGN' },
      { name: 'Waikato', abbreviation: 'WKO' },
      { name: 'West Coast', abbreviation: 'WTC' },
      { name: 'Chatham Islands Territory', abbreviation: 'CIT' },
    ],
  },
  OMN: {
    regions: [
      { name: 'Janūb al Bāţinah', abbreviation: 'BJ' },
      { name: 'Shamāl al Bāţinah', abbreviation: 'BS' },
      { name: 'Al Buraymī', abbreviation: 'BU' },
      { name: 'Ad Dākhilīyah', abbreviation: 'DA' },
      { name: 'Masqaţ', abbreviation: 'MA' },
      { name: 'Musandam', abbreviation: 'MU' },
      { name: 'Janūb ash Sharqīyah', abbreviation: 'SJ' },
      { name: 'Shamāl ash Sharqīyah', abbreviation: 'SS' },
      { name: 'Al Wusţá', abbreviation: 'WU' },
      { name: 'Az̧ Z̧āhirah', abbreviation: 'ZA' },
      { name: 'Z̧ufār', abbreviation: 'ZU' },
    ],
  },
  PAK: {
    regions: [
      { name: 'Gilgit-Baltistan', abbreviation: 'GB' },
      { name: 'Azad Jammu and Kashmir', abbreviation: 'JK' },
      { name: 'Islamabad', abbreviation: 'IS' },
      { name: 'Balochistan', abbreviation: 'BA' },
      { name: 'Khyber Pakhtunkhwa', abbreviation: 'KP' },
      { name: 'Punjab', abbreviation: 'PB' },
      { name: 'Sindh', abbreviation: 'SD' },
    ],
  },
  PAN: {
    regions: [
      { name: 'Emberá', abbreviation: 'EM' },
      { name: 'Guna Yala', abbreviation: 'KY' },
      { name: 'Ngöbe-Buglé', abbreviation: 'NB' },
      { name: 'Bocas del Toro', abbreviation: '1' },
      { name: 'Panamá Oeste', abbreviation: '10' },
      { name: 'Coclé', abbreviation: '2' },
      { name: 'Colón', abbreviation: '3' },
      { name: 'Chiriquí', abbreviation: '4' },
      { name: 'Darién', abbreviation: '5' },
      { name: 'Herrera', abbreviation: '6' },
      { name: 'Los Santos', abbreviation: '7' },
      { name: 'Panamá', abbreviation: '8' },
      { name: 'Veraguas', abbreviation: '9' },
    ],
  },
  PER: {
    regions: [
      { name: 'Amasunu', abbreviation: 'AMA' },
      { name: 'Ankashu', abbreviation: 'ANC' },
      { name: 'Apurimaq', abbreviation: 'APU' },
      { name: 'Arikipa', abbreviation: 'ARE' },
      { name: 'Ayaquchu', abbreviation: 'AYA' },
      { name: 'Qajamarka', abbreviation: 'CAJ' },
      { name: 'Kallao', abbreviation: 'CAL' },
      { name: 'Kusku', abbreviation: 'CUS' },
      { name: 'Wanuku', abbreviation: 'HUC' },
      { name: 'Wankawelika', abbreviation: 'HUV' },
      { name: 'Ika', abbreviation: 'ICA' },
      { name: 'Junin', abbreviation: 'JUN' },
      { name: 'La Libertad', abbreviation: 'LAL' },
      { name: 'Lambayeque', abbreviation: 'LAM' },
      { name: 'Lima', abbreviation: 'LIM' },
      { name: 'Luritu', abbreviation: 'LOR' },
      { name: 'Madre de Dios', abbreviation: 'MDD' },
      { name: 'Moqwegwa', abbreviation: 'MOQ' },
      { name: 'Pasqu', abbreviation: 'PAS' },
      { name: 'Piura', abbreviation: 'PIU' },
      { name: 'Puno', abbreviation: 'PUN' },
      { name: 'San Martín', abbreviation: 'SAM' },
      { name: 'Takna', abbreviation: 'TAC' },
      { name: 'Tumbes', abbreviation: 'TUM' },
      { name: 'Ukayali', abbreviation: 'UCA' },
      { name: 'Lima hatun llaqta', abbreviation: 'LMA' },
    ],
  },
  PHL: {
    regions: [
      { name: 'National Capital Region', abbreviation: '00' },
      { name: 'Ilocos (Region I)', abbreviation: '01' },
      { name: 'Ilocos Norte', abbreviation: 'ILN' },
      { name: 'Ilocos Sur', abbreviation: 'ILS' },
      { name: 'La Union', abbreviation: 'LUN' },
      { name: 'Pangasinan', abbreviation: 'PAN' },
      { name: 'Cagayan Valley (Region II)', abbreviation: '02' },
      { name: 'Batanes', abbreviation: 'BTN' },
      { name: 'Cagayan', abbreviation: 'CAG' },
      { name: 'Isabela', abbreviation: 'ISA' },
      { name: 'Nueva Vizcaya', abbreviation: 'NUV' },
      { name: 'Quirino', abbreviation: 'QUI' },
      { name: 'Central Luzon (Region III)', abbreviation: '03' },
      { name: 'Aurora', abbreviation: 'AUR' },
      { name: 'Bataan', abbreviation: 'BAN' },
      { name: 'Bulacan', abbreviation: 'BUL' },
      { name: 'Nueva Ecija', abbreviation: 'NUE' },
      { name: 'Pampanga', abbreviation: 'PAM' },
      { name: 'Tarlac', abbreviation: 'TAR' },
      { name: 'Zambales', abbreviation: 'ZMB' },
      { name: 'Bicol (Region V)', abbreviation: '05' },
      { name: 'Albay', abbreviation: 'ALB' },
      { name: 'Camarines Norte', abbreviation: 'CAN' },
      { name: 'Camarines Sur', abbreviation: 'CAS' },
      { name: 'Catanduanes', abbreviation: 'CAT' },
      { name: 'Masbate', abbreviation: 'MAS' },
      { name: 'Sorsogon', abbreviation: 'SOR' },
      { name: 'Western Visayas (Region VI)', abbreviation: '06' },
      { name: 'Aklan', abbreviation: 'AKL' },
      { name: 'Antique', abbreviation: 'ANT' },
      { name: 'Capiz', abbreviation: 'CAP' },
      { name: 'Guimaras', abbreviation: 'GUI' },
      { name: 'Iloilo', abbreviation: 'ILI' },
      { name: 'Negros Occidental', abbreviation: 'NEC' },
      { name: 'Central Visayas (Region VII)', abbreviation: '07' },
      { name: 'Bohol', abbreviation: 'BOH' },
      { name: 'Cebu', abbreviation: 'CEB' },
      { name: 'Negros Oriental', abbreviation: 'NER' },
      { name: 'Siquijor', abbreviation: 'SIG' },
      { name: 'Eastern Visayas (Region VIII)', abbreviation: '08' },
      { name: 'Biliran', abbreviation: 'BIL' },
      { name: 'Eastern Samar', abbreviation: 'EAS' },
      { name: 'Leyte', abbreviation: 'LEY' },
      { name: 'Northern Samar', abbreviation: 'NSA' },
      { name: 'Southern Leyte', abbreviation: 'SLE' },
      { name: 'Samar', abbreviation: 'WSA' },
      { name: 'Zamboanga Peninsula (Region IX)', abbreviation: '09' },
      { name: 'Basilan', abbreviation: 'BAS' },
      { name: 'Zamboanga del Norte', abbreviation: 'ZAN' },
      { name: 'Zamboanga del Sur', abbreviation: 'ZAS' },
      { name: 'Zamboanga Sibugay', abbreviation: 'ZSI' },
      { name: 'Northern Mindanao (Region X)', abbreviation: '10' },
      { name: 'Bukidnon', abbreviation: 'BUK' },
      { name: 'Camiguin', abbreviation: 'CAM' },
      { name: 'Misamis Occidental', abbreviation: 'MSC' },
      { name: 'Misamis Oriental', abbreviation: 'MSR' },
      { name: 'Davao (Region XI)', abbreviation: '11' },
      { name: 'Compostela Valley', abbreviation: 'COM' },
      { name: 'Davao Oriental', abbreviation: 'DAO' },
      { name: 'Davao del Sur', abbreviation: 'DAS' },
      { name: 'Davao del Norte', abbreviation: 'DAV' },
      { name: 'Davao Occidental', abbreviation: 'DVO' },
      { name: 'Sarangani', abbreviation: 'SAR' },
      { name: 'South Cotabato', abbreviation: 'SCO' },
      { name: 'Soccsksargen (Region XII)', abbreviation: '12' },
      { name: 'Lanao del Norte', abbreviation: 'LAN' },
      { name: 'Cotabato', abbreviation: 'NCO' },
      { name: 'Sultan Kudarat', abbreviation: 'SUK' },
      { name: 'Caraga (Region XIII)', abbreviation: '13' },
      { name: 'Agusan del Norte', abbreviation: 'AGN' },
      { name: 'Agusan del Sur', abbreviation: 'AGS' },
      { name: 'Dinagat Islands', abbreviation: 'DIN' },
      { name: 'Surigao del Norte', abbreviation: 'SUN' },
      { name: 'Surigao del Sur', abbreviation: 'SUR' },
      {
        name: 'Autonomous Region in Muslim Mindanao (ARMM)',
        abbreviation: '14',
      },
      { name: 'Lanao del Sur', abbreviation: 'LAS' },
      { name: 'Maguindanao', abbreviation: 'MAG' },
      { name: 'Sulu', abbreviation: 'SLU' },
      { name: 'Tawi-Tawi', abbreviation: 'TAW' },
      { name: 'Cordillera Administrative Region (CAR)', abbreviation: '15' },
      { name: 'Abra', abbreviation: 'ABR' },
      { name: 'Apayao', abbreviation: 'APA' },
      { name: 'Benguet', abbreviation: 'BEN' },
      { name: 'Ifugao', abbreviation: 'IFU' },
      { name: 'Kalinga', abbreviation: 'KAL' },
      { name: 'Mountain Province', abbreviation: 'MOU' },
      { name: 'Calabarzon (Region IV-A)', abbreviation: '40' },
      { name: 'Batangas', abbreviation: 'BTG' },
      { name: 'Cavite', abbreviation: 'CAV' },
      { name: 'Laguna', abbreviation: 'LAG' },
      { name: 'Quezon', abbreviation: 'QUE' },
      { name: 'Rizal', abbreviation: 'RIZ' },
      { name: 'Mimaropa (Region IV-B)', abbreviation: '41' },
      { name: 'Marinduque', abbreviation: 'MAD' },
      { name: 'Mindoro Occidental', abbreviation: 'MDC' },
      { name: 'Mindoro Oriental', abbreviation: 'MDR' },
      { name: 'Palawan', abbreviation: 'PLW' },
      { name: 'Romblon', abbreviation: 'ROM' },
    ],
  },
  PLW: {
    regions: [
      { name: 'Aimeliik', abbreviation: '002' },
      { name: 'Airai', abbreviation: '004' },
      { name: 'Angaur', abbreviation: '010' },
      { name: 'Hatohobei', abbreviation: '050' },
      { name: 'Kayangel', abbreviation: '100' },
      { name: 'Koror', abbreviation: '150' },
      { name: 'Melekeok', abbreviation: '212' },
      { name: 'Ngaraard', abbreviation: '214' },
      { name: 'Ngarchelong', abbreviation: '218' },
      { name: 'Ngardmau', abbreviation: '222' },
      { name: 'Ngatpang', abbreviation: '224' },
      { name: 'Ngchesar', abbreviation: '226' },
      { name: 'Ngeremlengui', abbreviation: '227' },
      { name: 'Ngiwal', abbreviation: '228' },
      { name: 'Peleliu', abbreviation: '350' },
      { name: 'Sonsorol', abbreviation: '370' },
    ],
  },
  PNG: {
    regions: [
      { name: 'National Capital District (Port Moresby)', abbreviation: 'NCD' },
      { name: 'Chimbu', abbreviation: 'CPK' },
      { name: 'Central', abbreviation: 'CPM' },
      { name: 'East New Britain', abbreviation: 'EBR' },
      { name: 'Eastern Highlands', abbreviation: 'EHG' },
      { name: 'Enga', abbreviation: 'EPW' },
      { name: 'East Sepik', abbreviation: 'ESW' },
      { name: 'Gulf', abbreviation: 'GPK' },
      { name: 'Hela', abbreviation: 'HLA' },
      { name: 'Jiwaka', abbreviation: 'JWK' },
      { name: 'Milne Bay', abbreviation: 'MBA' },
      { name: 'Morobe', abbreviation: 'MPL' },
      { name: 'Madang', abbreviation: 'MPM' },
      { name: 'Manus', abbreviation: 'MRL' },
      { name: 'New Ireland', abbreviation: 'NIK' },
      { name: 'Northern', abbreviation: 'NPP' },
      { name: 'West Sepik', abbreviation: 'SAN' },
      { name: 'Southern Highlands', abbreviation: 'SHM' },
      { name: 'West New Britain', abbreviation: 'WBK' },
      { name: 'Western Highlands', abbreviation: 'WHM' },
      { name: 'Western', abbreviation: 'WPD' },
      { name: 'Bougainville', abbreviation: 'NSB' },
    ],
  },
  POL: {
    regions: [
      { name: 'Dolnośląskie', abbreviation: '02' },
      { name: 'Kujawsko-pomorskie', abbreviation: '04' },
      { name: 'Lubelskie', abbreviation: '06' },
      { name: 'Lubuskie', abbreviation: '08' },
      { name: 'Łódzkie', abbreviation: '10' },
      { name: 'Małopolskie', abbreviation: '12' },
      { name: 'Mazowieckie', abbreviation: '14' },
      { name: 'Opolskie', abbreviation: '16' },
      { name: 'Podkarpackie', abbreviation: '18' },
      { name: 'Podlaskie', abbreviation: '20' },
      { name: 'Pomorskie', abbreviation: '22' },
      { name: 'Śląskie', abbreviation: '24' },
      { name: 'Świętokrzyskie', abbreviation: '26' },
      { name: 'Warmińsko-mazurskie', abbreviation: '28' },
      { name: 'Wielkopolskie', abbreviation: '30' },
      { name: 'Zachodniopomorskie', abbreviation: '32' },
    ],
  },
  PRK: {
    regions: [
      { name: 'Raseon', abbreviation: '13' },
      { name: 'Phyeongannamto', abbreviation: '02' },
      { name: "P'yǒngan-bukto", abbreviation: '03' },
      { name: 'Chagang-do', abbreviation: '04' },
      { name: 'Hwanghae-namdo', abbreviation: '05' },
      { name: 'Hwanghae-bukto', abbreviation: '06' },
      { name: 'Kangweonto', abbreviation: '07' },
      { name: 'Hamgyǒng-namdo', abbreviation: '08' },
      { name: 'Hamkyeongpukto', abbreviation: '09' },
      { name: 'Ryangkangto', abbreviation: '10' },
      { name: "P'yǒngyang", abbreviation: '01' },
      { name: 'Namp’o', abbreviation: '14' },
    ],
  },
  PRT: {
    regions: [
      { name: 'Região Autónoma dos Açores', abbreviation: '20' },
      { name: 'Região Autónoma da Madeira', abbreviation: '30' },
      { name: 'Aveiro', abbreviation: '01' },
      { name: 'Beja', abbreviation: '02' },
      { name: 'Braga', abbreviation: '03' },
      { name: 'Bragança', abbreviation: '04' },
      { name: 'Castelo Branco', abbreviation: '05' },
      { name: 'Coimbra', abbreviation: '06' },
      { name: 'Évora', abbreviation: '07' },
      { name: 'Faro', abbreviation: '08' },
      { name: 'Guarda', abbreviation: '09' },
      { name: 'Leiria', abbreviation: '10' },
      { name: 'Lisboa', abbreviation: '11' },
      { name: 'Portalegre', abbreviation: '12' },
      { name: 'Porto', abbreviation: '13' },
      { name: 'Santarém', abbreviation: '14' },
      { name: 'Setúbal', abbreviation: '15' },
      { name: 'Viana do Castelo', abbreviation: '16' },
      { name: 'Vila Real', abbreviation: '17' },
      { name: 'Viseu', abbreviation: '18' },
    ],
  },
  PRY: {
    regions: [
      { name: 'Concepción', abbreviation: '1' },
      { name: 'Alto Paraná', abbreviation: '10' },
      { name: 'Central', abbreviation: '11' },
      { name: 'Ñeembucú', abbreviation: '12' },
      { name: 'Amambay', abbreviation: '13' },
      { name: 'Canindeyú', abbreviation: '14' },
      { name: 'Presidente Hayes', abbreviation: '15' },
      { name: 'Alto Paraguay', abbreviation: '16' },
      { name: 'Boquerón', abbreviation: '19' },
      { name: 'San Pedro', abbreviation: '2' },
      { name: 'Cordillera', abbreviation: '3' },
      { name: 'Guairá', abbreviation: '4' },
      { name: 'Caaguazú', abbreviation: '5' },
      { name: 'Caazapá', abbreviation: '6' },
      { name: 'Itapúa', abbreviation: '7' },
      { name: 'Misiones', abbreviation: '8' },
      { name: 'Paraguarí', abbreviation: '9' },
      { name: 'Asunción', abbreviation: 'ASU' },
    ],
  },
  PSE: {
    regions: [
      { name: 'Bayt Laḩm', abbreviation: 'BTH' },
      { name: 'Deir El Balah', abbreviation: 'DEB' },
      { name: 'Gaza', abbreviation: 'GZA' },
      { name: 'Hebron', abbreviation: 'HBN' },
      { name: 'Jerusalem', abbreviation: 'JEM' },
      { name: 'Jenin', abbreviation: 'JEN' },
      { name: 'Jericho and Al Aghwar', abbreviation: 'JRH' },
      { name: 'Khan Yunis', abbreviation: 'KYS' },
      { name: 'Nablus', abbreviation: 'NBS' },
      { name: 'North Gaza', abbreviation: 'NGZ' },
      { name: 'Qalqilya', abbreviation: 'QQA' },
      { name: 'Ramallah', abbreviation: 'RBH' },
      { name: 'Rafah', abbreviation: 'RFH' },
      { name: 'Salfit', abbreviation: 'SLT' },
      { name: 'Tubas', abbreviation: 'TBS' },
      { name: 'Tulkarm', abbreviation: 'TKM' },
    ],
  },
  QAT: {
    regions: [
      { name: 'Ad Dawḩah', abbreviation: 'DA' },
      { name: 'Al Khawr wa adh Dhakhīrah', abbreviation: 'KH' },
      { name: 'Ash Shamāl', abbreviation: 'MS' },
      { name: 'Ar Rayyān', abbreviation: 'RA' },
      { name: 'Ash Shīḩānīyah', abbreviation: 'SH' },
      { name: 'Umm Şalāl', abbreviation: 'US' },
      { name: 'Al Wakrah', abbreviation: 'WA' },
      { name: 'Az̧ Z̧a‘āyin', abbreviation: 'ZA' },
    ],
  },
  ROU: {
    regions: [
      { name: 'Alba', abbreviation: 'AB' },
      { name: 'Argeș', abbreviation: 'AG' },
      { name: 'Arad', abbreviation: 'AR' },
      { name: 'Bacău', abbreviation: 'BC' },
      { name: 'Bihor', abbreviation: 'BH' },
      { name: 'Bistrița-Năsăud', abbreviation: 'BN' },
      { name: 'Brăila', abbreviation: 'BR' },
      { name: 'Botoșani', abbreviation: 'BT' },
      { name: 'Brașov', abbreviation: 'BV' },
      { name: 'Buzău', abbreviation: 'BZ' },
      { name: 'Cluj', abbreviation: 'CJ' },
      { name: 'Călărași', abbreviation: 'CL' },
      { name: 'Caraș-Severin', abbreviation: 'CS' },
      { name: 'Constanța', abbreviation: 'CT' },
      { name: 'Covasna', abbreviation: 'CV' },
      { name: 'Dâmbovița', abbreviation: 'DB' },
      { name: 'Dolj', abbreviation: 'DJ' },
      { name: 'Gorj', abbreviation: 'GJ' },
      { name: 'Galați', abbreviation: 'GL' },
      { name: 'Giurgiu', abbreviation: 'GR' },
      { name: 'Hunedoara', abbreviation: 'HD' },
      { name: 'Harghita', abbreviation: 'HR' },
      { name: 'Ilfov', abbreviation: 'IF' },
      { name: 'Ialomița', abbreviation: 'IL' },
      { name: 'Iași', abbreviation: 'IS' },
      { name: 'Mehedinți', abbreviation: 'MH' },
      { name: 'Maramureș', abbreviation: 'MM' },
      { name: 'Mureș', abbreviation: 'MS' },
      { name: 'Neamț', abbreviation: 'NT' },
      { name: 'Olt', abbreviation: 'OT' },
      { name: 'Prahova', abbreviation: 'PH' },
      { name: 'Sibiu', abbreviation: 'SB' },
      { name: 'Sălaj', abbreviation: 'SJ' },
      { name: 'Satu Mare', abbreviation: 'SM' },
      { name: 'Suceava', abbreviation: 'SV' },
      { name: 'Tulcea', abbreviation: 'TL' },
      { name: 'Timiș', abbreviation: 'TM' },
      { name: 'Teleorman', abbreviation: 'TR' },
      { name: 'Vâlcea', abbreviation: 'VL' },
      { name: 'Vrancea', abbreviation: 'VN' },
      { name: 'Vaslui', abbreviation: 'VS' },
      { name: 'București', abbreviation: 'B' },
    ],
  },
  RUS: {
    regions: [
      { name: "Amurskaya oblast'", abbreviation: 'AMU' },
      { name: "Arkhangel'skaya oblast'", abbreviation: 'ARK' },
      { name: "Astrakhanskaya oblast'", abbreviation: 'AST' },
      { name: "Belgorodskaya oblast'", abbreviation: 'BEL' },
      { name: "Bryanskaya oblast'", abbreviation: 'BRY' },
      { name: "Čeljabinskaja oblast'", abbreviation: 'CHE' },
      { name: "Irkutskaya oblast'", abbreviation: 'IRK' },
      { name: "Ivanovskaya oblast'", abbreviation: 'IVA' },
      { name: "Kemerovskaya oblast'", abbreviation: 'KEM' },
      { name: "Kaliningradskaya oblast'", abbreviation: 'KGD' },
      { name: "Kurganskaja oblast'", abbreviation: 'KGN' },
      { name: "Kirovskaja oblast'", abbreviation: 'KIR' },
      { name: "Kalužskaja oblast'", abbreviation: 'KLU' },
      { name: "Kostromskaya oblast'", abbreviation: 'KOS' },
      { name: "Kurskaja oblast'", abbreviation: 'KRS' },
      { name: "Leningradskaja oblast'", abbreviation: 'LEN' },
      { name: "Lipeckaja oblast'", abbreviation: 'LIP' },
      { name: "Magadanskaya oblast'", abbreviation: 'MAG' },
      { name: "Moskovskaya oblast'", abbreviation: 'MOS' },
      { name: "Murmanskaya oblast'", abbreviation: 'MUR' },
      { name: "Novgorodskaja oblast'", abbreviation: 'NGR' },
      { name: "Nižegorodskaja oblast'", abbreviation: 'NIZ' },
      { name: "Novosibirskaya oblast'", abbreviation: 'NVS' },
      { name: "Omskaya oblast'", abbreviation: 'OMS' },
      { name: "Orenburgskaja oblast'", abbreviation: 'ORE' },
      { name: "Orlovskaja oblast'", abbreviation: 'ORL' },
      { name: "Penzenskaya oblast'", abbreviation: 'PNZ' },
      { name: "Pskovskaya oblast'", abbreviation: 'PSK' },
      { name: "Rostovskaya oblast'", abbreviation: 'ROS' },
      { name: "Rjazanskaja oblast'", abbreviation: 'RYA' },
      { name: "Sahalinskaja oblast'", abbreviation: 'SAK' },
      { name: "Samarskaya oblast'", abbreviation: 'SAM' },
      { name: "Saratovskaya oblast'", abbreviation: 'SAR' },
      { name: "Smolenskaja oblast'", abbreviation: 'SMO' },
      { name: "Sverdlovskaya oblast'", abbreviation: 'SVE' },
      { name: "Tambovskaya oblast'", abbreviation: 'TAM' },
      { name: "Tomskaya oblast'", abbreviation: 'TOM' },
      { name: "Tul'skaja oblast'", abbreviation: 'TUL' },
      { name: "Tverskaja oblast'", abbreviation: 'TVE' },
      { name: "Tyumenskaya oblast'", abbreviation: 'TYU' },
      { name: "Ul'janovskaja oblast'", abbreviation: 'ULY' },
      { name: "Volgogradskaja oblast'", abbreviation: 'VGG' },
      { name: "Vladimirskaya oblast'", abbreviation: 'VLA' },
      { name: "Vologodskaya oblast'", abbreviation: 'VLG' },
      { name: "Voronežskaja oblast'", abbreviation: 'VOR' },
      { name: "Jaroslavskaja oblast'", abbreviation: 'YAR' },
      { name: 'Chukotskiy avtonomnyy okrug', abbreviation: 'CHU' },
      { name: 'Khanty-Mansiyskiy avtonomnyy okrug', abbreviation: 'KHM' },
      { name: 'Neneckij avtonomnyj okrug', abbreviation: 'NEN' },
      { name: 'Jamalo-Neneckij avtonomnyj okrug', abbreviation: 'YAN' },
      { name: 'Moskva', abbreviation: 'MOW' },
      { name: 'Sankt-Peterburg', abbreviation: 'SPE' },
      { name: "Yevreyskaya avtonomnaya oblast'", abbreviation: 'YEV' },
      { name: 'Altajskij kraj', abbreviation: 'ALT' },
      { name: 'Kamchatskiy kray', abbreviation: 'KAM' },
      { name: 'Krasnodarskiy kray', abbreviation: 'KDA' },
      { name: 'Khabarovskiy kray', abbreviation: 'KHA' },
      { name: 'Krasnojarskij kraj', abbreviation: 'KYA' },
      { name: 'Permskiy kray', abbreviation: 'PER' },
      { name: 'Primorskiy kray', abbreviation: 'PRI' },
      { name: "Stavropol'skiy kray", abbreviation: 'STA' },
      { name: "Zabaykal'skiy kray", abbreviation: 'ZAB' },
      { name: 'Adygeya, Respublika', abbreviation: 'AD' },
      { name: 'Altaj, Respublika', abbreviation: 'AL' },
      { name: 'Baškortostan, Respublika', abbreviation: 'BA' },
      { name: 'Buryatiya, Respublika', abbreviation: 'BU' },
      { name: 'Čečenskaja Respublika', abbreviation: 'CE' },
      { name: 'Čuvašskaja Respublika', abbreviation: 'CU' },
      { name: 'Dagestan, Respublika', abbreviation: 'DA' },
      { name: 'Ingušetija, Respublika', abbreviation: 'IN' },
      { name: 'Kabardino-Balkarskaya Respublika', abbreviation: 'KB' },
      { name: 'Karachayevo-Cherkesskaya Respublika', abbreviation: 'KC' },
      { name: 'Hakasija, Respublika', abbreviation: 'KK' },
      { name: 'Kalmykija, Respublika', abbreviation: 'KL' },
      { name: 'Komi, Respublika', abbreviation: 'KO' },
      { name: 'Kareliya, Respublika', abbreviation: 'KR' },
      { name: 'Mariy El, Respublika', abbreviation: 'ME' },
      { name: 'Mordoviya, Respublika', abbreviation: 'MO' },
      { name: 'Saha, Respublika', abbreviation: 'SA' },
      { name: 'Severnaya Osetiya, Respublika', abbreviation: 'SE' },
      { name: 'Tatarstan, Respublika', abbreviation: 'TA' },
      { name: 'Tyva, Respublika', abbreviation: 'TY' },
      { name: 'Udmurtskaya Respublika', abbreviation: 'UD' },
    ],
  },
  RWA: {
    regions: [
      { name: 'City of Kigali', abbreviation: '01' },
      { name: 'Eastern', abbreviation: '02' },
      { name: 'Northern', abbreviation: '03' },
      { name: 'Western', abbreviation: '04' },
      { name: 'Southern', abbreviation: '05' },
    ],
  },
  SAU: {
    regions: [
      { name: 'Ar Riyāḑ', abbreviation: '01' },
      { name: 'Makkah al Mukarramah', abbreviation: '02' },
      { name: 'Al Madīnah al Munawwarah', abbreviation: '03' },
      { name: 'Ash Sharqīyah', abbreviation: '04' },
      { name: 'Al Qaşīm', abbreviation: '05' },
      { name: "Ḩā'il", abbreviation: '06' },
      { name: 'Tabūk', abbreviation: '07' },
      { name: 'Al Ḩudūd ash Shamālīyah', abbreviation: '08' },
      { name: 'Jāzān', abbreviation: '09' },
      { name: 'Najrān', abbreviation: '10' },
      { name: 'Al Bāḩah', abbreviation: '11' },
      { name: 'Al Jawf', abbreviation: '12' },
      { name: "'Asīr", abbreviation: '14' },
    ],
  },
  SDN: {
    regions: [
      { name: 'Wasaţ Dārfūr Zālinjay', abbreviation: 'DC' },
      { name: 'East Darfur', abbreviation: 'DE' },
      { name: 'North Darfur', abbreviation: 'DN' },
      { name: 'South Darfur', abbreviation: 'DS' },
      { name: 'West Darfur', abbreviation: 'DW' },
      { name: 'Gedaref', abbreviation: 'GD' },
      { name: 'West Kordofan', abbreviation: 'GK' },
      { name: 'Gezira', abbreviation: 'GZ' },
      { name: 'Kassala', abbreviation: 'KA' },
      { name: 'Khartoum', abbreviation: 'KH' },
      { name: 'North Kordofan', abbreviation: 'KN' },
      { name: 'South Kordofan', abbreviation: 'KS' },
      { name: 'Blue Nile', abbreviation: 'NB' },
      { name: 'Northern', abbreviation: 'NO' },
      { name: 'River Nile', abbreviation: 'NR' },
      { name: 'White Nile', abbreviation: 'NW' },
      { name: 'Red Sea', abbreviation: 'RS' },
      { name: 'Sennar', abbreviation: 'SI' },
    ],
  },
  SEN: {
    regions: [
      { name: 'Diourbel', abbreviation: 'DB' },
      { name: 'Dakar', abbreviation: 'DK' },
      { name: 'Fatick', abbreviation: 'FK' },
      { name: 'Kaffrine', abbreviation: 'KA' },
      { name: 'Kolda', abbreviation: 'KD' },
      { name: 'Kédougou', abbreviation: 'KE' },
      { name: 'Kaolack', abbreviation: 'KL' },
      { name: 'Louga', abbreviation: 'LG' },
      { name: 'Matam', abbreviation: 'MT' },
      { name: 'Sédhiou', abbreviation: 'SE' },
      { name: 'Saint-Louis', abbreviation: 'SL' },
      { name: 'Tambacounda', abbreviation: 'TC' },
      { name: 'Thiès', abbreviation: 'TH' },
      { name: 'Ziguinchor', abbreviation: 'ZG' },
    ],
  },
  SGP: {
    regions: [
      { name: 'Central Singapore', abbreviation: '01' },
      { name: 'North East', abbreviation: '02' },
      { name: 'North West', abbreviation: '03' },
      { name: 'South East', abbreviation: '04' },
      { name: 'South West', abbreviation: '05' },
    ],
  },
  SHN: {
    regions: [
      { name: 'Ascension', abbreviation: 'AC' },
      { name: 'Saint Helena', abbreviation: 'HL' },
      { name: 'Tristan da Cunha', abbreviation: 'TA' },
    ],
  },
  SLB: {
    regions: [
      { name: 'Central', abbreviation: 'CE' },
      { name: 'Choiseul', abbreviation: 'CH' },
      { name: 'Guadalcanal', abbreviation: 'GU' },
      { name: 'Isabel', abbreviation: 'IS' },
      { name: 'Makira-Ulawa', abbreviation: 'MK' },
      { name: 'Malaita', abbreviation: 'ML' },
      { name: 'Rennell and Bellona', abbreviation: 'RB' },
      { name: 'Temotu', abbreviation: 'TE' },
      { name: 'Western', abbreviation: 'WE' },
      { name: 'Capital Territory (Honiara)', abbreviation: 'CT' },
    ],
  },
  SLE: {
    regions: [
      { name: 'Western Area (Freetown)', abbreviation: 'W' },
      { name: 'Eastern', abbreviation: 'E' },
      { name: 'Northern', abbreviation: 'N' },
      { name: 'North Western', abbreviation: 'NW' },
      { name: 'Southern', abbreviation: 'S' },
    ],
  },
  SLV: {
    regions: [
      { name: 'Ahuachapán', abbreviation: 'AH' },
      { name: 'Cabañas', abbreviation: 'CA' },
      { name: 'Chalatenango', abbreviation: 'CH' },
      { name: 'Cuscatlán', abbreviation: 'CU' },
      { name: 'La Libertad', abbreviation: 'LI' },
      { name: 'Morazán', abbreviation: 'MO' },
      { name: 'La Paz', abbreviation: 'PA' },
      { name: 'Santa Ana', abbreviation: 'SA' },
      { name: 'San Miguel', abbreviation: 'SM' },
      { name: 'Sonsonate', abbreviation: 'SO' },
      { name: 'San Salvador', abbreviation: 'SS' },
      { name: 'San Vicente', abbreviation: 'SV' },
      { name: 'La Unión', abbreviation: 'UN' },
      { name: 'Usulután', abbreviation: 'US' },
    ],
  },
  SMR: {
    regions: [
      { name: 'Acquaviva', abbreviation: '01' },
      { name: 'Chiesanuova', abbreviation: '02' },
      { name: 'Domagnano', abbreviation: '03' },
      { name: 'Faetano', abbreviation: '04' },
      { name: 'Fiorentino', abbreviation: '05' },
      { name: 'Borgo Maggiore', abbreviation: '06' },
      { name: 'San Marino', abbreviation: '07' },
      { name: 'Montegiardino', abbreviation: '08' },
      { name: 'Serravalle', abbreviation: '09' },
    ],
  },
  SOM: {
    regions: [
      { name: 'Awdal', abbreviation: 'AW' },
      { name: 'Bakool', abbreviation: 'BK' },
      { name: 'Banaadir', abbreviation: 'BN' },
      { name: 'Bari', abbreviation: 'BR' },
      { name: 'Bay', abbreviation: 'BY' },
      { name: 'Galguduud', abbreviation: 'GA' },
      { name: 'Gedo', abbreviation: 'GE' },
      { name: 'Hiiraan', abbreviation: 'HI' },
      { name: 'Jubbada Dhexe', abbreviation: 'JD' },
      { name: 'Jubbada Hoose', abbreviation: 'JH' },
      { name: 'Mudug', abbreviation: 'MU' },
      { name: 'Nugaal', abbreviation: 'NU' },
      { name: 'Sanaag', abbreviation: 'SA' },
      { name: 'Shabeellaha Dhexe', abbreviation: 'SD' },
      { name: 'Shabeellaha Hoose', abbreviation: 'SH' },
      { name: 'Sool', abbreviation: 'SO' },
      { name: 'Togdheer', abbreviation: 'TO' },
      { name: 'Woqooyi Galbeed', abbreviation: 'WO' },
    ],
  },
  SRB: {
    regions: [
      { name: 'Kosovo-Metohija', abbreviation: 'KM' },
      { name: 'Kosovski okrug', abbreviation: '25' },
      { name: 'Pećki okrug', abbreviation: '26' },
      { name: 'Prizrenski okrug', abbreviation: '27' },
      { name: 'Kosovsko-Mitrovački okrug', abbreviation: '28' },
      { name: 'Kosovsko-Pomoravski okrug', abbreviation: '29' },
      { name: 'Vojvodina', abbreviation: 'VO' },
      { name: 'Severnobački okrug', abbreviation: '01' },
      { name: 'Srednjebanatski okrug', abbreviation: '02' },
      { name: 'Severnobanatski okrug', abbreviation: '03' },
      { name: 'Južnobanatski okrug', abbreviation: '04' },
      { name: 'Zapadnobački okrug', abbreviation: '05' },
      { name: 'Južnobački okrug', abbreviation: '06' },
      { name: 'Sremski okrug', abbreviation: '07' },
      { name: 'Beograd', abbreviation: '00' },
      { name: 'Mačvanski okrug', abbreviation: '08' },
      { name: 'Kolubarski okrug', abbreviation: '09' },
      { name: 'Podunavski okrug', abbreviation: '10' },
      { name: 'Braničevski okrug', abbreviation: '11' },
      { name: 'Šumadijski okrug', abbreviation: '12' },
      { name: 'Pomoravski okrug', abbreviation: '13' },
      { name: 'Borski okrug', abbreviation: '14' },
      { name: 'Zaječarski okrug', abbreviation: '15' },
      { name: 'Zlatiborski okrug', abbreviation: '16' },
      { name: 'Moravički okrug', abbreviation: '17' },
      { name: 'Raški okrug', abbreviation: '18' },
      { name: 'Rasinski okrug', abbreviation: '19' },
      { name: 'Nišavski okrug', abbreviation: '20' },
      { name: 'Toplički okrug', abbreviation: '21' },
      { name: 'Pirotski okrug', abbreviation: '22' },
      { name: 'Jablanički okrug', abbreviation: '23' },
      { name: 'Pčinjski okrug', abbreviation: '24' },
    ],
  },
  SSD: {
    regions: [
      { name: 'Northern Bahr el Ghazal', abbreviation: 'BN' },
      { name: 'Western Bahr el  Ghazal', abbreviation: 'BW' },
      { name: 'Central Equatoria', abbreviation: 'EC' },
      { name: 'Eastern Equatoria', abbreviation: 'EE' },
      { name: 'Western Equatoria', abbreviation: 'EW' },
      { name: 'Jonglei', abbreviation: 'JG' },
      { name: 'Lakes', abbreviation: 'LK' },
      { name: 'Upper Nile', abbreviation: 'NU' },
      { name: 'Unity', abbreviation: 'UY' },
      { name: 'Warrap', abbreviation: 'WR' },
    ],
  },
  STP: {
    regions: [
      { name: 'Príncipe', abbreviation: 'P' },
      { name: 'São Tomé', abbreviation: 'S' },
    ],
  },
  SUR: {
    regions: [
      { name: 'Brokopondo', abbreviation: 'BR' },
      { name: 'Commewijne', abbreviation: 'CM' },
      { name: 'Coronie', abbreviation: 'CR' },
      { name: 'Marowijne', abbreviation: 'MA' },
      { name: 'Nickerie', abbreviation: 'NI' },
      { name: 'Paramaribo', abbreviation: 'PM' },
      { name: 'Para', abbreviation: 'PR' },
      { name: 'Saramacca', abbreviation: 'SA' },
      { name: 'Sipaliwini', abbreviation: 'SI' },
      { name: 'Wanica', abbreviation: 'WA' },
    ],
  },
  SVK: {
    regions: [
      { name: 'Banskobystrický kraj', abbreviation: 'BC' },
      { name: 'Bratislavský kraj', abbreviation: 'BL' },
      { name: 'Košický kraj', abbreviation: 'KI' },
      { name: 'Nitriansky kraj', abbreviation: 'NI' },
      { name: 'Prešovský kraj', abbreviation: 'PV' },
      { name: 'Trnavský kraj', abbreviation: 'TA' },
      { name: 'Trenčiansky kraj', abbreviation: 'TC' },
      { name: 'Žilinský kraj', abbreviation: 'ZI' },
    ],
  },
  SVN: {
    regions: [
      { name: 'Ajdovščina', abbreviation: '001' },
      { name: 'Beltinci', abbreviation: '002' },
      { name: 'Bled', abbreviation: '003' },
      { name: 'Bohinj', abbreviation: '004' },
      { name: 'Borovnica', abbreviation: '005' },
      { name: 'Bovec', abbreviation: '006' },
      { name: 'Brda', abbreviation: '007' },
      { name: 'Brezovica', abbreviation: '008' },
      { name: 'Brežice', abbreviation: '009' },
      { name: 'Tišina', abbreviation: '010' },
      { name: 'Celje', abbreviation: '011' },
      { name: 'Cerklje na Gorenjskem', abbreviation: '012' },
      { name: 'Cerknica', abbreviation: '013' },
      { name: 'Cerkno', abbreviation: '014' },
      { name: 'Črenšovci', abbreviation: '015' },
      { name: 'Črna na Koroškem', abbreviation: '016' },
      { name: 'Črnomelj', abbreviation: '017' },
      { name: 'Destrnik', abbreviation: '018' },
      { name: 'Divača', abbreviation: '019' },
      { name: 'Dobrepolje', abbreviation: '020' },
      { name: 'Dobrova-Polhov Gradec', abbreviation: '021' },
      { name: 'Dol pri Ljubljani', abbreviation: '022' },
      { name: 'Domžale', abbreviation: '023' },
      { name: 'Dornava', abbreviation: '024' },
      { name: 'Dravograd', abbreviation: '025' },
      { name: 'Duplek', abbreviation: '026' },
      { name: 'Gorenja vas-Poljane', abbreviation: '027' },
      { name: 'Gorišnica', abbreviation: '028' },
      { name: 'Gornja Radgona', abbreviation: '029' },
      { name: 'Gornji Grad', abbreviation: '030' },
      { name: 'Gornji Petrovci', abbreviation: '031' },
      { name: 'Grosuplje', abbreviation: '032' },
      { name: 'Šalovci', abbreviation: '033' },
      { name: 'Hrastnik', abbreviation: '034' },
      { name: 'Hrpelje-Kozina', abbreviation: '035' },
      { name: 'Idrija', abbreviation: '036' },
      { name: 'Ig', abbreviation: '037' },
      { name: 'Ilirska Bistrica', abbreviation: '038' },
      { name: 'Ivančna Gorica', abbreviation: '039' },
      { name: 'Izola', abbreviation: '040' },
      { name: 'Jesenice', abbreviation: '041' },
      { name: 'Juršinci', abbreviation: '042' },
      { name: 'Kamnik', abbreviation: '043' },
      { name: 'Kanal', abbreviation: '044' },
      { name: 'Kidričevo', abbreviation: '045' },
      { name: 'Kobarid', abbreviation: '046' },
      { name: 'Kobilje', abbreviation: '047' },
      { name: 'Kočevje', abbreviation: '048' },
      { name: 'Komen', abbreviation: '049' },
      { name: 'Koper', abbreviation: '050' },
      { name: 'Kozje', abbreviation: '051' },
      { name: 'Kranj', abbreviation: '052' },
      { name: 'Kranjska Gora', abbreviation: '053' },
      { name: 'Krško', abbreviation: '054' },
      { name: 'Kungota', abbreviation: '055' },
      { name: 'Kuzma', abbreviation: '056' },
      { name: 'Laško', abbreviation: '057' },
      { name: 'Lenart', abbreviation: '058' },
      { name: 'Lendava', abbreviation: '059' },
      { name: 'Litija', abbreviation: '060' },
      { name: 'Ljubljana', abbreviation: '061' },
      { name: 'Ljubno', abbreviation: '062' },
      { name: 'Ljutomer', abbreviation: '063' },
      { name: 'Logatec', abbreviation: '064' },
      { name: 'Loška Dolina', abbreviation: '065' },
      { name: 'Loški Potok', abbreviation: '066' },
      { name: 'Luče', abbreviation: '067' },
      { name: 'Lukovica', abbreviation: '068' },
      { name: 'Majšperk', abbreviation: '069' },
      { name: 'Maribor', abbreviation: '070' },
      { name: 'Medvode', abbreviation: '071' },
      { name: 'Mengeš', abbreviation: '072' },
      { name: 'Metlika', abbreviation: '073' },
      { name: 'Mežica', abbreviation: '074' },
      { name: 'Miren-Kostanjevica', abbreviation: '075' },
      { name: 'Mislinja', abbreviation: '076' },
      { name: 'Moravče', abbreviation: '077' },
      { name: 'Moravske Toplice', abbreviation: '078' },
      { name: 'Mozirje', abbreviation: '079' },
      { name: 'Murska Sobota', abbreviation: '080' },
      { name: 'Muta', abbreviation: '081' },
      { name: 'Naklo', abbreviation: '082' },
      { name: 'Nazarje', abbreviation: '083' },
      { name: 'Nova Gorica', abbreviation: '084' },
      { name: 'Novo Mesto', abbreviation: '085' },
      { name: 'Odranci', abbreviation: '086' },
      { name: 'Ormož', abbreviation: '087' },
      { name: 'Osilnica', abbreviation: '088' },
      { name: 'Pesnica', abbreviation: '089' },
      { name: 'Piran', abbreviation: '090' },
      { name: 'Pivka', abbreviation: '091' },
      { name: 'Podčetrtek', abbreviation: '092' },
      { name: 'Podvelka', abbreviation: '093' },
      { name: 'Postojna', abbreviation: '094' },
      { name: 'Preddvor', abbreviation: '095' },
      { name: 'Ptuj', abbreviation: '096' },
      { name: 'Puconci', abbreviation: '097' },
      { name: 'Rače-Fram', abbreviation: '098' },
      { name: 'Radeče', abbreviation: '099' },
      { name: 'Radenci', abbreviation: '100' },
      { name: 'Radlje ob Dravi', abbreviation: '101' },
      { name: 'Radovljica', abbreviation: '102' },
      { name: 'Ravne na Koroškem', abbreviation: '103' },
      { name: 'Ribnica', abbreviation: '104' },
      { name: 'Rogašovci', abbreviation: '105' },
      { name: 'Rogaška Slatina', abbreviation: '106' },
      { name: 'Rogatec', abbreviation: '107' },
      { name: 'Ruše', abbreviation: '108' },
      { name: 'Semič', abbreviation: '109' },
      { name: 'Sevnica', abbreviation: '110' },
      { name: 'Sežana', abbreviation: '111' },
      { name: 'Slovenj Gradec', abbreviation: '112' },
      { name: 'Slovenska Bistrica', abbreviation: '113' },
      { name: 'Slovenske Konjice', abbreviation: '114' },
      { name: 'Starše', abbreviation: '115' },
      { name: 'Sveti Jurij', abbreviation: '116' },
      { name: 'Šenčur', abbreviation: '117' },
      { name: 'Šentilj', abbreviation: '118' },
      { name: 'Šentjernej', abbreviation: '119' },
      { name: 'Šentjur', abbreviation: '120' },
      { name: 'Škocjan', abbreviation: '121' },
      { name: 'Škofja Loka', abbreviation: '122' },
      { name: 'Škofljica', abbreviation: '123' },
      { name: 'Šmarje pri Jelšah', abbreviation: '124' },
      { name: 'Šmartno ob Paki', abbreviation: '125' },
      { name: 'Šoštanj', abbreviation: '126' },
      { name: 'Štore', abbreviation: '127' },
      { name: 'Tolmin', abbreviation: '128' },
      { name: 'Trbovlje', abbreviation: '129' },
      { name: 'Trebnje', abbreviation: '130' },
      { name: 'Tržič', abbreviation: '131' },
      { name: 'Turnišče', abbreviation: '132' },
      { name: 'Velenje', abbreviation: '133' },
      { name: 'Velike Lašče', abbreviation: '134' },
      { name: 'Videm', abbreviation: '135' },
      { name: 'Vipava', abbreviation: '136' },
      { name: 'Vitanje', abbreviation: '137' },
      { name: 'Vodice', abbreviation: '138' },
      { name: 'Vojnik', abbreviation: '139' },
      { name: 'Vrhnika', abbreviation: '140' },
      { name: 'Vuzenica', abbreviation: '141' },
      { name: 'Zagorje ob Savi', abbreviation: '142' },
      { name: 'Zavrč', abbreviation: '143' },
      { name: 'Zreče', abbreviation: '144' },
      { name: 'Železniki', abbreviation: '146' },
      { name: 'Žiri', abbreviation: '147' },
      { name: 'Benedikt', abbreviation: '148' },
      { name: 'Bistrica ob Sotli', abbreviation: '149' },
      { name: 'Bloke', abbreviation: '150' },
      { name: 'Braslovče', abbreviation: '151' },
      { name: 'Cankova', abbreviation: '152' },
      { name: 'Cerkvenjak', abbreviation: '153' },
      { name: 'Dobje', abbreviation: '154' },
      { name: 'Dobrna', abbreviation: '155' },
      { name: 'Dobrovnik', abbreviation: '156' },
      { name: 'Dolenjske Toplice', abbreviation: '157' },
      { name: 'Grad', abbreviation: '158' },
      { name: 'Hajdina', abbreviation: '159' },
      { name: 'Hoče-Slivnica', abbreviation: '160' },
      { name: 'Hodoš', abbreviation: '161' },
      { name: 'Horjul', abbreviation: '162' },
      { name: 'Jezersko', abbreviation: '163' },
      { name: 'Komenda', abbreviation: '164' },
      { name: 'Kostel', abbreviation: '165' },
      { name: 'Križevci', abbreviation: '166' },
      { name: 'Lovrenc na Pohorju', abbreviation: '167' },
      { name: 'Markovci', abbreviation: '168' },
      { name: 'Miklavž na Dravskem Polju', abbreviation: '169' },
      { name: 'Mirna Peč', abbreviation: '170' },
      { name: 'Oplotnica', abbreviation: '171' },
      { name: 'Podlehnik', abbreviation: '172' },
      { name: 'Polzela', abbreviation: '173' },
      { name: 'Prebold', abbreviation: '174' },
      { name: 'Prevalje', abbreviation: '175' },
      { name: 'Razkrižje', abbreviation: '176' },
      { name: 'Ribnica na Pohorju', abbreviation: '177' },
      { name: 'Selnica ob Dravi', abbreviation: '178' },
      { name: 'Sodražica', abbreviation: '179' },
      { name: 'Solčava', abbreviation: '180' },
      { name: 'Sveta Ana', abbreviation: '181' },
      { name: 'Sveti Andraž v Slovenskih Goricah', abbreviation: '182' },
      { name: 'Šempeter-Vrtojba', abbreviation: '183' },
      { name: 'Tabor', abbreviation: '184' },
      { name: 'Trnovska Vas', abbreviation: '185' },
      { name: 'Trzin', abbreviation: '186' },
      { name: 'Velika Polana', abbreviation: '187' },
      { name: 'Veržej', abbreviation: '188' },
      { name: 'Vransko', abbreviation: '189' },
      { name: 'Žalec', abbreviation: '190' },
      { name: 'Žetale', abbreviation: '191' },
      { name: 'Žirovnica', abbreviation: '192' },
      { name: 'Žužemberk', abbreviation: '193' },
      { name: 'Šmartno pri Litiji', abbreviation: '194' },
      { name: 'Apače', abbreviation: '195' },
      { name: 'Cirkulane', abbreviation: '196' },
      { name: 'Kosanjevica na Krki', abbreviation: '197' },
      { name: 'Makole', abbreviation: '198' },
      { name: 'Mokronog-Trebelno', abbreviation: '199' },
      { name: 'Poljčane', abbreviation: '200' },
      { name: 'Renče-Vogrsko', abbreviation: '201' },
      { name: 'Središče ob Dravi', abbreviation: '202' },
      { name: 'Straža', abbreviation: '203' },
      { name: 'Sveta Trojica v Slovenskih Goricah', abbreviation: '204' },
      { name: 'Sveti Tomaž', abbreviation: '205' },
      { name: 'Šmarješke Toplice', abbreviation: '206' },
      { name: 'Gorje', abbreviation: '207' },
      { name: 'Log-Dragomer', abbreviation: '208' },
      { name: 'Rečica ob Savinji', abbreviation: '209' },
      { name: 'Sveti Jurij v Slovenskih Goricah', abbreviation: '210' },
      { name: 'Šentrupert', abbreviation: '211' },
      { name: 'Mirna', abbreviation: '212' },
      { name: 'Ankaran', abbreviation: '213' },
    ],
  },
  SWE: {
    regions: [
      { name: 'Stockholms län [SE-01]', abbreviation: 'AB' },
      { name: 'Västerbottens län [SE-24]', abbreviation: 'AC' },
      { name: 'Norrbottens län [SE-25]', abbreviation: 'BD' },
      { name: 'Uppsala län [SE-03]', abbreviation: 'C' },
      { name: 'Södermanlands län [SE-04]', abbreviation: 'D' },
      { name: 'Östergötlands län [SE-05]', abbreviation: 'E' },
      { name: 'Jönköpings län [SE-06]', abbreviation: 'F' },
      { name: 'Kronobergs län [SE-07]', abbreviation: 'G' },
      { name: 'Kalmar län [SE-08]', abbreviation: 'H' },
      { name: 'Gotlands län [SE-09]', abbreviation: 'I' },
      { name: 'Blekinge län [SE-10]', abbreviation: 'K' },
      { name: 'Skåne län [SE-12]', abbreviation: 'M' },
      { name: 'Hallands län [SE-13]', abbreviation: 'N' },
      { name: 'Västra Götalands län [SE-14]', abbreviation: 'O' },
      { name: 'Värmlands län [SE-17]', abbreviation: 'S' },
      { name: 'Örebro län [SE-18]', abbreviation: 'T' },
      { name: 'Västmanlands län [SE-19]', abbreviation: 'U' },
      { name: 'Dalarnas län [SE-20]', abbreviation: 'W' },
      { name: 'Gävleborgs län [SE-21]', abbreviation: 'X' },
      { name: 'Västernorrlands län [SE-22]', abbreviation: 'Y' },
      { name: 'Jämtlands län [SE-23]', abbreviation: 'Z' },
    ],
  },
  SWZ: {
    regions: [
      { name: 'Hhohho', abbreviation: 'HH' },
      { name: 'Lubombo', abbreviation: 'LU' },
      { name: 'Manzini', abbreviation: 'MA' },
      { name: 'Shiselweni', abbreviation: 'SH' },
    ],
  },
  SYC: {
    regions: [
      { name: 'Ans o Pen', abbreviation: '01' },
      { name: 'Anse Boileau', abbreviation: '02' },
      { name: 'Anse Etoile', abbreviation: '03' },
      { name: 'Au Cap', abbreviation: '04' },
      { name: 'Anse Royale', abbreviation: '05' },
      { name: 'Baie Lazare', abbreviation: '06' },
      { name: 'Baie Sainte Anne', abbreviation: '07' },
      { name: 'Beau Vallon', abbreviation: '08' },
      { name: 'Bel Air', abbreviation: '09' },
      { name: 'Bel Ombre', abbreviation: '10' },
      { name: 'Cascade', abbreviation: '11' },
      { name: 'Glacis', abbreviation: '12' },
      { name: 'Grand Anse Mahe', abbreviation: '13' },
      { name: 'Grand Anse Praslin', abbreviation: '14' },
      { name: 'La Digue', abbreviation: '15' },
      { name: 'English River', abbreviation: '16' },
      { name: 'Mont Buxton', abbreviation: '17' },
      { name: 'Mont Fleuri', abbreviation: '18' },
      { name: 'Plaisance', abbreviation: '19' },
      { name: 'Pointe Larue', abbreviation: '20' },
      { name: 'Port Glaud', abbreviation: '21' },
      { name: 'Saint Louis', abbreviation: '22' },
      { name: 'Takamaka', abbreviation: '23' },
      { name: 'Les Mamelles', abbreviation: '24' },
      { name: 'Roche Caiman', abbreviation: '25' },
    ],
  },
  SYR: {
    regions: [
      { name: 'Dimashq', abbreviation: 'DI' },
      { name: "Dar'ā", abbreviation: 'DR' },
      { name: 'Dayr az Zawr', abbreviation: 'DY' },
      { name: 'Al Ḩasakah', abbreviation: 'HA' },
      { name: 'Ḩimş', abbreviation: 'HI' },
      { name: 'Ḩalab', abbreviation: 'HL' },
      { name: 'Ḩamāh', abbreviation: 'HM' },
      { name: 'Idlib', abbreviation: 'ID' },
      { name: 'Al Lādhiqīyah', abbreviation: 'LA' },
      { name: 'Al Qunayţirah', abbreviation: 'QU' },
      { name: 'Ar Raqqah', abbreviation: 'RA' },
      { name: 'Rīf Dimashq', abbreviation: 'RD' },
      { name: "As Suwaydā'", abbreviation: 'SU' },
      { name: 'Ţarţūs', abbreviation: 'TA' },
    ],
  },
  TCD: {
    regions: [
      { name: 'Al Baţḩah', abbreviation: 'BA' },
      { name: 'Baḩr al Ghazāl', abbreviation: 'BG' },
      { name: 'Būrkū', abbreviation: 'BO' },
      { name: 'Shārī Bāqirmī', abbreviation: 'CB' },
      { name: 'Ennedi-Est', abbreviation: 'EE' },
      { name: 'Ennedi-Ouest', abbreviation: 'EO' },
      { name: 'Qīrā', abbreviation: 'GR' },
      { name: 'Ḩajjar Lamīs', abbreviation: 'HL' },
      { name: 'Kānim', abbreviation: 'KA' },
      { name: 'Al Buḩayrah', abbreviation: 'LC' },
      { name: 'Lūqūn al Gharbī', abbreviation: 'LO' },
      { name: 'Lūqūn ash Sharqī', abbreviation: 'LR' },
      { name: 'Māndūl', abbreviation: 'MA' },
      { name: 'Shārī al Awsaţ', abbreviation: 'MC' },
      { name: 'Māyū Kībbī ash Sharqī', abbreviation: 'ME' },
      { name: 'Māyū Kībbī al Gharbī', abbreviation: 'MO' },
      { name: 'Madīnat Injamīnā', abbreviation: 'ND' },
      { name: 'Waddāy', abbreviation: 'OD' },
      { name: 'Salāmāt', abbreviation: 'SA' },
      { name: 'Sīlā', abbreviation: 'SI' },
      { name: 'Tānjilī', abbreviation: 'TA' },
      { name: 'Tibastī', abbreviation: 'TI' },
      { name: 'Wādī Fīrā', abbreviation: 'WF' },
    ],
  },
  TGO: {
    regions: [
      { name: 'Centrale', abbreviation: 'C' },
      { name: 'Kara', abbreviation: 'K' },
      { name: 'Maritime (Région)', abbreviation: 'M' },
      { name: 'Plateaux', abbreviation: 'P' },
      { name: 'Savanes', abbreviation: 'S' },
    ],
  },
  THA: {
    regions: [
      { name: 'Krung Thep Maha Nakhon', abbreviation: '10' },
      { name: 'Samut Prakan', abbreviation: '11' },
      { name: 'Nonthaburi', abbreviation: '12' },
      { name: 'Pathum Thani', abbreviation: '13' },
      { name: 'Phra Nakhon Si Ayutthaya', abbreviation: '14' },
      { name: 'Ang Thong', abbreviation: '15' },
      { name: 'Lop Buri', abbreviation: '16' },
      { name: 'Sing Buri', abbreviation: '17' },
      { name: 'Chai Nat', abbreviation: '18' },
      { name: 'Saraburi', abbreviation: '19' },
      { name: 'Chon Buri', abbreviation: '20' },
      { name: 'Rayong', abbreviation: '21' },
      { name: 'Chanthaburi', abbreviation: '22' },
      { name: 'Trat', abbreviation: '23' },
      { name: 'Chachoengsao', abbreviation: '24' },
      { name: 'Prachin Buri', abbreviation: '25' },
      { name: 'Nakhon Nayok', abbreviation: '26' },
      { name: 'Sa Kaeo', abbreviation: '27' },
      { name: 'Nakhon Ratchasima', abbreviation: '30' },
      { name: 'Buri Ram', abbreviation: '31' },
      { name: 'Surin', abbreviation: '32' },
      { name: 'Si Sa Ket', abbreviation: '33' },
      { name: 'Ubon Ratchathani', abbreviation: '34' },
      { name: 'Yasothon', abbreviation: '35' },
      { name: 'Chaiyaphum', abbreviation: '36' },
      { name: 'Amnat Charoen', abbreviation: '37' },
      { name: 'Bueng Kan', abbreviation: '38' },
      { name: 'Nong Bua Lam Phu', abbreviation: '39' },
      { name: 'Khon Kaen', abbreviation: '40' },
      { name: 'Udon Thani', abbreviation: '41' },
      { name: 'Loei', abbreviation: '42' },
      { name: 'Nong Khai', abbreviation: '43' },
      { name: 'Maha Sarakham', abbreviation: '44' },
      { name: 'Roi Et', abbreviation: '45' },
      { name: 'Kalasin', abbreviation: '46' },
      { name: 'Sakon Nakhon', abbreviation: '47' },
      { name: 'Nakhon Phanom', abbreviation: '48' },
      { name: 'Mukdahan', abbreviation: '49' },
      { name: 'Chiang Mai', abbreviation: '50' },
      { name: 'Lamphun', abbreviation: '51' },
      { name: 'Lampang', abbreviation: '52' },
      { name: 'Uttaradit', abbreviation: '53' },
      { name: 'Phrae', abbreviation: '54' },
      { name: 'Nan', abbreviation: '55' },
      { name: 'Phayao', abbreviation: '56' },
      { name: 'Chiang Rai', abbreviation: '57' },
      { name: 'Mae Hong Son', abbreviation: '58' },
      { name: 'Nakhon Sawan', abbreviation: '60' },
      { name: 'Uthai Thani', abbreviation: '61' },
      { name: 'Kamphaeng Phet', abbreviation: '62' },
      { name: 'Tak', abbreviation: '63' },
      { name: 'Sukhothai', abbreviation: '64' },
      { name: 'Phitsanulok', abbreviation: '65' },
      { name: 'Phichit', abbreviation: '66' },
      { name: 'Phetchabun', abbreviation: '67' },
      { name: 'Ratchaburi', abbreviation: '70' },
      { name: 'Kanchanaburi', abbreviation: '71' },
      { name: 'Suphan Buri', abbreviation: '72' },
      { name: 'Nakhon Pathom', abbreviation: '73' },
      { name: 'Samut Sakhon', abbreviation: '74' },
      { name: 'Samut Songkhram', abbreviation: '75' },
      { name: 'Phetchaburi', abbreviation: '76' },
      { name: 'Prachuap Khiri Khan', abbreviation: '77' },
      { name: 'Nakhon Si Thammarat', abbreviation: '80' },
      { name: 'Krabi', abbreviation: '81' },
      { name: 'Phangnga', abbreviation: '82' },
      { name: 'Phuket', abbreviation: '83' },
      { name: 'Surat Thani', abbreviation: '84' },
      { name: 'Ranong', abbreviation: '85' },
      { name: 'Chumphon', abbreviation: '86' },
      { name: 'Songkhla', abbreviation: '90' },
      { name: 'Satun', abbreviation: '91' },
      { name: 'Trang', abbreviation: '92' },
      { name: 'Phatthalung', abbreviation: '93' },
      { name: 'Pattani', abbreviation: '94' },
      { name: 'Yala', abbreviation: '95' },
      { name: 'Narathiwat', abbreviation: '96' },
      { name: 'Phatthaya', abbreviation: 'S' },
    ],
  },
  TJK: {
    regions: [
      { name: 'Khatlon', abbreviation: 'KT' },
      { name: 'Sughd', abbreviation: 'SU' },
      { name: 'Kŭhistoni Badakhshon', abbreviation: 'GB' },
      { name: 'Dushanbe', abbreviation: 'DU' },
      { name: 'nohiyahoi tobei jumhurí', abbreviation: 'RA' },
    ],
  },
  TKM: {
    regions: [
      { name: 'Aşgabat', abbreviation: 'S' },
      { name: 'Ahal', abbreviation: 'A' },
      { name: 'Balkan', abbreviation: 'B' },
      { name: 'Daşoguz', abbreviation: 'D' },
      { name: 'Lebap', abbreviation: 'L' },
      { name: 'Mary', abbreviation: 'M' },
    ],
  },
  TLS: {
    regions: [
      { name: 'Aileu', abbreviation: 'AL' },
      { name: 'Ainaro', abbreviation: 'AN' },
      { name: 'Baucau', abbreviation: 'BA' },
      { name: 'Bobonaro', abbreviation: 'BO' },
      { name: 'Cova Lima', abbreviation: 'CO' },
      { name: 'Díli', abbreviation: 'DI' },
      { name: 'Ermera', abbreviation: 'ER' },
      { name: 'Lautém', abbreviation: 'LA' },
      { name: 'Liquiça', abbreviation: 'LI' },
      { name: 'Manufahi', abbreviation: 'MF' },
      { name: 'Manatuto', abbreviation: 'MT' },
      { name: 'Viqueque', abbreviation: 'VI' },
      { name: 'Oé-Cusse Ambeno', abbreviation: 'OE' },
    ],
  },
  TON: {
    regions: [
      { name: "'Eua", abbreviation: '01' },
      { name: "Ha'apai", abbreviation: '02' },
      { name: 'Niuas', abbreviation: '03' },
      { name: 'Tongatapu', abbreviation: '04' },
      { name: "Vava'u", abbreviation: '05' },
    ],
  },
  TTO: {
    regions: [
      { name: 'Arima', abbreviation: 'ARI' },
      { name: 'Chaguanas', abbreviation: 'CHA' },
      { name: 'Port of Spain', abbreviation: 'POS' },
      { name: 'Point Fortin', abbreviation: 'PTF' },
      { name: 'San Fernando', abbreviation: 'SFO' },
      { name: 'Couva-Tabaquite-Talparo', abbreviation: 'CTT' },
      { name: 'Diego Martin', abbreviation: 'DMN' },
      { name: 'Mayaro-Rio Claro', abbreviation: 'MRC' },
      { name: 'Penal-Debe', abbreviation: 'PED' },
      { name: 'Princes Town', abbreviation: 'PRT' },
      { name: 'Sangre Grande', abbreviation: 'SGE' },
      { name: 'Siparia', abbreviation: 'SIP' },
      { name: 'San Juan-Laventille', abbreviation: 'SJL' },
      { name: 'Tunapuna-Piarco', abbreviation: 'TUP' },
      { name: 'Tobago', abbreviation: 'TOB' },
    ],
  },
  TUN: {
    regions: [
      { name: 'Tunis', abbreviation: '11' },
      { name: "L'Ariana", abbreviation: '12' },
      { name: 'Ben Arous', abbreviation: '13' },
      { name: 'La Manouba', abbreviation: '14' },
      { name: 'Nabeul', abbreviation: '21' },
      { name: 'Zaghouan', abbreviation: '22' },
      { name: 'Bizerte', abbreviation: '23' },
      { name: 'Béja', abbreviation: '31' },
      { name: 'Jendouba', abbreviation: '32' },
      { name: 'Le Kef', abbreviation: '33' },
      { name: 'Siliana', abbreviation: '34' },
      { name: 'Kairouan', abbreviation: '41' },
      { name: 'Kasserine', abbreviation: '42' },
      { name: 'Sidi Bouzid', abbreviation: '43' },
      { name: 'Sousse', abbreviation: '51' },
      { name: 'Monastir', abbreviation: '52' },
      { name: 'Mahdia', abbreviation: '53' },
      { name: 'Sfax', abbreviation: '61' },
      { name: 'Gafsa', abbreviation: '71' },
      { name: 'Tozeur', abbreviation: '72' },
      { name: 'Kébili', abbreviation: '73' },
      { name: 'Gabès', abbreviation: '81' },
      { name: 'Médenine', abbreviation: '82' },
      { name: 'Tataouine', abbreviation: '83' },
    ],
  },
  TUR: {
    regions: [
      { name: 'Adana', abbreviation: '01' },
      { name: 'Adıyaman', abbreviation: '02' },
      { name: 'Afyonkarahisar', abbreviation: '03' },
      { name: 'Ağrı', abbreviation: '04' },
      { name: 'Amasya', abbreviation: '05' },
      { name: 'Ankara', abbreviation: '06' },
      { name: 'Antalya', abbreviation: '07' },
      { name: 'Artvin', abbreviation: '08' },
      { name: 'Aydın', abbreviation: '09' },
      { name: 'Balıkesir', abbreviation: '10' },
      { name: 'Bilecik', abbreviation: '11' },
      { name: 'Bingöl', abbreviation: '12' },
      { name: 'Bitlis', abbreviation: '13' },
      { name: 'Bolu', abbreviation: '14' },
      { name: 'Burdur', abbreviation: '15' },
      { name: 'Bursa', abbreviation: '16' },
      { name: 'Çanakkale', abbreviation: '17' },
      { name: 'Çankırı', abbreviation: '18' },
      { name: 'Çorum', abbreviation: '19' },
      { name: 'Denizli', abbreviation: '20' },
      { name: 'Diyarbakır', abbreviation: '21' },
      { name: 'Edirne', abbreviation: '22' },
      { name: 'Elazığ', abbreviation: '23' },
      { name: 'Erzincan', abbreviation: '24' },
      { name: 'Erzurum', abbreviation: '25' },
      { name: 'Eskişehir', abbreviation: '26' },
      { name: 'Gaziantep', abbreviation: '27' },
      { name: 'Giresun', abbreviation: '28' },
      { name: 'Gümüşhane', abbreviation: '29' },
      { name: 'Hakkâri', abbreviation: '30' },
      { name: 'Hatay', abbreviation: '31' },
      { name: 'Isparta', abbreviation: '32' },
      { name: 'Mersin', abbreviation: '33' },
      { name: 'İstanbul', abbreviation: '34' },
      { name: 'İzmir', abbreviation: '35' },
      { name: 'Kars', abbreviation: '36' },
      { name: 'Kastamonu', abbreviation: '37' },
      { name: 'Kayseri', abbreviation: '38' },
      { name: 'Kırklareli', abbreviation: '39' },
      { name: 'Kırşehir', abbreviation: '40' },
      { name: 'Kocaeli', abbreviation: '41' },
      { name: 'Konya', abbreviation: '42' },
      { name: 'Kütahya', abbreviation: '43' },
      { name: 'Malatya', abbreviation: '44' },
      { name: 'Manisa', abbreviation: '45' },
      { name: 'Kahramanmaraş', abbreviation: '46' },
      { name: 'Mardin', abbreviation: '47' },
      { name: 'Muğla', abbreviation: '48' },
      { name: 'Muş', abbreviation: '49' },
      { name: 'Nevşehir', abbreviation: '50' },
      { name: 'Niğde', abbreviation: '51' },
      { name: 'Ordu', abbreviation: '52' },
      { name: 'Rize', abbreviation: '53' },
      { name: 'Sakarya', abbreviation: '54' },
      { name: 'Samsun', abbreviation: '55' },
      { name: 'Siirt', abbreviation: '56' },
      { name: 'Sinop', abbreviation: '57' },
      { name: 'Sivas', abbreviation: '58' },
      { name: 'Tekirdağ', abbreviation: '59' },
      { name: 'Tokat', abbreviation: '60' },
      { name: 'Trabzon', abbreviation: '61' },
      { name: 'Tunceli', abbreviation: '62' },
      { name: 'Şanlıurfa', abbreviation: '63' },
      { name: 'Uşak', abbreviation: '64' },
      { name: 'Van', abbreviation: '65' },
      { name: 'Yozgat', abbreviation: '66' },
      { name: 'Zonguldak', abbreviation: '67' },
      { name: 'Aksaray', abbreviation: '68' },
      { name: 'Bayburt', abbreviation: '69' },
      { name: 'Karaman', abbreviation: '70' },
      { name: 'Kırıkkale', abbreviation: '71' },
      { name: 'Batman', abbreviation: '72' },
      { name: 'Şırnak', abbreviation: '73' },
      { name: 'Bartın', abbreviation: '74' },
      { name: 'Ardahan', abbreviation: '75' },
      { name: 'Iğdır', abbreviation: '76' },
      { name: 'Yalova', abbreviation: '77' },
      { name: 'Karabük', abbreviation: '78' },
      { name: 'Kilis', abbreviation: '79' },
      { name: 'Osmaniye', abbreviation: '80' },
      { name: 'Düzce', abbreviation: '81' },
    ],
  },
  TUV: {
    regions: [
      { name: 'Niutao', abbreviation: 'NIT' },
      { name: 'Nukufetau', abbreviation: 'NKF' },
      { name: 'Nukulaelae', abbreviation: 'NKL' },
      { name: 'Nanumea', abbreviation: 'NMA' },
      { name: 'Nanumaga', abbreviation: 'NMG' },
      { name: 'Nui', abbreviation: 'NUI' },
      { name: 'Vaitupu', abbreviation: 'VAI' },
      { name: 'Funafuti', abbreviation: 'FUN' },
    ],
  },
  TWN: {
    regions: [
      { name: 'Chiayi', abbreviation: 'CYI' },
      { name: 'Hsinchu', abbreviation: 'HSZ' },
      { name: 'Keelung', abbreviation: 'KEE' },
      { name: 'Kaohsiung', abbreviation: 'KHH' },
      { name: 'New Taipei', abbreviation: 'NWT' },
      { name: 'Taoyuan', abbreviation: 'TAO' },
      { name: 'Tainan', abbreviation: 'TNN' },
      { name: 'Taipei', abbreviation: 'TPE' },
      { name: 'Taichung', abbreviation: 'TXG' },
      { name: 'Changhua', abbreviation: 'CHA' },
      { name: 'Chiayi', abbreviation: 'CYQ' },
      { name: 'Hsinchu', abbreviation: 'HSQ' },
      { name: 'Hualien', abbreviation: 'HUA' },
      { name: 'Yilan', abbreviation: 'ILA' },
      { name: 'Kinmen', abbreviation: 'KIN' },
      { name: 'Lienchiang', abbreviation: 'LIE' },
      { name: 'Miaoli', abbreviation: 'MIA' },
      { name: 'Nantou', abbreviation: 'NAN' },
      { name: 'Penghu', abbreviation: 'PEN' },
      { name: 'Pingtung', abbreviation: 'PIF' },
      { name: 'Taitung', abbreviation: 'TTT' },
      { name: 'Yunlin', abbreviation: 'YUN' },
    ],
  },
  TZA: {
    regions: [
      { name: 'Arusha', abbreviation: '01' },
      { name: 'Dar es Salaam', abbreviation: '02' },
      { name: 'Dodoma', abbreviation: '03' },
      { name: 'Iringa', abbreviation: '04' },
      { name: 'Kagera', abbreviation: '05' },
      { name: 'Pemba North', abbreviation: '06' },
      { name: 'Zanzibar North', abbreviation: '07' },
      { name: 'Kigoma', abbreviation: '08' },
      { name: 'Kilimanjaro', abbreviation: '09' },
      { name: 'Pemba South', abbreviation: '10' },
      { name: 'Zanzibar South', abbreviation: '11' },
      { name: 'Lindi', abbreviation: '12' },
      { name: 'Mara', abbreviation: '13' },
      { name: 'Mbeya', abbreviation: '14' },
      { name: 'Zanzibar West', abbreviation: '15' },
      { name: 'Morogoro', abbreviation: '16' },
      { name: 'Mtwara', abbreviation: '17' },
      { name: 'Mwanza', abbreviation: '18' },
      { name: 'Coast', abbreviation: '19' },
      { name: 'Rukwa', abbreviation: '20' },
      { name: 'Ruvuma', abbreviation: '21' },
      { name: 'Shinyanga', abbreviation: '22' },
      { name: 'Singida', abbreviation: '23' },
      { name: 'Tabora', abbreviation: '24' },
      { name: 'Tanga', abbreviation: '25' },
      { name: 'Manyara', abbreviation: '26' },
      { name: 'Geita', abbreviation: '27' },
      { name: 'Katavi', abbreviation: '28' },
      { name: 'Njombe', abbreviation: '29' },
      { name: 'Simiyu', abbreviation: '30' },
      { name: 'Songwe', abbreviation: '31' },
    ],
  },
  UGA: {
    regions: [
      { name: 'Central', abbreviation: 'C' },
      { name: 'Kalangala', abbreviation: '101' },
      { name: 'Kiboga', abbreviation: '103' },
      { name: 'Luwero', abbreviation: '104' },
      { name: 'Masaka', abbreviation: '105' },
      { name: 'Mpigi', abbreviation: '106' },
      { name: 'Mubende', abbreviation: '107' },
      { name: 'Mukono', abbreviation: '108' },
      { name: 'Nakasongola', abbreviation: '109' },
      { name: 'Rakai', abbreviation: '110' },
      { name: 'Sembabule', abbreviation: '111' },
      { name: 'Kayunga', abbreviation: '112' },
      { name: 'Wakiso', abbreviation: '113' },
      { name: 'Lyantonde', abbreviation: '114' },
      { name: 'Mityana', abbreviation: '115' },
      { name: 'Nakaseke', abbreviation: '116' },
      { name: 'Buikwe', abbreviation: '117' },
      { name: 'Bukomansibi', abbreviation: '118' },
      { name: 'Butambala', abbreviation: '119' },
      { name: 'Buvuma', abbreviation: '120' },
      { name: 'Gomba', abbreviation: '121' },
      { name: 'Kalungu', abbreviation: '122' },
      { name: 'Kyankwanzi', abbreviation: '123' },
      { name: 'Lwengo', abbreviation: '124' },
      { name: 'Kyotera', abbreviation: '125' },
      { name: 'Kasanda', abbreviation: '126' },
      { name: 'Kampala', abbreviation: '102' },
      { name: 'Eastern', abbreviation: 'E' },
      { name: 'Bugiri', abbreviation: '201' },
      { name: 'Busia', abbreviation: '202' },
      { name: 'Iganga', abbreviation: '203' },
      { name: 'Jinja', abbreviation: '204' },
      { name: 'Kamuli', abbreviation: '205' },
      { name: 'Kapchorwa', abbreviation: '206' },
      { name: 'Katakwi', abbreviation: '207' },
      { name: 'Kumi', abbreviation: '208' },
      { name: 'Mbale', abbreviation: '209' },
      { name: 'Pallisa', abbreviation: '210' },
      { name: 'Soroti', abbreviation: '211' },
      { name: 'Tororo', abbreviation: '212' },
      { name: 'Kaberamaido', abbreviation: '213' },
      { name: 'Mayuge', abbreviation: '214' },
      { name: 'Sironko', abbreviation: '215' },
      { name: 'Amuria', abbreviation: '216' },
      { name: 'Budaka', abbreviation: '217' },
      { name: 'Bududa', abbreviation: '218' },
      { name: 'Bukedea', abbreviation: '219' },
      { name: 'Bukwa', abbreviation: '220' },
      { name: 'Butaleja', abbreviation: '221' },
      { name: 'Kaliro', abbreviation: '222' },
      { name: 'Manafwa', abbreviation: '223' },
      { name: 'Namutumba', abbreviation: '224' },
      { name: 'Bulambuli', abbreviation: '225' },
      { name: 'Buyende', abbreviation: '226' },
      { name: 'Kibuku', abbreviation: '227' },
      { name: 'Kween', abbreviation: '228' },
      { name: 'Luuka', abbreviation: '229' },
      { name: 'Namayingo', abbreviation: '230' },
      { name: 'Ngora', abbreviation: '231' },
      { name: 'Serere', abbreviation: '232' },
      { name: 'Butebo', abbreviation: '233' },
      { name: 'Namisindwa', abbreviation: '234' },
      { name: 'Bugweri', abbreviation: '235' },
      { name: 'Kapelebyong', abbreviation: '236' },
      { name: 'Northern', abbreviation: 'N' },
      { name: 'Adjumani', abbreviation: '301' },
      { name: 'Apac', abbreviation: '302' },
      { name: 'Arua', abbreviation: '303' },
      { name: 'Gulu', abbreviation: '304' },
      { name: 'Kitgum', abbreviation: '305' },
      { name: 'Kotido', abbreviation: '306' },
      { name: 'Lira', abbreviation: '307' },
      { name: 'Moroto', abbreviation: '308' },
      { name: 'Moyo', abbreviation: '309' },
      { name: 'Nebbi', abbreviation: '310' },
      { name: 'Nakapiripirit', abbreviation: '311' },
      { name: 'Pader', abbreviation: '312' },
      { name: 'Yumbe', abbreviation: '313' },
      { name: 'Abim', abbreviation: '314' },
      { name: 'Amolatar', abbreviation: '315' },
      { name: 'Amuru', abbreviation: '316' },
      { name: 'Dokolo', abbreviation: '317' },
      { name: 'Kaabong', abbreviation: '318' },
      { name: 'Koboko', abbreviation: '319' },
      { name: 'Maracha', abbreviation: '320' },
      { name: 'Oyam', abbreviation: '321' },
      { name: 'Agago', abbreviation: '322' },
      { name: 'Alebtong', abbreviation: '323' },
      { name: 'Amudat', abbreviation: '324' },
      { name: 'Kole', abbreviation: '325' },
      { name: 'Lamwo', abbreviation: '326' },
      { name: 'Napak', abbreviation: '327' },
      { name: 'Nwoya', abbreviation: '328' },
      { name: 'Otuke', abbreviation: '329' },
      { name: 'Zombo', abbreviation: '330' },
      { name: 'Omoro', abbreviation: '331' },
      { name: 'Pakwach', abbreviation: '332' },
      { name: 'Kwania', abbreviation: '333' },
      { name: 'Nabilatuk', abbreviation: '334' },
      { name: 'Western', abbreviation: 'W' },
      { name: 'Bundibugyo', abbreviation: '401' },
      { name: 'Bushenyi', abbreviation: '402' },
      { name: 'Hoima', abbreviation: '403' },
      { name: 'Kabale', abbreviation: '404' },
      { name: 'Kabarole', abbreviation: '405' },
      { name: 'Kasese', abbreviation: '406' },
      { name: 'Kibaale', abbreviation: '407' },
      { name: 'Kisoro', abbreviation: '408' },
      { name: 'Masindi', abbreviation: '409' },
      { name: 'Mbarara', abbreviation: '410' },
      { name: 'Ntungamo', abbreviation: '411' },
      { name: 'Rukungiri', abbreviation: '412' },
      { name: 'Kamwenge', abbreviation: '413' },
      { name: 'Kanungu', abbreviation: '414' },
      { name: 'Kyenjojo', abbreviation: '415' },
      { name: 'Buliisa', abbreviation: '416' },
      { name: 'Ibanda', abbreviation: '417' },
      { name: 'Isingiro', abbreviation: '418' },
      { name: 'Kiruhura', abbreviation: '419' },
      { name: 'Buhweju', abbreviation: '420' },
      { name: 'Kiryandongo', abbreviation: '421' },
      { name: 'Kyegegwa', abbreviation: '422' },
      { name: 'Mitooma', abbreviation: '423' },
      { name: 'Ntoroko', abbreviation: '424' },
      { name: 'Rubirizi', abbreviation: '425' },
      { name: 'Sheema', abbreviation: '426' },
      { name: 'Kagadi', abbreviation: '427' },
      { name: 'Kakumiro', abbreviation: '428' },
      { name: 'Rubanda', abbreviation: '429' },
      { name: 'Bunyangabu', abbreviation: '430' },
      { name: 'Rukiga', abbreviation: '431' },
      { name: 'Kikuube', abbreviation: '432' },
    ],
  },
  UKR: {
    regions: [
      { name: 'Kyiv', abbreviation: '30' },
      { name: 'Sevastopol', abbreviation: '40' },
      { name: 'Vinnytska oblast', abbreviation: '05' },
      { name: 'Volynska oblast', abbreviation: '07' },
      { name: 'Luhanska oblast', abbreviation: '09' },
      { name: 'Dnipropetrovska oblast', abbreviation: '12' },
      { name: 'Donetska oblast', abbreviation: '14' },
      { name: 'Zhytomyrska oblast', abbreviation: '18' },
      { name: 'Zakarpatska oblast', abbreviation: '21' },
      { name: 'Zaporizka oblast', abbreviation: '23' },
      { name: 'Ivano-Frankivska oblast', abbreviation: '26' },
      { name: 'Kyivska oblast', abbreviation: '32' },
      { name: 'Kirovohradska oblast', abbreviation: '35' },
      { name: 'Lvivska oblast', abbreviation: '46' },
      { name: 'Mykolaivska oblast', abbreviation: '48' },
      { name: 'Odeska oblast', abbreviation: '51' },
      { name: 'Poltavska oblast', abbreviation: '53' },
      { name: 'Rivnenska oblast', abbreviation: '56' },
      { name: 'Sumska oblast', abbreviation: '59' },
      { name: 'Ternopilska oblast', abbreviation: '61' },
      { name: 'Kharkivska oblast', abbreviation: '63' },
      { name: 'Khersonska oblast', abbreviation: '65' },
      { name: 'Khmelnytska oblast', abbreviation: '68' },
      { name: 'Cherkaska oblast', abbreviation: '71' },
      { name: 'Chernihivska oblast', abbreviation: '74' },
      { name: 'Chernivetska oblast', abbreviation: '77' },
      { name: 'Avtonomna Respublika Krym', abbreviation: '43' },
    ],
  },
  UMI: {
    regions: [
      { name: 'Johnston Atoll', abbreviation: '67' },
      { name: 'Midway Islands', abbreviation: '71' },
      { name: 'Navassa Island', abbreviation: '76' },
      { name: 'Wake Island', abbreviation: '79' },
      { name: 'Baker Island', abbreviation: '81' },
      { name: 'Howland Island', abbreviation: '84' },
      { name: 'Jarvis Island', abbreviation: '86' },
      { name: 'Kingman Reef', abbreviation: '89' },
      { name: 'Palmyra Atoll', abbreviation: '95' },
    ],
  },
  URY: {
    regions: [
      { name: 'Artigas', abbreviation: 'AR' },
      { name: 'Canelones', abbreviation: 'CA' },
      { name: 'Cerro Largo', abbreviation: 'CL' },
      { name: 'Colonia', abbreviation: 'CO' },
      { name: 'Durazno', abbreviation: 'DU' },
      { name: 'Florida', abbreviation: 'FD' },
      { name: 'Flores', abbreviation: 'FS' },
      { name: 'Lavalleja', abbreviation: 'LA' },
      { name: 'Maldonado', abbreviation: 'MA' },
      { name: 'Montevideo', abbreviation: 'MO' },
      { name: 'Paysandú', abbreviation: 'PA' },
      { name: 'Río Negro', abbreviation: 'RN' },
      { name: 'Rocha', abbreviation: 'RO' },
      { name: 'Rivera', abbreviation: 'RV' },
      { name: 'Salto', abbreviation: 'SA' },
      { name: 'San José', abbreviation: 'SJ' },
      { name: 'Soriano', abbreviation: 'SO' },
      { name: 'Tacuarembó', abbreviation: 'TA' },
      { name: 'Treinta y Tres', abbreviation: 'TT' },
    ],
  },
  USA: {
    postalCodeLabel: 'ZIP Code',
    regionLabel: 'State',
    regions: [
      { name: 'Alabama', abbreviation: 'AL', type: 'state' },
      { name: 'Alaska', abbreviation: 'AK', type: 'state' },
      { name: 'American Samoa', abbreviation: 'AS', type: 'territory' },
      { name: 'Arizona', abbreviation: 'AZ', type: 'state' },
      { name: 'Arkansas', abbreviation: 'AR', type: 'state' },
      { name: 'California', abbreviation: 'CA', type: 'state' },
      { name: 'Colorado', abbreviation: 'CO', type: 'state' },
      { name: 'Connecticut', abbreviation: 'CT', type: 'state' },
      { name: 'Delaware', abbreviation: 'DE', type: 'state' },
      { name: 'District Of Columbia', abbreviation: 'DC', type: 'territory' },
      {
        name: 'Federated States Of Micronesia',
        abbreviation: 'FM',
        type: 'territory',
      },
      { name: 'Florida', abbreviation: 'FL', type: 'state' },
      { name: 'Georgia', abbreviation: 'GA', type: 'state' },
      { name: 'Guam', abbreviation: 'GU', type: 'territory' },
      { name: 'Hawaii', abbreviation: 'HI', type: 'state' },
      { name: 'Idaho', abbreviation: 'ID', type: 'state' },
      { name: 'Illinois', abbreviation: 'IL', type: 'state' },
      { name: 'Indiana', abbreviation: 'IN', type: 'state' },
      { name: 'Iowa', abbreviation: 'IA', type: 'state' },
      { name: 'Kansas', abbreviation: 'KS', type: 'state' },
      { name: 'Kentucky', abbreviation: 'KY', type: 'state' },
      { name: 'Louisiana', abbreviation: 'LA', type: 'state' },
      { name: 'Maine', abbreviation: 'ME', type: 'state' },
      { name: 'Marshall Islands', abbreviation: 'MH', type: 'territory' },
      { name: 'Maryland', abbreviation: 'MD', type: 'state' },
      { name: 'Massachusetts', abbreviation: 'MA', type: 'state' },
      { name: 'Michigan', abbreviation: 'MI', type: 'state' },
      { name: 'Minnesota', abbreviation: 'MN', type: 'state' },
      { name: 'Mississippi', abbreviation: 'MS', type: 'state' },
      { name: 'Missouri', abbreviation: 'MO', type: 'state' },
      { name: 'Montana', abbreviation: 'MT', type: 'state' },
      { name: 'Nebraska', abbreviation: 'NE', type: 'state' },
      { name: 'Nevada', abbreviation: 'NV', type: 'state' },
      { name: 'New Hampshire', abbreviation: 'NH', type: 'state' },
      { name: 'New Jersey', abbreviation: 'NJ', type: 'state' },
      { name: 'New Mexico', abbreviation: 'NM', type: 'state' },
      { name: 'New York', abbreviation: 'NY', type: 'state' },
      { name: 'North Carolina', abbreviation: 'NC', type: 'state' },
      { name: 'North Dakota', abbreviation: 'ND', type: 'state' },
      {
        name: 'Northern Mariana Islands',
        abbreviation: 'MP',
        type: 'territory',
      },
      { name: 'Ohio', abbreviation: 'OH', type: 'state' },
      { name: 'Oklahoma', abbreviation: 'OK', type: 'state' },
      { name: 'Oregon', abbreviation: 'OR', type: 'state' },
      { name: 'Palau', abbreviation: 'PW', type: 'territory' },
      { name: 'Pennsylvania', abbreviation: 'PA', type: 'state' },
      { name: 'Puerto Rico', abbreviation: 'PR', type: 'territory' },
      { name: 'Rhode Island', abbreviation: 'RI', type: 'state' },
      { name: 'South Carolina', abbreviation: 'SC', type: 'state' },
      { name: 'South Dakota', abbreviation: 'SD', type: 'state' },
      { name: 'Tennessee', abbreviation: 'TN', type: 'state' },
      { name: 'Texas', abbreviation: 'TX', type: 'state' },
      { name: 'Utah', abbreviation: 'UT', type: 'state' },
      { name: 'Vermont', abbreviation: 'VT', type: 'state' },
      { name: 'Virgin Islands', abbreviation: 'VI', type: 'territory' },
      { name: 'Virginia', abbreviation: 'VA', type: 'state' },
      { name: 'Washington', abbreviation: 'WA', type: 'state' },
      { name: 'West Virginia', abbreviation: 'WV', type: 'state' },
      { name: 'Wisconsin', abbreviation: 'WI', type: 'state' },
      { name: 'Wyoming', abbreviation: 'WY', type: 'state' },
    ],
  },
  UZB: {
    regions: [
      { name: 'Andijon', abbreviation: 'AN' },
      { name: 'Buxoro', abbreviation: 'BU' },
      { name: 'Farg‘ona', abbreviation: 'FA' },
      { name: 'Jizzax', abbreviation: 'JI' },
      { name: 'Namangan', abbreviation: 'NG' },
      { name: 'Navoiy', abbreviation: 'NW' },
      { name: 'Qashqadaryo', abbreviation: 'QA' },
      { name: 'Samarqand', abbreviation: 'SA' },
      { name: 'Sirdaryo', abbreviation: 'SI' },
      { name: 'Surxondaryo', abbreviation: 'SU' },
      { name: 'Toshkent', abbreviation: 'TO' },
      { name: 'Xorazm', abbreviation: 'XO' },
      { name: 'Qoraqalpog‘iston Respublikasi', abbreviation: 'QR' },
      { name: 'Toshkent', abbreviation: 'TK' },
    ],
  },
  VCT: {
    regions: [
      { name: 'Charlotte', abbreviation: '01' },
      { name: 'Saint Andrew', abbreviation: '02' },
      { name: 'Saint David', abbreviation: '03' },
      { name: 'Saint George', abbreviation: '04' },
      { name: 'Saint Patrick', abbreviation: '05' },
      { name: 'Grenadines', abbreviation: '06' },
    ],
  },
  VEN: {
    regions: [
      { name: 'Anzoátegui', abbreviation: 'B' },
      { name: 'Apure', abbreviation: 'C' },
      { name: 'Aragua', abbreviation: 'D' },
      { name: 'Barinas', abbreviation: 'E' },
      { name: 'Bolívar', abbreviation: 'F' },
      { name: 'Carabobo', abbreviation: 'G' },
      { name: 'Cojedes', abbreviation: 'H' },
      { name: 'Falcón', abbreviation: 'I' },
      { name: 'Guárico', abbreviation: 'J' },
      { name: 'Lara', abbreviation: 'K' },
      { name: 'Mérida', abbreviation: 'L' },
      { name: 'Miranda', abbreviation: 'M' },
      { name: 'Monagas', abbreviation: 'N' },
      { name: 'Nueva Esparta', abbreviation: 'O' },
      { name: 'Portuguesa', abbreviation: 'P' },
      { name: 'Sucre', abbreviation: 'R' },
      { name: 'Táchira', abbreviation: 'S' },
      { name: 'Trujillo', abbreviation: 'T' },
      { name: 'Yaracuy', abbreviation: 'U' },
      { name: 'Zulia', abbreviation: 'V' },
      { name: 'Vargas', abbreviation: 'X' },
      { name: 'Delta Amacuro', abbreviation: 'Y' },
      { name: 'Amazonas', abbreviation: 'Z' },
      { name: 'Dependencias Federales', abbreviation: 'W' },
      { name: 'Distrito Capital', abbreviation: 'A' },
    ],
  },
  VNM: {
    regions: [
      { name: 'Lai Châu', abbreviation: '01' },
      { name: 'Lào Cai', abbreviation: '02' },
      { name: 'Hà Giang', abbreviation: '03' },
      { name: 'Cao Bằng', abbreviation: '04' },
      { name: 'Sơn La', abbreviation: '05' },
      { name: 'Yên Bái', abbreviation: '06' },
      { name: 'Tuyên Quang', abbreviation: '07' },
      { name: 'Lạng Sơn', abbreviation: '09' },
      { name: 'Quảng Ninh', abbreviation: '13' },
      { name: 'Hòa Bình', abbreviation: '14' },
      { name: 'Ninh Bình', abbreviation: '18' },
      { name: 'Thái Bình', abbreviation: '20' },
      { name: 'Thanh Hóa', abbreviation: '21' },
      { name: 'Nghệ An', abbreviation: '22' },
      { name: 'Hà Tĩnh', abbreviation: '23' },
      { name: 'Quảng Bình', abbreviation: '24' },
      { name: 'Quảng Trị', abbreviation: '25' },
      { name: 'Thừa Thiên-Huế', abbreviation: '26' },
      { name: 'Quảng Nam', abbreviation: '27' },
      { name: 'Kon Tum', abbreviation: '28' },
      { name: 'Quảng Ngãi', abbreviation: '29' },
      { name: 'Gia Lai', abbreviation: '30' },
      { name: 'Bình Định', abbreviation: '31' },
      { name: 'Phú Yên', abbreviation: '32' },
      { name: 'Đắk Lắk', abbreviation: '33' },
      { name: 'Khánh Hòa', abbreviation: '34' },
      { name: 'Lâm Đồng', abbreviation: '35' },
      { name: 'Ninh Thuận', abbreviation: '36' },
      { name: 'Tây Ninh', abbreviation: '37' },
      { name: 'Đồng Nai', abbreviation: '39' },
      { name: 'Bình Thuận', abbreviation: '40' },
      { name: 'Long An', abbreviation: '41' },
      { name: 'Bà Rịa - Vũng Tàu', abbreviation: '43' },
      { name: 'An Giang', abbreviation: '44' },
      { name: 'Đồng Tháp', abbreviation: '45' },
      { name: 'Tiền Giang', abbreviation: '46' },
      { name: 'Kiến Giang', abbreviation: '47' },
      { name: 'Vĩnh Long', abbreviation: '49' },
      { name: 'Bến Tre', abbreviation: '50' },
      { name: 'Trà Vinh', abbreviation: '51' },
      { name: 'Sóc Trăng', abbreviation: '52' },
      { name: 'Bắc Kạn', abbreviation: '53' },
      { name: 'Bắc Giang', abbreviation: '54' },
      { name: 'Bạc Liêu', abbreviation: '55' },
      { name: 'Bắc Ninh', abbreviation: '56' },
      { name: 'Bình Dương', abbreviation: '57' },
      { name: 'Bình Phước', abbreviation: '58' },
      { name: 'Cà Mau', abbreviation: '59' },
      { name: 'Hải Dương', abbreviation: '61' },
      { name: 'Hà Nam', abbreviation: '63' },
      { name: 'Hưng Yên', abbreviation: '66' },
      { name: 'Nam Định', abbreviation: '67' },
      { name: 'Phú Thọ', abbreviation: '68' },
      { name: 'Thái Nguyên', abbreviation: '69' },
      { name: 'Vĩnh Phúc', abbreviation: '70' },
      { name: 'Điện Biên', abbreviation: '71' },
      { name: 'Đắk Nông', abbreviation: '72' },
      { name: 'Hậu Giang', abbreviation: '73' },
      { name: 'Can Tho', abbreviation: 'CT' },
      { name: 'Da Nang', abbreviation: 'DN' },
      { name: 'Ha Noi', abbreviation: 'HN' },
      { name: 'Hai Phong', abbreviation: 'HP' },
      { name: 'Ho Chi Minh', abbreviation: 'SG' },
    ],
  },
  VUT: {
    regions: [
      { name: 'Malampa', abbreviation: 'MAP' },
      { name: 'Pénama', abbreviation: 'PAM' },
      { name: 'Sanma', abbreviation: 'SAM' },
      { name: 'Shéfa', abbreviation: 'SEE' },
      { name: 'Taféa', abbreviation: 'TAE' },
      { name: 'Torba', abbreviation: 'TOB' },
    ],
  },
  WLF: {
    regions: [
      { name: 'Alo', abbreviation: 'AL' },
      { name: 'Sigave', abbreviation: 'SG' },
      { name: 'Uvea', abbreviation: 'UV' },
    ],
  },
  WSM: {
    regions: [
      { name: "A'ana", abbreviation: 'AA' },
      { name: 'Aiga-i-le-Tai', abbreviation: 'AL' },
      { name: 'Atua', abbreviation: 'AT' },
      { name: "Fa'asaleleaga", abbreviation: 'FA' },
      { name: "Gaga'emauga", abbreviation: 'GE' },
      { name: 'Gagaifomauga', abbreviation: 'GI' },
      { name: 'Palauli', abbreviation: 'PA' },
      { name: "Satupa'itea", abbreviation: 'SA' },
      { name: 'Tuamasaga', abbreviation: 'TU' },
      { name: "Va'a-o-Fonoti", abbreviation: 'VF' },
      { name: 'Vaisigano', abbreviation: 'VS' },
    ],
  },
  YEM: {
    regions: [
      { name: 'Amānat al ‘Āşimah [city]', abbreviation: 'SA' },
      { name: 'Abyan', abbreviation: 'AB' },
      { name: '‘Adan', abbreviation: 'AD' },
      { name: '‘Amrān', abbreviation: 'AM' },
      { name: 'Al Bayḑā’', abbreviation: 'BA' },
      { name: 'Aḑ Ḑāli‘', abbreviation: 'DA' },
      { name: 'Dhamār', abbreviation: 'DH' },
      { name: 'Ḩaḑramawt', abbreviation: 'HD' },
      { name: 'Ḩajjah', abbreviation: 'HJ' },
      { name: 'Al Ḩudaydah', abbreviation: 'HU' },
      { name: 'Ibb', abbreviation: 'IB' },
      { name: 'Al Jawf', abbreviation: 'JA' },
      { name: 'Laḩij', abbreviation: 'LA' },
      { name: 'Ma’rib', abbreviation: 'MA' },
      { name: 'Al Mahrah', abbreviation: 'MR' },
      { name: 'Al Maḩwīt', abbreviation: 'MW' },
      { name: 'Raymah', abbreviation: 'RA' },
      { name: 'Şāʻdah', abbreviation: 'SD' },
      { name: 'Shabwah', abbreviation: 'SH' },
      { name: 'Şanʻā’', abbreviation: 'SN' },
      { name: 'Arkhabīl Suquţrá', abbreviation: 'SU' },
      { name: 'Tāʻizz', abbreviation: 'TA' },
    ],
  },
  ZAF: {
    regions: [
      { name: 'Oos-Kaap', abbreviation: 'EC' },
      { name: 'Free State', abbreviation: 'FS' },
      { name: 'Gauteng', abbreviation: 'GP' },
      { name: 'Kwazulu-Natal', abbreviation: 'KZN' },
      { name: 'Limpopo', abbreviation: 'LP' },
      { name: 'Mpumalanga', abbreviation: 'MP' },
      { name: 'Northern Cape', abbreviation: 'NC' },
      { name: 'North-West', abbreviation: 'NW' },
      { name: 'Western Cape', abbreviation: 'WC' },
    ],
  },
  ZMB: {
    regions: [
      { name: 'Western', abbreviation: '01' },
      { name: 'Central', abbreviation: '02' },
      { name: 'Eastern', abbreviation: '03' },
      { name: 'Luapula', abbreviation: '04' },
      { name: 'Northern', abbreviation: '05' },
      { name: 'North-Western', abbreviation: '06' },
      { name: 'Southern', abbreviation: '07' },
      { name: 'Copperbelt', abbreviation: '08' },
      { name: 'Lusaka', abbreviation: '09' },
      { name: 'Muchinga', abbreviation: '10' },
    ],
  },
  ZWE: {
    regions: [
      { name: 'Bulawayo', abbreviation: 'BU' },
      { name: 'Harare', abbreviation: 'HA' },
      { name: 'Manicaland', abbreviation: 'MA' },
      { name: 'Mashonaland Central', abbreviation: 'MC' },
      { name: 'Mashonaland East', abbreviation: 'ME' },
      { name: 'Midlands', abbreviation: 'MI' },
      { name: 'Matabeleland North', abbreviation: 'MN' },
      { name: 'Matabeleland South', abbreviation: 'MS' },
      { name: 'Masvingo', abbreviation: 'MV' },
      { name: 'Mashonaland West', abbreviation: 'MW' },
    ],
  },
};

// Originally adopted from https://stackoverflow.com/questions/578406/what-is-the-ultimate-postal-code-and-zip-regex
export const COUNTRY_POSTAL_CODE_REGEX = {
  AFG: /[0-9]{4}/,
  ALA: /22\d{3}/,
  AND: /AD\d{3}/,
  ARG: /([A-HJ-NP-Z])?\d{4}([A-Z]{3})?/,
  ARM: /(37)?\d{4}/,
  ASM: /96799/,
  AUS: /\d{4}/,
  AUT: /\d{4}/,
  AZE: /\d{4}/,
  BEL: /\d{4}/,
  BGD: /\d{4}/,
  BGR: /\d{4}/,
  BHR: /((1[0-2]|[2-9])\d{2})?/,
  BIH: /\d{5}/,
  BLR: /\d{6}/,
  BMU: /[A-Z]{2}[ ]?[A-Z0-9]{2}/,
  BRA: /\d{5}[-]?\d{3}/,
  BRB: /(BB\d{5})?/,
  BRN: /[A-Z]{2}[ ]?\d{4}/,
  CAN: /[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d/,
  CCK: /6799/,
  CHE: /\d{4}/,
  CHL: /\d{7}/,
  CHN: /\d{6}/,
  COK: /\d{4}/,
  CPV: /\d{4}/,
  CRI: /\d{4,5}|\d{3}-\d{4}/,
  CXR: /6798/,
  CYP: /\d{4}/,
  CZE: /\d{3}[ ]?\d{2}/,
  DEU: /\d{5}/,
  DNK: /\d{4}/,
  DOM: /\d{5}/,
  DZA: /\d{5}/,
  ECU: /([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?/,
  EGY: /\d{5}/,
  ESP: /\d{5}/,
  EST: /\d{5}/,
  ETH: /\d{4}/,
  FIN: /\d{5}/,
  FLK: /FIQQ 1ZZ/,
  FRA: /^((0[1-9])|([1-8][0-9])|(9[0-8])|(2A)|(2B))[0-9]{3}$/,
  FRO: /\d{3}/,
  FSM: /(9694[1-4])([ -]\d{4})?/,
  GBR: /GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}/,
  GEO: /\d{4}/,
  GGY: /GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}/,
  GIN: /\d{3}/,
  GLP: /9[78][01]\d{2}/,
  GNB: /\d{4}/,
  GRC: /\d{3}[ ]?\d{2}/,
  GRL: /39\d{2}/,
  GTM: /\d{5}/,
  GUF: /9[78]3\d{2}/,
  GUM: /969[123]\d([ -]\d{4})?/,
  HMD: /\d{4}/,
  HND: /(?:\d{5})?/,
  HRV: /\d{5}/,
  HTI: /\d{4}/,
  HUN: /\d{4}/,
  IDN: /\d{5}/,
  IMN: /IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}/,
  IND: /^(?!0{1})\d{6}$/,
  IOT: /BBND 1ZZ/,
  IRQ: /\d{5}/,
  ISL: /\d{3}/,
  ISR: /\d{5}/,
  ITA: /\d{5}/,
  JEY: /JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}/,
  JOR: /\d{5}/,
  JPN: /\d{3}-\d{4}/,
  KAZ: /\d{6}/,
  KEN: /\d{5}/,
  KGZ: /\d{6}/,
  KHM: /\d{5}/,
  KOR: /\d{3}[-]\d{3}/,
  KWT: /\d{5}/,
  LAO: /\d{5}/,
  LBN: /(\d{4}([ ]?\d{4})?)?/,
  LBR: /\d{4}/,
  LIE: /(948[5-9])|(949[0-7])/,
  LKA: /\d{5}/,
  LSO: /\d{3}/,
  LTU: /\d{5}/,
  LUX: /\d{4}/,
  LVA: /\d{4}/,
  MAR: /\d{5}/,
  MCO: /980\d{2}/,
  MDA: /\d{4}/,
  MDG: /\d{3}/,
  MDV: /\d{5}/,
  MEX: /\d{5}/,
  MHL: /969[67]\d([ -]\d{4})?/,
  MKD: /\d{4}/,
  MLT: /[A-Z]{3}[ ]?\d{2,4}/,
  MNE: /8\d{4}/,
  MNG: /\d{6}/,
  MNP: /9695[012]([ -]\d{4})?/,
  MTQ: /9[78]2\d{2}/,
  MUS: /(\d{3}[A-Z]{2}\d{3})?/,
  MYS: /\d{5}/,
  MYT: /976\d{2}/,
  NCL: /988\d{2}/,
  NER: /\d{4}/,
  NFK: /2899/,
  NGA: /(\d{6})?/,
  NIC: /((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?/,
  NLD: /\d{4}[ ]?[A-Z]{2}/,
  NOR: /\d{4}/,
  NPL: /\d{5}/,
  NZL: /\d{4}/,
  OMN: /(PC )?\d{3}/,
  PAK: /\d{5}/,
  PCN: /PCRN 1ZZ/,
  PFY: /987\d{2}/,
  PHL: /\d{4}/,
  PLW: /96940/,
  PNG: /\d{3}/,
  POL: /\d{2}-\d{3}/,
  PRI: /00[679]\d{2}([ -]\d{4})?/,
  PRT: /\d{4}([-]\d{3})?/,
  PRY: /\d{4}/,
  REU: /9[78]4\d{2}/,
  ROU: /\d{6}/,
  RUS: /\d{6}/,
  SAU: /\d{5}/,
  SEN: /\d{5}/,
  SGP: /\d{6}/,
  SGS: /SIQQ 1ZZ/,
  SHN: /(ASCN|STHL) 1ZZ/,
  SJM: /\d{4}/,
  SMR: /4789\d/,
  SOM: /\d{5}/,
  SPM: /9[78]5\d{2}/,
  SRB: /\d{6}/,
  SVK: /\d{3}[ ]?\d{2}/,
  SVN: /\d{4}/,
  SWE: /\d{3}[ ]?\d{2}/,
  SWZ: /[HLMS]\d{3}/,
  TCA: /TKCA 1ZZ/,
  THA: /\d{5}/,
  TJK: /\d{6}/,
  TKM: /\d{6}/,
  TUN: /\d{4}/,
  TUR: /\d{5}/,
  TWN: /\d{3}(\d{2})?/,
  UKR: /\d{5}/,
  URY: /\d{5}/,
  USA: /^\d{5}([ -]\d{4})?$/,
  UZB: /\d{6}/,
  VAT: /00120/,
  VEN: /\d{4}/,
  VIR: /008(([0-4]\d)|(5[01]))([ -]\d{4})?/,
  WLF: /986\d{2}/,
  ZAF: /\d{4}/,
  ZMB: /\d{5}/,
};

export const DEFAULT_REGION_LABEL = 'State/Province';
